/* eslint-disable max-len */
import React from 'react';

class Attribution extends React.Component {
  render() {
    return (
      <div className="aa-attribution-content">
        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product includes the following third-party software/licensing:</strong></p>
          <p><strong>MIT License</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>@babel/code-frame@7.0.0-beta.36</strong>
              {' '}
              https://babeljs.io/
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>@babel/helper-function-name@7.0.0-beta.36</strong>
              {' '}
              https://babeljs.io/
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>@babel/helper-get-function-arity@7.0.0-beta.36</strong>
              {' '}
              https://babeljs.io/
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>@babel/template@7.0.0-beta.36</strong>
              {' '}
              https://babeljs.io/
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>@babel/traverse@7.0.0-beta.36</strong>
              {' '}
              https://babeljs.io/
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>@babel/types@7.0.0-beta.36</strong>
              {' '}
              https://babeljs.io/
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>@types/react@16.0.34</strong>
              {' '}
              https://www.github.com/DefinitelyTyped/DefinitelyTyped
            </li>

            <li>
              <strong>JSONStream@1.3.2</strong>
              {' '}
              http://bit.ly/dominictarr
              <br />
              Copyright (c) 2011 Dominic Tarr
            </li>

            <li>
              <strong>accepts@1.3.3 accepts@1.3.4</strong>
              {' '}
              https://github.com/jshttp/accepts
              <br />
              Copyright (c) 2014 Jonathan Ong &lt;me@jongleberry.com&gt;
              <br />
              Copyright (c) 2015 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>acorn-dynamic-import@2.0.2</strong>
              {' '}
              https://github.com/kesne/acorn-dynamic-import
              <br />
              Copyright (c) 2016 Jordan Gensler
            </li>

            <li>
              <strong>acorn-jsx@3.0.1 acorn-jsx@4.1.0</strong>
              {' '}
              https://github.com/RReverser/acorn-jsx
              <br />
              Copyright (C) 2012-2017 by Ingvar Stepanyan
            </li>

            <li>
              <strong>acorn@3.3.0 acorn@4.0.13 acorn@5.3.0</strong>
              {' '}
              https://github.com/ternjs/acorn
              <br />
              Copyright (C) 2012-2018 by various contributors (see https://github.com/ternjs/acorn)
            </li>

            <li>
              <strong>addressparser@1.0.1</strong>
              {' '}
              https://github.com/andris9/addressparser
              <br />
              Copyright (c) 2014-2016 Andris Reinman
            </li>

            <li>
              <strong>after@0.8.2</strong>
              {' '}
              https://github.com/Raynos/after
              <br />
              Copyright (c) 2011 Raynos
            </li>

            <li>
              <strong>agent-base@2.1.1</strong>
              {' '}
              http://n8.io/
              <br />
              Copyright (c) 2013 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
            </li>

            <li>
              <strong>ajv-keywords@1.5.1  ajv-keywords@2.1.1 ajv-keywords@3.0.0</strong>
              {' '}
              https://github.com/epoberezkin/ajv-keywords
              <br />
              Copyright (c) 2016 Evgeny Poberezkin
            </li>

            <li>
              <strong>ajv@4.11.8 ajv@5.5.2 ajv@6.0.1</strong>
              {' '}
              https://github.com/epoberezkin/ajv
              <br />
              Copyright (c) 2015-2017 Evgeny Poberezkin
            </li>

            <li>
              <strong>align-text@0.1.4</strong>
              {' '}
              https://github.com/jonschlinkert/align-text
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert
            </li>

            <li>
              <strong>alphanum-sort@1.0.2</strong>
              {' '}
              https://github.com/TrySound/alphanum-sort
              <br />
              Copyright (c) Bogdan Chadkin &lt;trysound@yandex.ru&gt;
            </li>

            <li>
              <strong>alt@0.18.6</strong>
              {' '}
              https://github.com/goatslacker/alt
              <br />
              Copyright (c) 2018 Josh Perez, http://www.goatslacker.com
            </li>

            <li>
              <strong>amdefine@1.0.1</strong>
              {' '}
              https://github.com/jrburke/amdefine
              <br />
              Copyright (c) 2011-2016, The Dojo Foundation
            </li>

            <li>
              <strong>ansi-cyan@0.1.1</strong>
              {' '}
              https://github.com/jonschlinkert/ansi-cyan
              <br />
              Copyright (c) Jon Schlinkert
            </li>

            <li>
              <strong>ansi-escapes@1.4.0 ansi-escapes@3.0.0</strong>
              {' '}
              https://github.com/sindresorhus/ansi-escapes
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>ansi-gray@0.1.1</strong>
              {' '}
              https://github.com/jonschlinkert/ansi-gray
              <br />
              Copyright (c) Jon Schlinkert
            </li>

            <li>
              <strong>ansi-red@0.1.1</strong>
              {' '}
              https://github.com/jonschlinkert/ansi-red
              <br />
              Copyright (c) Jon Schlinkert
            </li>

            <li>
              <strong>ansi-regex@2.1.1 ansi-regex@3.0.0</strong>
              {' '}
              https://github.com/chalk/ansi-regex
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>ansi-styles@2.2.1 ansi-styles@3.2.0</strong>
              {' '}
              https://github.com/chalk/ansi-styles
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>ansi-wrap@0.1.0</strong>
              {' '}
              https://github.com/jonschlinkert/ansi-wrap
              <br />
              Copyright (c) 2015, Jon Schlinkert
            </li>

            <li>
              <strong>archy@1.0.0</strong>
              {' '}
              http://substack.net
            </li>

            <li>
              <strong>argparse@1.0.9</strong>
              {' '}
              https://github.com/nodeca/argparse
              <br />
              Copyright (C) 2012 by Vitaly Puzrin
            </li>

            <li>
              <strong>arr-diff@1.1.0  arr-diff@2.0.0 arr-diff@4.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/arr-diff
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert
            </li>

            <li>
              <strong>arr-flatten@1.1.0</strong>
              {' '}
              https://github.com/jonschlinkert/arr-flatten
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert
            </li>

            <li>
              <strong>arr-union@2.1.0</strong>
              {' '}
              https://github.com/jonschlinkert/arr-union
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert
            </li>

            <li>
              <strong>arr-union@3.1.0</strong>
              {' '}
              https://github.com/jonschlinkert/arr-union
              <br />
              Copyright (c) 2014-2016, Jon Schlinkert
            </li>

            <li>
              <strong>array-differ@1.0.0 array-differ@2.0.3</strong>
              {' '}
              https://github.com/sindresorhus/array-differ
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>array-each@1.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/array-each
              <br />
              Copyright (c) 2015, 2017, Jon Schlinkert
            </li>

            <li>
              <strong>array-filter@0.0.1</strong>
              {' '}
              https://github.com/juliangruber/array-filter
              <br />
              Copyright (c) 2013 Julian Gruber &lt;julian@juliangruber.com&gt;
            </li>

            <li>
              <strong>array-find-index@1.0.2</strong>
              {' '}
              https://github.com/sindresorhus/array-find-index
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>array-flatten@1.1.1 array-flatten@2.1.1</strong>
              {' '}
              https://github.com/blakeembrey/array-flatten
              <br />
              Copyright (c) 2014 Blake Embrey (hello@blakeembrey.com)
            </li>

            <li>
              <strong>array-includes@3.0.3</strong>
              {' '}
              https://github.com/ljharb/array-includes
              <br />
              Copyright (C) 2015 Jordan Harband
            </li>

            <li>
              <strong>array-index@1.0.0</strong>
              {' '}
              https://github.com/TooTallNate/array-index
              <br />
              Copyright (c) 2012 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
            </li>

            <li>
              <strong>array-map@0.0.0</strong>
              {' '}
              https://github.com/substack/array-map
            </li>

            <li>
              <strong>array-reduce@0.0.0</strong>
              {' '}
              https://github.com/substack/array-reduce
            </li>

            <li>
              <strong>array-slice@0.2.3</strong>
              {' '}
              https://github.com/jonschlinkert/array-slice
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert.
              <br />
              Copyright (c) 2012-2015, The Dojo Foundation.copyright (c) 2009-2015, Jeremy Ashkenas
            </li>

            <li>
              <strong>array-slice@1.1.0</strong>
              {' '}
              https://github.com/jonschlinkert/array-slice
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert
            </li>

            <li>
              <strong>array-union@1.0.2</strong>
              {' '}
              https://github.com/sindresorhus/array-union
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>array-uniq@1.0.3</strong>
              {' '}
              https://github.com/sindresorhus/array-uniq
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>array-unique@0.2.1 array-unique@0.3.2</strong>
              {' '}
              https://github.com/jonschlinkert/array-unique
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert.
            </li>

            <li>
              <strong>arraybuffer.slice@0.0.7</strong>
              {' '}
              https://github.com/rase-/arraybuffer.slice
              <br />
              Copyright (C) 2013 Rase-
            </li>

            <li>
              <strong>arrify@1.0.1</strong>
              {' '}
              https://github.com/sindresorhus/arrify
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>asap@2.0.6</strong>
              {' '}
              https://github.com/kriskowal/asap
              <br />
              Copyright 2009–2014 Contributors. All rights reserved.
            </li>

            <li>
              <strong>asn1.js@4.9.2</strong>
              {' '}
              https://github.com/indutny/asn1.js
              <br />
              Copyright Fedor Indutny, 2013
            </li>

            <li>
              <strong>asn1.js@5.0.0</strong>
              {' '}
              https://github.com/indutny/asn1.js
              <br />
              Copyright Fedor Indutny, 2017
            </li>

            <li>
              <strong>asn1@0.2.3</strong>
              {' '}
              https://github.com/mcavage/node-asn1
              <br />
              Copyright (c) 2011 Mark Cavage, All rights reserved.
            </li>

            <li>
              <strong>assert-plus@0.2.0</strong>
              {' '}
              https://github.com/mcavage/node-assert-plus
              <br />
              Copyright (c) 2012 Mark Cavage
            </li>

            <li>
              <strong>assert-plus@1.0.0</strong>
              {' '}
              https://github.com/mcavage/node-assert-plus
              <br />
              Copyright (c) 2012 Mark Cavage
            </li>

            <li>
              <strong>assert@1.4.1</strong>
              {' '}
              https://github.com/defunctzombie/commonjs-assert
              <br />
              Copyright Joyent, Inc. and other Node contributors. All rights reserved.
            </li>

            <li>
              <strong>assign-symbols@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/assign-symbols
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>ast-types@0.10.1</strong>
              {' '}
              https://github.com/benjamn/ast-types
              <br />
              Copyright (c) 2013 Ben Newman &lt;bn@cs.stanford.edu&gt;
            </li>

            <li>
              <strong>astw@2.2.0</strong>
              {' '}
              https://github.com/substack/astw"}
            </li>

            <li>
              <strong>async-each@1.0.1</strong>
              {' '}
              https://github.com/paulmillr/async-each
              <br />
              Copyright (c) 2016 Paul Miller (paulmillr.com)
            </li>

            <li>
              <strong>async-foreach@0.1.3</strong>
              {' '}
              https://github.com/cowboy/javascript-sync-async-foreach
              <br />
              Copyright (c) 2012 \"Cowboy\" Ben Alman
            </li>

            <li>
              <strong>async-limiter@1.0.0</strong>
              {' '}
              https://github.com/strml/async-limiter
              <br />
              Copyright (c) 2017 Samuel Reed &lt;samuel.trace.reed@gmail.com&gt;
            </li>

            <li>
              <strong>async@0.9.2 async@1.5.2 async@2.1.5 async@2.6.0</strong>
              {' '}
              https://github.com/caolan/async
              <br />
              Copyright (c) 2010-2014 Caolan McMahon
            </li>

            <li>
              <strong>asynckit@0.4.0</strong>
              {' '}
              https://github.com/alexindigo/asynckit
              <br />
              Copyright (c) 2016 Alex Indigo
            </li>

            <li>
              <strong>atob@2.0.3</strong>
              {' '}
              https://github.com/coolaj86/node-browser-compat/atob
              <br />
              Copyright (c) 2015 AJ ONeal
            </li>

            <li>
              <strong>autoprefixer@6.7.7 autoprefixer@7.2.5</strong>
              {' '}
              https://github.com/postcss/autoprefixer
              <br />
              Copyright 2013 Andrey Sitnik &lt;andrey@sitnik.ru&gt;
            </li>

            <li>
              <strong>aws4@1.6.0</strong>
              {' '}
              https://github.com/mhart/aws4
              <br />
              Copyright 2013 Michael Hart &lt;michael.hart.au@gmail.com&gt;
            </li>

            <li>
              <strong>axios@0.15.3 axios@0.17.1</strong>
              {' '}
              https://github.com/mzabriskie/axios
              <br />
              Copyright (c) 2014 Matt Zabriskie
            </li>

            <li>
              <strong>babel-code-frame@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-code-frame
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-core@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-core
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-eslint@8.2.1</strong>
              {' '}
              https://github.com/babel/babel-eslint
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-generator@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-generator
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-helper-builder-binary-assignment-operator-visitor@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-helper-builder-binary-assignment-operator-visitor
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-helper-builder-react-jsx@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-helper-builder-react-jsx
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-helper-call-delegate@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-helper-call-delegate
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-helper-define-map@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-helper-define-map
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-helper-explode-assignable-expression@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-helper-explode-assignable-expression
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-helper-function-name@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-helper-function-name
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-helper-get-function-arity@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-helper-get-function-arity
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-helper-hoist-variables@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-helper-hoist-variables
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-helper-optimise-call-expression@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-helper-optimise-call-expression
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-helper-regex@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-helper-regex
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-helper-remap-async-to-generator@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-helper-remap-async-to-generator
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-helper-replace-supers@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-helper-replace-supers
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-helpers@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-helpers
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-loader@7.1.2</strong>
              {' '}
              https://github.com/babel/babel-loader
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-messages@6.23.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-messages
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-check-es2015-constants@6.22.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-check-es2015-constants
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-syntax-async-functions@6.13.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-async-functions
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-syntax-class-properties@6.13.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-class-properties
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-syntax-decorators@6.13.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-decorators
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-syntax-exponentiation-operator@6.13.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-exponentation-operator
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-syntax-export-extensions@6.13.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-export-extensions
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-syntax-flow@6.18.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-flow
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-syntax-jsx@6.18.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-jsx
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-syntax-object-rest-spread@6.13.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-object-rest-spread
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-syntax-trailing-function-commas@6.22.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-syntax-trailing-function-commas
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-async-to-generator@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-async-to-generator
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-class-properties@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-class-properties
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-decorators-legacy@1.3.4</strong>
              {' '}
              https://github.com/loganfsmyth/babel-plugin-transform-decorators-legacy
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-arrow-functions@6.22.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-arrow-functions
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-block-scoped-functions@6.22.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-block-scoped-functions
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-block-scoping@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-block-scoping
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-classes@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-classes
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-computed-properties@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-computed-properties
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-destructuring@6.23.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-destructuring
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-duplicate-keys@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-duplicate-keys
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-for-of@6.23.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-for-of
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-function-name@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-function-name
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-literals@6.22.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-literals
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-modules-amd@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-modules-amd
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-modules-commonjs@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-modules-commonjs
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-modules-systemjs@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-modules-systemjs
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-modules-umd@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-modules-umd
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-object-super@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-object-super
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-parameters@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-parameters
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-shorthand-properties@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-shorthand-properties
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-spread@6.22.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-spread
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-sticky-regex@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-sticky-regex
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-template-literals@6.22.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-template-literals
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-typeof-symbol@6.23.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-typeof-symbol
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-es2015-unicode-regex@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-es2015-unicode-regex
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-exponentiation-operator@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-exponentiation-operator
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-export-extensions@6.22.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-export-extensions
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-flow-strip-types@6.22.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-flow-strip-types
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-object-rest-spread@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-object-rest-spread
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-react-display-name@6.25.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-react-display-name
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-react-jsx-self@6.22.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-react-jsx-self
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-react-jsx-source@6.22.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-react-jsx-source
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-react-jsx@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-react-jsx
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-regenerator@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-regenerator
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-plugin-transform-strict-mode@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-plugin-transform-strict-mode
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-polyfill@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-polyfill
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-preset-es2015@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-preset-es2015
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-preset-es2016@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-preset-es2016
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-preset-es2017@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-preset-es2017
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-preset-flow@6.23.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-preset-flow
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-preset-latest@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-preset-latest
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-preset-react@6.24.1</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-preset-react
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-register@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-register
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-runtime@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-runtime
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-template@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-template
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-traverse@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-traverse
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel-types@6.26.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel-types
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babel@6.23.0</strong>
              {' '}
              https://github.com/babel/babel/tree/master/packages/babel
              <br />
              Copyright (c) 2014-2018 Sebastian McKenzie &lt;sebmck@gmail.com&gt;
            </li>

            <li>
              <strong>babelify@8.0.0</strong>
              {' '}
              https://github.com/babel/babelify
              <br />
              Copyright (c) 2015 Sebastian McKenzie
            </li>

            <li>
              <strong>babylon@6.18.0 babylon@7.0.0-beta.36</strong>
              {' '}
              https://github.com/babel/babylon
              <br />
              Copyright (C) 2012-2014 by various contributors (see https://github.com/babel/babylon/blob/master/AUTHORS)
            </li>

            <li>
              <strong>backo2@1.0.2</strong>
              {' '}
              https://github.com/mokesmokes/backo
            </li>

            <li>
              <strong>balanced-match@0.4.2</strong>
              {' '}
              https://github.com/juliangruber/balanced-match
              <br />
              Copyright (c) 2013 Julian Gruber &lt;julian@juliangruber.com&gt;
            </li>

            <li>
              <strong>balanced-match@1.0.0</strong>
              {' '}
              https://github.com/juliangruber/balanced-match
              <br />
              Copyright (c) 2013 Julian Gruber &lt;julian@juliangruber.com&gt;
            </li>

            <li>
              <strong>base64-arraybuffer@0.1.5</strong>
              {' '}
              https://github.com/niklasvh/base64-arraybuffer
              <br />
              Copyright (c) 2012 Niklas von Hertzen
            </li>

            <li>
              <strong>base64-js@1.2.1</strong>
              {' '}
              https://github.com/beatgammit/base64-js
              <br />
              Copyright (c) 2014
            </li>

            <li>
              <strong>base64id@1.0.0</strong>
              {' '}
              https://github.com/faeldt/base64id
              <br />
              Copyright (c) 2012-2016 Kristian Faeldt &lt;faeldt_kristian@cyberagent.co.jp&gt;
            </li>

            <li>
              <strong>base@0.11.2</strong>
              {' '}
              https://github.com/node-base/base
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>batch@0.6.1</strong>
              {' '}
              https://github.com/visionmedia/batch
              <br />
              Copyright (c) 2013 TJ Holowaychuk &lt;tj@vision-media.ca&lt;
            </li>

            <li>
              <strong>beeper@1.1.1</strong>
              {' '}
              https://github.com/sindresorhus/beeper
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>better-assert@1.0.2</strong>
              {' '}
              https://github.com/visionmedia/better-assert
              <br />
              Copyright (c) 2012 TJ Holowaychuk &lt;tj@vision-media.ca&gt;
            </li>

            <li>
              <strong>big.js@3.2.0</strong>
              {' '}
              https://github.com/MikeMcl/big.js
              <br />
              Copyright (c) 2012 Michael Mclaughlin
            </li>

            <li>
              <strong>big.js@5.0.3</strong>
              {' '}
              https://github.com/MikeMcl/big.js
              <br />
              Copyright (c) 2017 Michael Mclaughlin
            </li>

            <li>
              <strong>binary-extensions@1.11.0</strong>
              {' '}
              https://github.com/sindresorhus/binary-extensions
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>bl@1.1.2</strong>
              {' '}
              https://github.com/rvagg/bl
              <br />
              Copyright (c) 2014 bl contributors
              <br />
              bl contributors listed at &lt;https://github.com/rvagg/bl#contributors&gt;
            </li>

            <li>
              <strong>bl@1.2.1</strong>
              {' '}
              https://github.com/rvagg/bl
              <br />
              Copyright (c) 2013-2016 bl contributors
              <br />
              bl contributors listed at &lt;https://github.com/rvagg/bl#contributors&gt;
            </li>

            <li>
              <strong>blob@0.0.4</strong>
              {' '}
              https://github.com/rase-/blob
            </li>

            <li>
              <strong>bluebird@3.5.1</strong>
              {' '}
              https://github.com/petkaantonov/bluebird
              <br />
              Copyright (c) 2013-2017 Petka Antonov
            </li>

            <li>
              <strong>bn.js@4.11.8</strong>
              {' '}
              https://github.com/indutny/bn.js
              <br />
              Copyright Fedor Indutny, 2015.
            </li>

            <li>
              <strong>body-parser@1.18.2</strong>
              {' '}
              https://github.com/expressjs/body-parser
              <br />
              Copyright (c) 2014 Jonathan Ong &lt;me@jongleberry.com&gt;
              <br />
              Copyright (c) 2014-2015 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>bonjour@3.5.0</strong>
              {' '}
              https://github.com/watson/bonjour
              <br />
              Copyright (c) 2015-2016 Thomas Watson Steen
            </li>

            <li>
              <strong>bootstrap-sass@3.3.7</strong>
              {' '}
              https://github.com/twbs/bootstrap-sass
              <br />
              Copyright (c) 2011-2016 Twitter, Inc
              <br />
              Copyright (c) 2011-2016 The Bootstrap Authors
            </li>

            <li>
              <strong>brace-expansion@1.1.7 brace-expansion@1.1.8</strong>
              {' '}
              https://github.com/juliangruber/brace-expansion
              <br />
              Copyright (c) 2013 Julian Gruber &lt;julian@juliangruber.com&gt;
            </li>

            <li>
              <strong>braces@0.1.5 braces@1.8.5 braces@2.3.0</strong>
              {' '}
              https://github.com/jonschlinkert/braces
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert
            </li>

            <li>
              <strong>brorand@1.1.0</strong>
              {' '}
              https://github.com/indutny/brorand
              <br />
              Copyright Fedor Indutny, 2014
            </li>

            <li>
              <strong>browser-pack@6.0.2</strong>
              {' '}
              https://github.com/substack/browser-pack
            </li>

            <li>
              <strong>browser-resolve@1.11.2</strong>
              {' '}
              https://github.com/shtylman/node-browser-resolve
              <br />
              Copyright (c) 2013-2015 Roman Shtylman &lt;shtylman@gmail.com&gt;
            </li>

            <li>
              <strong>browserify-aes@1.1.1</strong>
              {' '}
              https://github.com/crypto-browserify/browserify-aes
              <br />
              Copyright (c) 2014-2017 browserify-aes contributors
            </li>

            <li>
              <strong>browserify-cipher@1.0.0</strong>
              {' '}
              https://github.com/crypto-browserify/browserify-cipher
              <br />
              Copyright (c) 2014-2017 Calvin Metcalf & contributors
            </li>

            <li>
              <strong>browserify-des@1.0.0</strong>
              {' '}
              https://github.com/crypto-browserify/browserify-des
              <br />
              Copyright (c) 2014-2017 Calvin Metcalf, Fedor Indutny & contributors
            </li>

            <li>
              <strong>browserify-rsa@4.0.1</strong>
              {' '}
              https://github.com/crypto-browserify/browserify-rsa
              <br />
              Copyright (c) 2014-2015 Calvin Metcalf & contributors
            </li>

            <li>
              <strong>browserify-zlib@0.2.0</strong>
              {' '}
              https://github.com/devongovett/browserify-zlib
              <br />
              Copyright (c) 2014-2015 Devon Govett &lt;devongovett@gmail.com&gt;
            </li>

            <li>
              <strong>browserify@14.5.0</strong>
              {' '}
              https://github.com/substack/node-browserify
            </li>

            <li>
              <strong>browserslist@1.7.7 browserslist@2.11.1</strong>
              {' '}
              https://github.com/ai/browserslist
              <br />
              Copyright 2014 Andrey Sitnik &lt;andrey@sitnik.ru&gt;
            </li>

            <li>
              <strong>buffer-indexof@1.1.1</strong>
              {' '}
              https://github.com/soldair/node-buffer-indexof
              <br />
              Copyright (c) 2013 Ryan Day
            </li>

            <li>
              <strong>buffer-shims@1.0.0</strong>
              {' '}
              https://github.com/calvinmetcalf/buffer-shims"}
              <br />
              Copyright (c) 2016 Calvin Metcalf
            </li>

            <li>
              <strong>buffer-xor@1.0.3 buffer-xor@2.0.2</strong>
              {' '}
              https://github.com/crypto-browserify/buffer-xor
              <br />
              Copyright (c) 2015 Daniel Cousens
            </li>

            <li>
              <strong>buffer@4.9.1 buffer@5.0.8</strong>
              {' '}
              https://github.com/feross/buffer
              <br />
              Copyright (c) Feross Aboukhadijeh, and other contributors.
            </li>

            <li>
              <strong>buildmail@4.0.1</strong>
              {' '}
              https://github.com/andris9/buildmail
              <br />
              Copyright (c) 2014-2017 Andris Reinman
            </li>

            <li>
              <strong>builtin-modules@1.1.1</strong>
              {' '}
              https://github.com/sindresorhus/builtin-modules
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>builtin-status-codes@3.0.0</strong>
              {' '}
              https://github.com/bendrucker/builtin-status-codes
              <br />
              Copyright (c) Ben Drucker &lt;bvdrucker@gmail.com&gt; (bendrucker.me)
            </li>

            <li>
              <strong>bytes@3.0.0</strong>
              {' '}
              https://github.com/visionmedia/bytes.js
              <br />
              Copyright (c) 2012-2014 TJ Holowaychuk &lt;tj@vision-media.ca&gt;
              <br />
              Copyright (c) 2015 Jed Watson &lt;jed.watson@me.com&gt;
            </li>

            <li>
              <strong>cache-base@1.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/cache-base
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>cached-path-relative@1.0.1</strong>
              {' '}
              https://github.com/ashaffer/cached-path-relative
              <br />
              Copyright (c); 2016, Weo.io &lt;info@weo.io&gt;
            </li>

            <li>
              <strong>caller-callsite@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/caller-callsite
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>caller-path@0.1.0 caller-path@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/caller-path
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>callsite@1.0.0</strong>
              {' '}
              https://github.com/tj/callsite
              <br />
              Copyright (c) 2011, 2013 TJ Holowaychuk &lt;tj@vision-media.ca&gt;
            </li>

            <li>
              <strong>callsites@0.2.0 callsites@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/callsites
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>camelcase-keys@4.2.0 camelcase-keys@2.1.0</strong>
              {' '}
              https://github.com/sindresorhus/camelcase-keys
            </li>

            <li>
              <strong>camelcase@1.2.1 camelcase@2.1.1 camelcase@3.0.0 camelcase@4.1.0</strong>
              {' '}
              https://github.com/sindresorhus/camelcase
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>caniuse-api@1.6.1</strong>
              {' '}
              https://github.com/nyalab/caniuse-api
              <br />
              Copyright (c) 2014 Sébastien Balayn
            </li>

            <li>
              <strong>center-align@0.1.3</strong>
              {' '}
              https://github.com/jonschlinkert/center-align
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>chain-function@1.0.0</strong>
              {' '}
              https://github.com/jquense/chain-function
            </li>

            <li>
              <strong>chalk@1.1.3 chalk@2.3.0</strong>
              {' '}
              https://github.com/chalk/chalk
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>chardet@0.4.2</strong>
              {' '}
              https://github.com/runk/node-chardet
              <br />
              Copyright (C) 2017 Dmitry Shirokov
            </li>

            <li>
              <strong>chokidar@1.7.0 chokidar@2.0.0</strong>
              {' '}
              https://github.com/paulmillr/chokidar
              <br />
              Copyright (c) 2016 Paul Miller (http://paulmillr.com) & Elan Shanker
            </li>

            <li>
              <strong>cipher-base@1.0.4</strong>
              {' '}
              https://github.com/crypto-browserify/cipher-base
              <br />
              Copyright (c) 2017 crypto-browserify contributors
            </li>

            <li>
              <strong>circular-json@0.3.3 circular-json@0.4.0 circular-json@0.5.1</strong>
              {' '}
              https://github.com/WebReflection/circulajson
              <br />
              Copyright (C) 2013-2017 by Andrea Giammarchi - @WebReflection
            </li>

            <li>
              <strong>clap@1.2.3</strong>
              {' '}
              https://github.com/lahmatiy/clap
              <br />
              Copyright (C) 2014-2016 by Roman Dvornov &lt;rdvornov@gmail.com&gt;
            </li>

            <li>
              <strong>class-utils@0.3.6</strong>
              {' '}
              https://github.com/jonschlinkert/class-utils
              <br />
              Copyright (c) 2015, 2017-2018, Jon Schlinkert.
            </li>

            <li>
              <strong>classnames@2.2.5</strong>
              {' '}
              https://github.com/JedWatson/classnames
              <br />
              Copyright (c) 2016 Jed Watson
            </li>

            <li>
              <strong>cli-cursor@1.0.2 cli-cursor@2.1.0</strong>
              {' '}
              https://github.com/sindresorhus/cli-cursor
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>clone-buffer@1.0.0</strong>
              {' '}
              https://github.com/gulpjs/clone-buffer
              <br />
              Copyright (c) 2016 Blaine Bublitz &lt;blaine.bublitz@gmail.com&gt;,
              Eric Schoffstall &lt;yo@contra.io&gt; and other contributors
            </li>

            <li>
              <strong>clone-deep@0.3.0 clone-deep@2.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/clone-deep
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert
            </li>

            <li>
              <strong>clone-stats@0.0.1 clone-stats@1.0.0</strong>
              {' '}
              https://github.com/hughsk/clone-stats
              <br />
              Copyright (c) 2014 Hugh Kennedy
            </li>

            <li>
              <strong>clone@0.2.0 clone@1.0.3 clone@2.1.1</strong>
              {' '}
              https://github.com/pvorb/node-clone
              <br />
              Copyright (c) 2011-2015 Paul Vorbach &lt;paul@vorba.ch&gt;
            </li>

            <li>
              <strong>cloneable-readable@1.0.0</strong>
              {' '}
              https://github.com/mcollina/cloneable-readable
              <br />
              Copyright (c) 2016 Matteo Collina
            </li>

            <li>
              <strong>co@3.0.6</strong>
              {' '}
              https://github.com/visionmedia/co
            </li>

            <li>
              <strong>co@4.6.0</strong>
              {' '}
              https://github.com/tj/co
              <br />
              Copyright (c) 2014 TJ Holowaychuk &lt;tj@vision-media.ca&gt;
            </li>

            <li>
              <strong>coa@1.0.4 coa@2.0.1</strong>
              {' '}
              https://github.com/veged/coa
              <br />
              Copyright (c) 2015-present Sergey Berezhnoy &lt;veged@ya.ru&gt;
            </li>

            <li>
              <strong>code-point-at@1.1.0</strong>
              {' '}
              https://github.com/sindresorhus/code-point-at
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>coffee-script@1.12.7</strong>
              {' '}
              https://github.com/jashkenas/coffeescript
              <br />
              Copyright (c) 2009-2017 Jeremy Ashkenas
            </li>

            <li>
              <strong>collection-visit@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/collection-visit
              <br />
              Copyright (c) 2015, 2017, Jon Schlinkert
            </li>

            <li>
              <strong>color-convert@1.9.1</strong>
              {' '}
              https://github.com/Qix-/color-convert
              <br />
              Copyright (c) 2011-2016 Heather Arthur &lt;fayearthur@gmail.com&gt;
            </li>

            <li>
              <strong>color-name@1.1.3</strong>
              {' '}
              https://github.com/dfcreative/color-name
              <br />
              Copyright (c) 2015 Dmitry Ivanov
            </li>

            <li>
              <strong>color-string@0.3.0 color-string@1.5.2</strong>
              {' '}
              https://github.com/harthur/color-string
              <br />
              Copyright (c) 2011 Heather Arthur &lt;fayearthur@gmail.com&gt;
            </li>

            <li>
              <strong>color@0.11.4 color@2.0.1</strong>
              {' '}
              https://github.com/qix-/color
              <br />
              Copyright (c) 2012 Heather Arthur
            </li>

            <li>
              <strong>colormin@1.1.2</strong>
              {' '}
              https://github.com/ben-eb/colormin
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>colors@1.1.2</strong>
              {' '}
              https://github.com/Marak/colors.js
              <br />
              Original Library: Copyright (c) Marak Squires
              <br />
              Additional Functionality: Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>combine-lists@1.0.1</strong>
              {' '}
              https://github.com/sjelin/combine-lists
              <br />
              Copyright (c) 2014-2016 Google, Inc.
            </li>

            <li>
              <strong>combine-source-map@0.7.2</strong>
              {' '}
              https://github.com/thlorenz/combine-source-map
              <br />
              Copyright 2013 Thorsten Lorenz. All rights reserved.
            </li>

            <li>
              <strong>combined-stream@1.0.5</strong>
              {' '}
              https://github.com/felixge/node-combined-stream
              <br />
              Copyright (c) 2011 Debuggable Limited &lt;felix@debuggable.com&gt;
            </li>

            <li>
              <strong>commander@2.12.2 commander@2.13.0</strong>
              {' '}
              https://github.com/tj/commander.js
              <br />
              Copyright (c) 2011 TJ Holowaychuk &lt;tj@vision-media.ca&gt;
            </li>

            <li>
              <strong>commondir@1.0.1</strong>
              {' '}
              https://github.com/substack/node-commondir
              <br />
              Copyright (c) 2013 James Halliday (mail@substack.net)
            </li>

            <li>
              <strong>component-bind@1.0.0</strong>
              {' '}
              https://github.com/component/bind
              <br />
              Copyright (c) 2012 TJ Holowaychuk
            </li>

            <li>
              <strong>component-emitter@1.2.1</strong>
              {' '}
              https://github.com/component/emitter
              <br />
              Copyright (c) 2014 Component contributors &lt;dev@component.io&gt;
            </li>

            <li>
              <strong>component-inherit@0.0.3</strong>
              {' '}
              https://github.com/component/inherit
              <br />
              Copyright (c) 2012 TJ Holowaychuk
            </li>

            <li>
              <strong>compressible@2.0.12</strong>
              {' '}
              https://github.com/jshttp/compressible
              <br />
              Copyright (c) 2013 Jonathan Ong &lt;me@jongleberry.com&gt;
              <br />
              Copyright (c) 2014 Jeremiah Senkpiel &lt;fishrock123@rocketmail.com&gt;
              <br />
              Copyright (c) 2015 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>compression@1.7.1</strong>
              {' '}
              https://github.com/expressjs/compression
              <br />
              Copyright (c) 2014 Jonathan Ong &lt;me@jongleberry.com&gt;
              <br />
              Copyright (c) 2014-2015 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>concat-map@0.0.1</strong>
              {' '}
              https://github.com/substack/node-concat-map
            </li>

            <li>
              <strong>concat-stream@1.5.2</strong>
              {' '}
              https://github.com/maxogden/concat-stream
              <br />
              Copyright (c) 2013 Max Ogden
            </li>

            <li>
              <strong>connect-history-api-fallback@1.5.0</strong>
              {' '}
              https://github.com/bripkens/connect-history-api-fallback
              <br />
              Copyright (c) 2012 Ben Ripkens http://bripkens.de
            </li>

            <li>
              <strong>connect@3.6.5</strong>
              {' '}
              https://github.com/senchalabs/connect
              <br />
              Copyright (c) 2010 Sencha Inc.
              <br />
              Copyright (c) 2011 LearnBoost
              <br />
              Copyright (c) 2011-2014 TJ Holowaychuk
              <br />
              Copyright (c) 2015 Douglas Christopher Wilson
            </li>

            <li>
              <strong>console-browserify@1.1.0</strong>
              {' '}
              https://github.com/Raynos/console-browserify
              <br />
              Copyright (c) 2012 Raynos.
            </li>

            <li>
              <strong>constants-browserify@1.0.0</strong>
              {' '}
              https://github.com/juliangruber/constants-browserify
              <br />
              Copyright (c) 2013 Julian Gruber &lt;julian@juliangruber.com&gt;
            </li>

            <li>
              <strong>content-disposition@0.5.2</strong>
              {' '}
              https://github.com/jshttp/content-disposition
              <br />
              Copyright (c) 2014 Douglas Christopher Wilson
            </li>

            <li>
              <strong>content-type@1.0.4</strong>
              {' '}
              https://github.com/jshttp/content-type
              <br />
              Copyright (c) 2015 Douglas Christopher Wilson
            </li>

            <li>
              <strong>convert-source-map@1.1.3 convert-source-map@1.5.1</strong>
              {' '}
              https://github.com/thlorenz/convert-source-map
              <br />
              Copyright 2013 Thorsten Lorenz
            </li>

            <li>
              <strong>cookie-signature@1.0.6</strong>
              {' '}
              https://github.com/visionmedia/node-cookie-signature
              <br />
              Copyright (c) 2012 LearnBoost &lt;tj@learnboost.com&gt;
            </li>

            <li>
              <strong>cookie@0.3.1</strong>
              {' '}
              https://github.com/jshttp/cookie
              <br />
              Copyright (c) 2012-2014 Roman Shtylman &lt;shtylman@gmail.com&gt;
              <br />
              Copyright (c) 2015 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>copy-descriptor@0.1.1</strong>
              {' '}
              https://github.com/jonschlinkert/copy-descriptor
              <br />
              Copyright (c) 2015-2016, Jon Schlinkert
            </li>

            <li>
              <strong>core-js@1.2.7</strong>
              {' '}
              https://github.com/zloirock/core-js
              <br />
              Copyright (c) 2015 Denis Pushkarev
            </li>

            <li>
              <strong>core-js@2.5.1 core-js@2.5.3</strong>
              {' '}
              https://github.com/zloirock/core-js
              <br />
              Copyright (c) 2014-2017 Denis Pushkarev
            </li>

            <li>
              <strong>core-util-is@1.0.2</strong>
              {' '}
              https://github.com/isaacs/core-util-is
              <br />
              Copyright Node.js contributors
            </li>

            <li>
              <strong>cosmiconfig@2.2.2 cosmiconfig@3.1.0</strong>
              {' '}
              https://github.com/davidtheclark/cosmiconfig
              <br />
              Copyright (c) 2015 David Clark
            </li>

            <li>
              <strong>create-ecdh@4.0.0</strong>
              {' '}
              https://github.com/crypto-browserify/createECDH
              <br />
              Copyright (c) 2014-2017 createECDH contributors
            </li>

            <li>
              <strong>create-hash@1.1.3</strong>
              {' '}
              https://github.com/crypto-browserify/createHash
              <br />
              Copyright (c) 2017 crypto-browserify contributors
            </li>

            <li>
              <strong>create-hmac@1.1.6</strong>
              {' '}
              https://github.com/crypto-browserify/createHmac
              <br />
              Copyright (c) 2017 crypto-browserify contributors
            </li>

            <li>
              <strong>create-react-class@15.6.2</strong>
              {' '}
              https://github.com/facebook/react
              <br />
              Copyright (c) 2013-present, Facebook, Inc.
            </li>

            <li>
              <strong>cross-spawn@3.0.1 cross-spawn@5.1.0</strong>
              {' '}
              https://github.com/IndigoUnited/node-cross-spawn
              <br />
              Copyright (c) 2014 IndigoUnited
            </li>

            <li>
              <strong>crypto-browserify@3.12.0</strong>
              {' '}
              https://github.com/crypto-browserify/crypto-browserify
              <br />
              Copyright (c) 2013 Dominic Tarr
            </li>

            <li>
              <strong>css-color-names@0.0.4</strong>
              {' '}
              https://github.com/bahamas10/css-color-names
            </li>

            <li>
              <strong>css-loader@0.28.8</strong>
              {' '}
              https://github.com/webpack-contrib/css-loader
              <br />
              Copyright (c) JS Foundation and other contributors
            </li>

            <li>
              <strong>css-select-base-adapter@0.1.0</strong>
              {' '}
              https://github.com/nrkn/css-select-base-adapter
            </li>

            <li>
              <strong>css-selector-tokenizer@0.7.0</strong>
              {' '}
              https://github.com/css-modules/css-selector-tokenizer
              <br />
              Copyright (c) Tobias Koppers, 2015
            </li>

            <li>
              <strong>css-tree@1.0.0-alpha25</strong>
              {' '}
              https://github.com/csstree/csstree
              <br />
              Copyright (C) 2016 by Roman Dvornov
            </li>

            <li>
              <strong>css-unit-converter@1.1.1</strong>
              {' '}
              https://github.com/andyjansson/css-unit-converter
              <br />
              Copyright (c) 2015 Andy Jansson
            </li>

            <li>
              <strong>css-url-regex@1.1.0</strong>
              {' '}
              https://github.com/johnotander/css-url-regex
              <br />
              Copyright (c) John Otander &lt;johnotander@gmail.com&gt;
            </li>

            <li>
              <strong>cssesc@0.1.0 cssesc@1.0.0</strong>
              {' '}
              https://github.com/mathiasbynens/cssesc
              <br />
              Copyright (c) Mathias Bynens &lt;https://mathiasbynens.be/&gt;
            </li>

            <li>
              <strong>cssnano@3.10.0"}</strong>
              {' '}
              https://github.com/ben-eb/cssnano
              <br />
              Copyright (c) Ben Briggs http://beneb.info
            </li>

            <li>
              <strong>csso@2.3.2</strong>
              {' '}
              https://github.com/css/csso
              <br />
              Copyright (C) 2011-2015 by Sergey Kryzhanovsky
            </li>

            <li>
              <strong>csso@3.4.0</strong>
              {' '}
              https://github.com/css/csso
              <br />
              Copyright (C) 2011-2017 by Sergey Kryzhanovsky
            </li>

            <li>
              <strong>currently-unhandled@0.4.1</strong>
              {' '}
              https://github.com/jamestalmage/currently-unhandled
              <br />
              Copyright (c) James Talmage &lt;james@talmage.io&gt;
            </li>

            <li>
              <strong>custom-event@1.0.1</strong>
              {' '}
              https://github.com/webmodules/custom-event
              <br />
              Copyright (c) 2015 Nathan Rajlich
            </li>

            <li>
              <strong>cyclist@0.2.2</strong>
              {' '}
              https://github.com/mafintosh/cyclist
              <br />
              Copyright (c) 2015 Mathias Buus
            </li>

            <li>
              <strong>d@1.0.0</strong>
              {' '}
              https://github.com/medikoo/d
              <br />
              Copyright (C) 2013 Mariusz Nowak (www.medikoo.com)
            </li>

            <li>
              <strong>dashdash@1.14.1</strong>
              {' '}
              https://github.com/trentm/node-dashdash
              <br />
              Copyright (c) 2013 Trent Mick. All rights reserved.
            </li>

            <li>
              <strong>data-uri-to-buffer@1.2.0</strong>
              {' '}
              https://github.com/TooTallNate/node-data-uri-to-buffer
              <br />
              Copyright (c) 2014 Nathan Rajlich nathan@tootallnate.net
            </li>

            <li>
              <strong>date-format@1.2.0</strong>
              {' '}
              https://github.com/nomiddlename/date-format
              <br />
              Copyright (c) 2013 Gareth Jones
            </li>

            <li>
              <strong>date-now@0.1.4 date-now@1.0.1</strong>
              {' '}
              https://github.com/Colingo/date-now
              <br />
              Copyright (c) 2012 Colingo.
            </li>

            <li>
              <strong>dateformat@2.2.0 dateformat@3.0.2</strong>
              {' '}
              https://github.com/felixge/node-dateformat
              <br />
              Copyright (c) 2007-2009 Steven Levithan &lt;stevenlevithan.com&gt;
            </li>

            <li>
              <strong>debug@2.2.0 debug@2.2.0 debug@2.6.8 debug@2.6.9 debug@3.1.0</strong>
              {' '}
              https://github.com/visionmedia/debug
              <br />
              Copyright (c) 2014 TJ Holowaychuk tj@vision-media.ca
            </li>

            <li>
              <strong>decamelize-keys@1.1.0</strong>
              {' '}
              https://github.com/sindresorhus/decamelize
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>decamelize@1.2.0 decamelize@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/decamelize
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>decode-uri-component@0.2.0</strong>
              {' '}
              https://github.com/samverschueren/decode-uri-component
              <br />
              Copyright (c) Sam Verschueren &lt;sam.verschueren@gmail.com&gt; (github.com/SamVerschueren)
            </li>

            <li>
              <strong>deep-equal@1.0.1</strong>
              {' '}
              https://github.com/substack/node-deep-equal
            </li>

            <li>
              <strong>deep-extend@0.4.2</strong>
              {' '}
              https://github.com/unclechu/node-deep-extend
              <br />
              Copyright (c) 2013-2015, Viacheslav Lotsmanov
            </li>

            <li>
              <strong>deep-is@0.1.3</strong>
              {' '}
              https://github.com/thlorenz/deep-is
              <br />
              Copyright (c) 2012, 2013 Thorsten Lorenz &lt;thlorenz@gmx.de&gt;
              <br />
              Copyright (c) 2012 James Halliday &lt;mail@substack.net&gt;
              <br />
              Copyright (c) 2009 Thomas Robinson &lt;280north.com&gt;
            </li>

            <li>
              <strong>defaults@1.0.3</strong>
              {' '}
              https://github.com/tmpvar/defaults
              <br />
              Copyright (c) 2015 Elijah Insua
            </li>

            <li>
              <strong>define-properties@1.1.2</strong>
              {' '}
              https://github.com/ljharb/define-properties
              <br />
              Copyright (C) 2015 Jordan Harband
            </li>

            <li>
              <strong>define-property@0.2.5</strong>
              {' '}
              https://github.com/jonschlinkert/define-property
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>define-property@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/define-property
              <br />
              Copyright (c) 2015, 2017, Jon Schlinkert
            </li>

            <li>
              <strong>defined@1.0.0</strong>
              {' '}
              https://github.com/substack/defined
            </li>

            <li>
              <strong>degenerator@1.0.4</strong>
              {' '}
              https://github.com/TooTallNate/node-degenerator
              <br />
              Copyright (c) 2013 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
            </li>

            <li>
              <strong>del@2.2.2 del@3.0.0</strong>
              {' '}
              https://github.com/sindresorhus/del
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>delayed-stream@1.0.0</strong>
              {' '}
              https://github.com/felixge/node-delayed-stream
              <br />
              Copyright (c) 2011 Debuggable Limited &lt;felix@debuggable.com&gt;
            </li>

            <li>
              <strong>delegates@1.0.0</strong>
              {' '}
              https://github.com/visionmedia/node-delegates
              <br />
              Copyright (c) 2015 TJ Holowaychuk &lt;tj@vision-media.ca&gt;
            </li>

            <li>
              <strong>depd@1.1.1 depd@1.1.2</strong>
              {' '}
              https://github.com/dougwilson/nodejs-depd
              <br />
              Copyright (c) 2014-2017 Douglas Christopher Wilson
            </li>

            <li>
              <strong>deprecated@0.0.1 deprecated@0.0.2</strong>
              {' '}
              https://github.com/wearefractal/deprecated
              <br />
              Copyright (c) 2014 Fractal &lt;contact@wearefractal.com&gt;
            </li>

            <li>
              <strong>deps-sort@2.0.0</strong>
              {' '}
              https://github.com/substack/deps-sort
            </li>

            <li>
              <strong>des.js@1.0.0</strong>
              {' '}
              https://github.com/indutny/des.js
              <br />
              Copyright Fedor Indutny, 2015.
            </li>

            <li>
              <strong>desandro-matches-selector@2.0.2</strong>
              {' '}
              https://github.com/desandro/matches-selector
              <br />
              Copyright (c) 2018 David DeSandro
            </li>

            <li>
              <strong>destroy@1.0.4</strong>
              {' '}
              https://github.com/stream-utils/destroy
              <br />
              Copyright (c) 2014 Jonathan Ong me@jongleberry.com
            </li>

            <li>
              <strong>detect-file@1.0.0</strong>
              {' '}
              https://github.com/doowb/detect-file
              <br />
              Copyright (c) 2016-2017, Brian Woodward.
            </li>

            <li>
              <strong>detect-indent@4.0.0 detect-indent@5.0.0</strong>
              {' '}
              https://github.com/sindresorhus/detect-indent
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>detective@4.7.1</strong>
              {' '}
              https://github.com/browserify/detective
            </li>

            <li>
              <strong>di@0.0.1</strong>
              {' '}
              https://github.com/vojtajina/node-di
              <br />
              Copyright (C) 2013 Vojta JÃ­na.
            </li>

            <li>
              <strong>diffie-hellman@5.0.2</strong>
              {' '}
              https://github.com/crypto-browserify/diffie-hellman
            </li>

            <li>
              <strong>dir-glob@2.0.0 dir-glob@2.0.0</strong>
              https://github.com/kevva/dir-glob
              <br />
              Copyright (c) Kevin Mårtensson &lt;kevinmartensson@gmail.com&gt; (github.com/kevva)
            </li>

            <li>
              <strong>dns-equal@1.0.0</strong>
              {' '}
              https://github.com/watson/dns-equal
              <br />
              Copyright (c) 2016 Thomas Watson Steen
            </li>

            <li>
              <strong>dns-packet@1.3.1</strong>
              {' '}
              https://github.com/mafintosh/dns-packet
              <br />
              Copyright (c) 2016 Mathias Buus
            </li>

            <li>
              <strong>dns-txt@2.0.2</strong>
              {' '}
              https://github.com/watson/dns-txt
              <br />
              Copyright (c) 2015 Thomas Watson Steen
            </li>

            <li>
              <strong>dom-helpers@3.3.1</strong>
              {' '}
              https://github.com/jquense/dom-helpers
              <br />
              Copyright (c) 2015 Jason Quense
            </li>

            <li>
              <strong>dom-serialize@2.2.1</strong>
              {' '}
              https://github.com/webmodules/dom-serialize
              <br />
              Copyright 2017 Nathan Rajlich
            </li>

            <li>
              <strong>dom-serializer@0.1.0</strong>
              {' '}
              https://github.com/webmodules/dom-serialize
              <br />
              Copyright 2017 Nathan Rajlich
            </li>

            <li>
              <strong>domain-browser@1.1.7</strong>
              {' '}
              https://github.com/bevry/domain-browser
              <br />
              Copyright (c) 2013+ Bevry Pty Ltd
            </li>

            <li>
              <strong>dot-prop@4.2.0</strong>
              {' '}
              https://github.com/sindresorhus/dot-prop
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>dotfile-regex@0.1.2 dotfile-regex@0.1.2</strong>
              https://github.com/regexps/dotfile-regex
              <br />
              Copyright (c) 2015 Jon Schlinkert
            </li>

            <li>
              <strong>double-ended-queue@2.1.0-0</strong>
              {' '}
              https://github.com/petkaantonov/deque
              <br />
              Copyright (c) 2013 Petka Antonov
            </li>

            <li>
              <strong>duplexer@0.1.1</strong>
              {' '}
              https://github.com/Raynos/duplexer
              <br />
              Copyright (c) 2012 Raynos
            </li>

            <li>
              <strong>duplexify@3.5.3</strong>
              {' '}
              https://github.com/mafintosh/duplexify
              <br />
              Copyright (c) 2014 Mathias Buus
            </li>

            <li>
              <strong>ecc-jsbn@0.1.1</strong>
              {' '}
              https://github.com/quartzjer/ecc-jsbn
              <br />
              Copyright (c) 2014 Jeremie Miller
            </li>

            <li>
              <strong>ee-first@1.1.1</strong>
              {' '}
              https://github.com/jonathanong/ee-first
              <br />
              Copyright (c) 2014 Jonathan Ong me@jongleberry.com
            </li>

            <li>
              <strong>electron-releases@2.1.0</strong>
              {' '}
              https://github.com/electron/electron-releases
            </li>

            <li>
              <strong>element-resize-event@2.0.9</strong>
              {' '}
              https://github.com/KyleAMathews/element-resize-event
              <br />
              Copyright (c) 2015 Kyle Mathews
            </li>

            <li>
              <strong>elliptic@6.4.0</strong>
              {' '}
              https://github.com/indutny/elliptic
              <br />
              Copyright Fedor Indutny, 2014.
            </li>

            <li>
              <strong>emojis-list@2.1.0</strong>
              {' '}
              https://github.com/kikobeats/emojis-list
              <br />
              Copyright Â© 2015 Kiko Beats
            </li>

            <li>
              <strong>encodeurl@1.0.1</strong>
              {' '}
              https://github.com/pillarjs/encodeurl
              <br />
              Copyright (c) 2016 Douglas Christopher Wilson
            </li>

            <li>
              <strong>encoding@0.1.12</strong>
              {' '}
              https://github.com/andris9/encoding
              <br />
              Copyright (c) 2012-2014 Andris Reinman
            </li>

            <li>
              <strong>end-of-stream@0.1.5 end-of-stream@1.4.1</strong>
              {' '}
              https://github.com/mafintosh/end-of-stream
              <br />
              Copyright (c) 2014 Mathias Buus
            </li>

            <li>
              <strong>engine.io-client@3.1.4</strong>
              {' '}
              https://github.com/socketio/engine.io-client
              <br />
              Copyright (c) 2014-2015 Automattic &lt;dev@cloudup.com&gt;
            </li>

            <li>
              <strong>engine.io-parser@2.1.2</strong>
              {' '}
              https://github.com/socketio/engine.io-parser
              <br />
              Copyright (c) 2016 Guillermo Rauch (@rauchg)
            </li>

            <li>
              <strong>engine.io@3.1.4</strong>
              {' '}
              https://github.com/socketio/engine.io
              <br />
              Copyright (c) 2014 Guillermo Rauch &lt;guillermo@learnboost.com&gt;
            </li>

            <li>
              <strong>enhanced-resolve@3.4.1</strong>
              {' '}
              https://github.com/webpack/enhanced-resolve
              <br />
              Copyright (c) 2012-2016 Tobias Koppers
            </li>

            <li>
              <strong>enhanced-resolve@4.0.0-beta.4</strong>
              {' '}
              https://github.com/webpack/enhanced-resolve
              <br />
              Copyright (c) 2012-2016 Tobias Koppers
            </li>

            <li>
              <strong>ent@2.2.0</strong>
              {' '}
              https://github.com/substack/node-ent
            </li>

            <li>
              <strong>errno@0.1.6</strong>
              {' '}
              https://github.com/rvagg/node-errno
              <br />
              Copyright (c) 2012-2015 Rod Vagg (https://github.com/rvagg) (@rvagg (https://twitter.com/rvagg))
            </li>

            <li>
              <strong>error-ex@1.3.1</strong>
              {' '}
              https://github.com/qix-/node-error-ex
              <br />
              Copyright (c) 2015 JD Ballard
            </li>

            <li>
              <strong>es-abstract@1.10.0</strong>
              {' '}
              https://github.com/ljharb/es-abstract
              <br />
              Copyright (C) 2015 Jordan Harband
            </li>

            <li>
              <strong>es-to-primitive@1.1.1</strong>
              {' '}
              https://github.com/ljharb/es-to-primitive
              <br />
              Copyright (c) 2015 Jordan Harband
            </li>

            <li>
              <strong>es5-ext@0.10.37</strong>
              {' '}
              https://github.com/medikoo/es5-ext
              <br />
              Copyright (C) 2011-2017 Mariusz Nowak (www.medikoo.com)
            </li>

            <li>
              <strong>es6-iterator@2.0.3</strong>
              {' '}
              https://github.com/medikoo/es6-iterator
              <br />
              Copyright (C) 2013-2017 Mariusz Nowak (www.medikoo.com)
            </li>

            <li>
              <strong>es6-map@0.1.5</strong>
              {' '}
              https://github.com/medikoo/es6-map
              <br />
              Copyright (C) 2013 Mariusz Nowak (www.medikoo.com)
            </li>

            <li>
              <strong>es6-promise@4.2.2</strong>
              {' '}
              https://github.com/stefanpenner/es6-promise
              <br />
              Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors
            </li>

            <li>
              <strong>es6-set@0.1.5</strong>
              {' '}
              https://github.com/medikoo/es6-set
              <br />
              Copyright (C) 2013 Mariusz Nowak (www.medikoo.com)
            </li>

            <li>
              <strong>es6-symbol@3.1.1</strong>
              {' '}
              https://github.com/medikoo/es6-symbol
              <br />
              Copyright (C) 2013-2015 Mariusz Nowak (www.medikoo.com)
            </li>

            <li>
              <strong>es6-weak-map@2.0.2</strong>
              {' '}
              https://github.com/medikoo/es6-weak-map
              <br />
              Copyright (C) 2013 Mariusz Nowak (www.medikoo.com)
            </li>

            <li>
              <strong>escape-html@1.0.3</strong>
              {' '}
              https://github.com/component/escape-html
              <br />
              Copyright (c) 2012-2013 TJ Holowaychuk
              <br />
              Copyright (c) 2015 Andreas Lubbe
              <br />
              Copyright (c) 2015 Tiancheng \"Timothy\" Gu
            </li>

            <li>
              <strong>escape-string-regexp@1.0.5</strong>
              {' '}
              https://github.com/sindresorhus/escape-string-regexp
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>eslint-plugin-react@7.5.1</strong>
              {' '}
              https://github.com/yannickcr/eslint-plugin-react
              <br />
              Copyright (c) 2014 Yannick Croissant
            </li>

            <li>
              <strong>eslint@2.13.1 eslint@4.15.0</strong>
              {' '}
              https://github.com/eslint/eslint
              <br />
              Copyright JS Foundation and other contributors, https://js.foundation
            </li>

            <li>
              <strong>etag@1.8.1</strong>
              {' '}
              https://github.com/jshttp/etag
              <br />
              Copyright (c) 2014-2016 Douglas Christopher Wilson
            </li>

            <li>
              <strong>ev-emitter@1.1.1</strong>
              {' '}
              https://github.com/metafizzy/ev-emitter
              <br />
              Copyright (c) 2018 David DeSandro
            </li>

            <li>
              <strong>event-emitter@0.3.5</strong>
              {' '}
              https://github.com/medikoo/event-emitter
              <br />
              Copyright (C) 2012-2015 Mariusz Nowak (www.medikoo.com)
            </li>

            <li>
              <strong>eventemitter3@1.2.0 eventemitter3@3.0.0</strong>
              {' '}
              https://github.com/primus/eventemitter3
              <br />
              Copyright (c) 2014 Arnout Kazemier
            </li>

            <li>
              <strong>event-emitter@0.3.5</strong>
              {' '}
              https://github.com/medikoo/event-emitter
              <br />
              Copyright (C) 2012-2015 Mariusz Nowak (www.medikoo.com)
            </li>

            <li>
              <strong>eventemitter3@1.2.0 eventemitter3@3.0.0</strong>
              {' '}
              https://github.com/primus/eventemitter3
              <br />
              Copyright (c) 2014 Arnout Kazemier
            </li>

            <li>
              <strong>events@1.1.1</strong>
              {' '}
              https://github.com/Gozala/events
              <br />
              Copyright Joyent, Inc. and other Node contributors.
            </li>

            <li>
              <strong>eventsource@0.1.6</strong>
              {' '}
              https://github.com/aslakhellesoy/eventsource-node
              <br />
              Copyright (c) 2012, 2013, 2014 Aslak HellesÃ¸y
            </li>

            <li>
              <strong>eventsource@1.0.5</strong>
              {' '}
              https://github.com/EventSource/eventsource
              <br />
              Copyright (c) EventSource GitHub organisation
            </li>

            <li>
              <strong>evp_bytestokey@1.0.3</strong>
              {' '}
              https://github.com/crypto-browserify/EVP_BytesToKey
              <br />
              Copyright (c) 2017 crypto-browserify contributors
            </li>

            <li>
              <strong>execa@0.7.0</strong>
              {' '}
              https://github.com/sindresorhus/execa
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>exit-hook@1.1.1</strong>
              {' '}
              https://github.com/sindresorhus/exit-hook
              <br />
              Copyright (c) Sindre Sorhus (http://sindresorhus.com)
            </li>

            <li>
              <strong>exit@0.1.2</strong>
              {' '}
              https://github.com/cowboy/node-exit
              <br />
              Copyright (c) 2013 'Cowboy' Ben Alman
            </li>

            <li>
              <strong>expand-braces@0.1.2</strong>
              {' '}
              https://github.com/jonschlinkert/expand-braces
              <br />
              Copyright (c) 2014 Jon Schlinkert, contributors.
            </li>

            <li>
              <strong>expand-brackets@0.1.5 expand-brackets@2.1.4</strong>
              {' '}
              https://github.com/jonschlinkert/expand-brackets
              <br />
              Copyright (c) 2015-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>expand-range@0.1.1</strong>
              {' '}
              https://github.com/jonschlinkert/expand-range
              <br />
              Copyright (c) 2014 Jon Schlinkert, contributors.
            </li>

            <li>
              <strong>expand-range@1.8.2</strong>
              {' '}
              https://github.com/jonschlinkert/expand-range
              <br />
              Copyright (c) 2014-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>expand-range@2.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/expand-range
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert
            </li>

            <li>
              <strong>expand-tilde@2.0.2</strong>
              {' '}
              https://github.com/jonschlinkert/expand-tilde
              <br />
              Copyright (c) 2015-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>express@4.16.2</strong>
              {' '}
              https://github.com/expressjs/express
              <br />
              Copyright (c) 2009-2014 TJ Holowaychuk &lt;tj@vision-media.ca&gt;
              <br />
              Copyright (c) 2013-2014 Roman Shtylman &lt;shtylman+expressjs@gmail.com&gt;
              <br />
              Copyright (c) 2014-2015 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>extend-shallow@1.1.4 extend-shallow@2.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/extend-shallow
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert.
            </li>

            <li>
              <strong>extend-shallow@3.0.2</strong>
              {' '}
              https://github.com/jonschlinkert/extend-shallow
              <br />
              Copyright (c) 2014-2015, 2017, Jon Schlinkert.
            </li>

            <li>
              <strong>extend@3.0.1</strong>
              {' '}
              https://github.com/justmoon/node-extend
              <br />
              Copyright (c) 2014 Stefan Thomas
            </li>

            <li>
              <strong>external-editor@2.1.0</strong>
              {' '}
              https://github.com/mrkmg/node-external-editor
              <br />
              Copyright (c) 2016 Kevin Gravier
            </li>

            <li>
              <strong>extglob@0.3.2</strong>
              {' '}
              https://github.com/jonschlinkert/extglob
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>extglob@2.0.3</strong>
              {' '}
              https://github.com/micromatch/extglob
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>extract-text-webpack-plugin@3.0.2</strong>
              {' '}
              https://github.com/webpack-contrib/extract-text-webpack-plugin
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>extsprintf@1.0.2 extsprintf@1.3.0 extsprintf@1.4.0</strong>
              {' '}
              https://github.com/davepacheco/node-extsprintf
              <br />
              Copyright (c) 2012, Joyent, Inc. All rights reserved.
            </li>

            <li>
              <strong>fancy-log@1.3.2</strong>
              {' '}
              https://github.com/js-cli/fancy-log
              <br />
              Copyright (c) 2015 Blaine Bublitz &lt;blaine.bublitz@gmail.com&gt;
              <br />
              Based on gulp-util, copyright 2014 Fractal &lt;contact@wearefractal.com&gt;
            </li>

            <li>
              <strong>fast-deep-equal@1.0.0</strong>
              {' '}
              https://github.com/epoberezkin/fast-deep-equal
              <br />
              Copyright (c) 2017 Evgeny Poberezkin
            </li>

            <li>
              <strong>fast-json-stable-stringify@2.0.0</strong>
              {' '}
              https://github.com/epoberezkin/fast-json-stable-stringify
            </li>

            <li>
              <strong>fast-levenshtein@2.0.6</strong>
              {' '}
              https://github.com/hiddentao/fast-levenshtein
              <br />
              Copyright (c) 2013 [Ramesh Nair](http://www.hiddentao.com/)
            </li>

            <li>
              <strong>fastparse@1.1.1</strong>
              {' '}
              https://github.com/webpack/fastparse
            </li>

            <li>
              <strong>faye-websocket@0.10.0</strong>
              {' '}
              https://github.com/faye/faye-websocket-node
              <br />
              Copyright (c) 2010-2015 James Coglan
            </li>

            <li>
              <strong>faye-websocket@0.11.1</strong>
              {' '}
              https://github.com/faye/faye-websocket-node
              <br />
              Copyright (c) 2010-2017 James Coglan
            </li>

            <li>
              <strong>fbjs@0.8.16</strong>
              {' '}
              https://github.com/facebook/fbjs
              <br />
              Copyright (c) 2013-present, Facebook, Inc.
            </li>

            <li>
              <strong>fd-slicer@1.0.1</strong>
              {' '}
              https://github.com/andrewrk/node-fd-slicer
              <br />
              Copyright (c) 2014 Andrew Kelley
            </li>

            <li>
              <strong>figures@1.7.0 figures@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/figures
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>file-entry-cache@1.3.1 file-entry-cache@2.0.0</strong>
              {' '}
              https://github.com/royriojas/file-entry-cache
              <br />
              Copyright (c) 2015 Roy Riojas
            </li>

            <li>
              <strong>file-loader@1.1.6</strong>
              {' '}
              https://github.com/webpack/file-loader
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>file-uri-to-path@1.0.0</strong>
              {' '}
              https://github.com/TooTallNate/file-uri-to-path
              <br />
              Copyright (c) 2014 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
            </li>

            <li>
              <strong>filename-regex@2.0.1</strong>
              {' '}
              https://github.com/regexhq/filename-regex
              <br />
              Copyright (c) 2014-2015, 2017, Jon Schlinkert
            </li>

            <li>
              <strong>fill-range@2.2.3</strong>
              {' '}
              https://github.com/jonschlinkert/fill-range
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert.
            </li>

            <li>
              <strong>fill-range@4.0.0 fill-range@5.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/fill-range
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert
            </li>

            <li>
              <strong>finalhandler@1.0.6 finalhandler@1.1.0</strong>
              {' '}
              https://github.com/pillarjs/finalhandler
              <br />
              Copyright (c) 2014-2017 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>find-cache-dir@1.0.0</strong>
              {' '}
              https://github.com/avajs/find-cache-dir
              <br />
              Copyright (c) James Talmage &lt;james@talmage.io&gt; (github.com/jamestalmage)
            </li>

            <li>
              <strong>find-index@0.1.1</strong>
              {' '}
              https://github.com/jsdf/find-index
            </li>

            <li>
              <strong>find-up@1.1.2 find-up@2.1.0</strong>
              {' '}
              https://github.com/sindresorhus/find-up
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>findup-sync@2.0.0</strong>
              {' '}
              https://github.com/js-cli/node-findup-sync
              <br />
              Copyright (c) 2012-2016 'Cowboy' Ben Alman
            </li>

            <li>
              <strong>fined@1.1.0</strong>
              {' '}
              https://github.com/js-cli/fined
              <br />
              Copyright (c) 2016 Blaine Bublitz, Tyler Kellen and other contributors
            </li>

            <li>
              <strong>first-chunk-stream@1.0.0</strong>
              {' '}
              https://github.com/sindresorhus/first-chunk-stream
              <br />
              Copyright (c) Sindre Sorhus(http://sindresorhus.com)
            </li>

            <li>
              <strong>fizzy-ui-utils@2.0.5</strong>
              {' '}
              https://github.com/metafizzy/fizzy-ui-utils
              <br />
              Copyright © 2018 David DeSandro
            </li>

            <li>
              <strong>flagged-respawn@1.0.0</strong>
              {' '}
              https://github.com/js-cli/js-flagged-respawn
              <br />
              Copyright (c) 2014 Tyler Kellen
            </li>

            <li>
              <strong>flat-cache@1.3.0</strong>
              {' '}
              https://github.com/royriojas/flat-cache
              <br />
              Copyright (c) 2015 Roy Riojas
            </li>

            <li>
              <strong>flatten@1.0.2</strong>
              {' '}
              https://github.com/jesusabdullah/node-flatten
              <br />
              Copyright (c) 2016 Joshua Holbrook
            </li>

            <li>
              <strong>flush-write-stream@1.0.2</strong>
              {' '}
              https://github.com/mafintosh/flush-write-stream
              <br />
              Copyright (c) 2015 Mathias Buus
            </li>

            <li>
              <strong>follow-redirects@1.0.0</strong>
              {' '}
              https://github.com/olalonde/follow-redirects
              <br />
              Copyright (c) 2018 Olivier Lalonde &lt;olalonde@gmail.com&gt;
            </li>

            <li>
              <strong>follow-redirects@1.3.0</strong>
              {' '}
              https://github.com/olalonde/follow-redirects
              <br />
              Copyright 2017 Olivier Lalonde &lt;olalonde@gmail.com&gt;,
              James Talmage &lt;james@talmage.io&gt;, Ruben Verborgh
            </li>

            <li>
              <strong>for-in@0.1.8 for-in@1.0.2</strong>
              {' '}
              https://github.com/jonschlinkert/for-in
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert
            </li>

            <li>
              <strong>for-own@0.1.5 for-own@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/for-own
              <br />
              Copyright (c) 2014-2015, 2017, Jon Schlinkert
            </li>

            <li>
              <strong>foreach@2.0.5</strong>
              {' '}
              https://github.com/manuelstofer/foreach
              <br />
              Copyright (c) 2013 Manuel Stofer
            </li>

            <li>
              <strong>form-data@2.0.0 form-data@2.1.4 form-data@2.3.1</strong>
              {' '}
              https://github.com/form-data/form-data
              <br />
              Copyright (c) 2012 Felix Geisendörfer (felix@debuggable.com) and contributors
            </li>

            <li>
              <strong>forwarded@0.1.2</strong>
              {' '}
              https://github.com/jshttp/forwarded
              <br />
              Copyright (c) 2014-2017 Douglas Christopher Wilson
            </li>

            <li>
              <strong>fragment-cache@0.2.1</strong>
              {' '}
              https://github.com/jonschlinkert/fragment-cache
              <br />
              Copyright (c) 2016-2017, Jon Schlinkert
            </li>

            <li>
              <strong>fresh@0.5.2</strong>
              {' '}
              https://github.com/jshttp/fresh
              <br />
              Copyright (c) 2012 TJ Holowaychuk &lt;tj@vision-media.ca&gt;
              <br />
              Copyright (c) 2016-2017 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>from2@2.3.0</strong>
              {' '}
              https://github.com/hughsk/from2
              <br />
              Copyright (c) 2014 Hugh Kennedy
            </li>

            <li>
              <strong>front-matter@2.1.2 front-matter@2.3.0</strong>
              {' '}
              https://github.com/jxson/front-matter
              <br />
              Copyright (c) Jason Campbell ('Author')
            </li>

            <li>
              <strong>fs-access@1.0.1</strong>
              {' '}
              https://github.com/sindresorhus/fs-access
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>fs-exists-sync@0.1.0</strong>
              {' '}
              https://github.com/jonschlinkert/fs-exists-sync
              <br />
              Copyright (c) 2016, Jon Schlinkert.
            </li>

            <li>
              <strong>fs-extra@1.0.0</strong>
              {' '}
              https://github.com/jprichardson/node-fs-extra
              <br />
              Copyright (c) 2011-2016 JP Richardson
            </li>

            <li>
              <strong>fs-extra@3.0.1 fs-extra@5.0.0</strong>
              {' '}
              https://github.com/jprichardson/node-fs-extra
              <br />
              Copyright (c) 2011-2017 JP Richardson
            </li>

            <li>
              <strong>fs-readdir-recursive@1.1.0</strong>
              {' '}
              https://github.com/fs-utils/fs-readdir-recursive
              <br />
              Copyright (c) 2014 Jonathan Ong me@jongleberry.com
            </li>

            <li>
              <strong>fsevents@1.1.3</strong>
              {' '}
              https://github.com/strongloop/fsevents
              <br />
              Copyright (C) 2010-2014 Philipp Dunkel
            </li>

            <li>
              <strong>ftp@0.3.10</strong>
              {' '}
              https://github.com/mscdex/node-ftp
              <br />
              Copyright Brian White. All rights reserved.
            </li>

            <li>
              <strong>function-bind@1.1.1</strong>
              {' '}
              https://github.com/Raynos/function-bind
              <br />
              Copyright (c) 2013 Raynos.
            </li>

            <li>
              <strong>functional-red-black-tree@1.0.1</strong>
              {' '}
              https://github.com/mikolalysenko/functional-red-black-tree
              <br />
              Copyright (c) 2013 Mikola Lysenko
            </li>

            <li>
              <strong>gaze@0.5.2 gaze@1.1.2</strong>
              {' '}
              https://github.com/shama/gaze
              <br />
              Copyright (c) 2013 Kyle Robinson Young
            </li>

            <li>
              <strong>gaze@1.1.2</strong>
              {' '}
              https://github.com/shama/gaze
              <br />
              Copyright (c) 2015 Kyle Robinson Young
            </li>

            <li>
              <strong>generate-function@2.0.0</strong>
              {' '}
              https://github.com/mafintosh/generate-function
              <br />
              Copyright (c) 2014 Mathias Buus
            </li>

            <li>
              <strong>generate-object-property@1.2.0</strong>
              {' '}
              https://github.com/mafintosh/generate-object-property
              <br />
              Copyright (c) 2014 Mathias Buus
            </li>

            <li>
              <strong>get-size@2.0.2</strong>
              {' '}
              https://github.com/desandro/get-size
              <br />
              Copyright (c) 2018 David DeSandro
            </li>

            <li>
              <strong>get-stdin@4.0.1 get-stdin@5.0.1</strong>
              {' '}
              https://github.com/sindresorhus/get-stdin
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>get-stream@3.0.0</strong>
              {' '}
              https://github.com/sindresorhus/get-stream
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>get-uri@2.0.1</strong>
              {' '}
              https://github.com/TooTallNate/node-get-uri
              <br />
              Copyright (c) 2014 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
            </li>

            <li>
              <strong>get-value@2.0.6</strong>
              {' '}
              https://github.com/jonschlinkert/get-value
              <br />
              Copyright (c) 2014-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>getpass@0.1.7</strong>
              {' '}
              https://github.com/arekinath/node-getpass
              <br />
              Copyright Joyent, Inc.
            </li>

            <li>
              <strong>glob-base@0.3.0</strong>
              {' '}
              https://github.com/jonschlinkert/glob-base
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>glob-stream@3.1.18</strong>
              {' '}
              https://github.com/wearefractal/glob-stream
              <br />
              Copyright (c) 2013 Fractal &lt;contact@wearefractal.com&gt;
            </li>

            <li>
              <strong>glob-watcher@0.0.6</strong>
              {' '}
              https://github.com/wearefractal/glob-watcher
              <br />
              Copyright (c) 2013 Fractal &lt;contact@wearefractal.com&gt;
            </li>

            <li>
              <strong>glob2base@0.0.12</strong>
              {' '}
              https://github.com/wearefractal/glob2base
              <br />
              Copyright (c) 2014 Fractal &lt;contact@wearefractal.com&gt;
            </li>

            <li>
              <strong>global-modules@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/global-modules
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>global-prefix@1.0.2</strong>
              {' '}
              https://github.com/jonschlinkert/global-prefix
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>globals@11.1.0 globals@9.18.0</strong>
              {' '}
              https://github.com/sindresorhus/globals
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>globby@5.0.0 globby@6.1.0 globby@7.1.1</strong>
              {' '}
              https://github.com/sindresorhus/globby
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>globule@0.1.0</strong>
              {' '}
              https://github.com/cowboy/node-globule
              <br />
              Copyright (c) 2013 'Cowboy' Ben Alman
            </li>

            <li>
              <strong>globule@1.2.0</strong>
              {' '}
              https://github.com/cowboy/node-globule
              <br />
              Copyright (c) 2017 'Cowboy' Ben Alman
            </li>

            <li>
              <strong>glogg@1.0.0</strong>
              {' '}
              https://github.com/undertakerjs/glogg
              <br />
              Copyright (c) 2014 Blaine Bublitz
            </li>

            <li>
              <strong>gonzales-pe-sl@4.2.3 gonzales-pe@4.2.3</strong>
              {' '}
              https://github.com/DanPurdy/gonzales-pe
              <br />
              Copyright (C) 2012 by Sergey Kryzhanovsky
            </li>

            <li>
              <strong>graceful-readlink@1.0.1</strong>
              {' '}
              https://github.com/zhiyelee/graceful-readlink
              <br />
              Copyright (c) 2015 Zhiye Li
            </li>

            <li>
              <strong>grunt-mocha-test@0.13.3</strong>
              {' '}
              https://github.com/pghalliday/grunt-mocha-test
              <br />
              Copyright (c) 2016 Peter Halliday
            </li>

            <li>
              <strong>gulp-eslint@4.0.1</strong>
              {' '}
              https://github.com/adametry/gulp-eslint
              <br />
              Copyright 2016 ADAMETRY
            </li>

            <li>
              <strong>gulp-sass-lint@1.3.4</strong>
              {' '}
              https://github.com/sasstools/gulp-sass-lint
              <br />
              Copyright (c) 2015 Sam Richard
            </li>

            <li>
              <strong>gulp-util@3.0.8</strong>
              {' '}
              https://github.com/gulpjs/gulp-util
              <br />
              Copyright (c) 2014 Fractal &lt;contact@wearefractal.com&gt;
            </li>

            <li>
              <strong>gulp@3.9.1</strong>
              {' '}
              https://github.com/gulpjs/gulp
              <br />
              Copyright (c) 2013-2016 Fractal &lt;contact@wearefractal.com&gt;
            </li>

            <li>
              <strong>gulplog@1.0.0</strong>
              {' '}
              https://github.com/gulpjs/gulplog
              <br />
              Copyright (c) 2015 Blaine Bublitz, Eric Schoffstall and other contributors
            </li>

            <li>
              <strong>gzip-size@3.0.0</strong>
              {' '}
              https://github.com/sindresorhus/gzip-size
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>gzip-size@4.1.0</strong>
              {' '}
              https://github.com/sindresorhus/gzip-size
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>handle-thing@1.2.5</strong>
              {' '}
              https://github.com/indutny/handle-thing
              <br />
              Copyright Fedor Indutny, 2015.
            </li>

            <li>
              <strong>has-ansi@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/has-ansi
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>has-ansi@3.0.0</strong>
              {' '}
              https://github.com/chalk/has-ansi
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>has-binary2@1.0.2</strong>
              <br />
              Copyright (c) 2014 Kevin Roark
            </li>

            <li>
              <strong>has-binary@0.1.7</strong>
              <br />
              Copyright (c) 2014 Kevin Roark
            </li>

            <li>
              <strong>has-color@0.1.7</strong>
              {' '}
              https://github.com/sindresorhus/has-color
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>has-cors@1.1.0</strong>
              {' '}
              https://github.com/component/has-cors
            </li>

            <li>
              <strong>has-flag@1.0.0</strong>
              {' '}
              https://github.com/sindresorhus/has-flag
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>has-flag@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/has-flag
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>has-flag@3.0.0</strong>
              {' '}
              https://github.com/sindresorhus/has-flag
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>has-gulplog@0.1.0</strong>
              {' '}
              https://github.com/gulpjs/has-gulplog
              <br />
              Copyright (c) 2015 gulp
            </li>

            <li>
              <strong>has-own@1.0.0</strong>
              {' '}
              https://github.com/pebble/has-own
              <br />
              Copyright (c) 2014 Pebble Technology
            </li>

            <li>
              <strong>has-value@0.3.1</strong>
              {' '}
              https://github.com/jonschlinkert/has-value
              <br />
              Copyright (c) 2014-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>has-value@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/has-value
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert
            </li>

            <li>
              <strong>has-values@0.1.4</strong>
              {' '}
              https://github.com/jonschlinkert/has-values
              <br />
              Copyright (c) 2014-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>has-values@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/has-values
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert
            </li>

            <li>
              <strong>has@1.0.1</strong>
              {' '}
              https://github.com/tarruda/has
              <br />
              Copyright (c) 2013 Thiago de Arruda
            </li>

            <li>
              <strong>hash-base@2.0.2</strong>
              {' '}
              https://github.com/crypto-browserify/hash-base
              <br />
              Copyright (c) 2016 Kirill Fomichev
            </li>

            <li>
              <strong>hash-base@3.0.4</strong>
              {' '}
              https://github.com/crypto-browserify/hash-base
              <br />
              Copyright (c) 2016 Kirill Fomichev
            </li>

            <li>
              <strong>hash.js@1.1.3</strong>
              {' '}
              https://github.com/indutny/hash.js
              <br />
              Copyright Fedor Indutny, 2014.
            </li>

            <li>
              <strong>hasha@2.2.0</strong>
              {' '}
              https://github.com/sindresorhus/hasha
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>history@4.7.2</strong>
              {' '}
              https://github.com/ReactTraining/history
              <br />
              Copyright (c) 2015-2016 Michael Jackson
            </li>

            <li>
              <strong>hmac-drbg@1.0.1</strong>
              {' '}
              https://github.com/indutny/hmac-drbg
              <br />
              Copyright Fedor Indutny, 2017.
            </li>

            <li>
              <strong>home-or-tmp@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/home-or-tmp
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>home-or-tmp@3.0.0</strong>
              {' '}
              https://github.com/sindresorhus/home-or-tmp
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>homedir-polyfill@1.0.1</strong>
              {' '}
              https://github.com/doowb/homedir-polyfill
              <br />
              Copyright (c) 2016 Brian Woodward
            </li>

            <li>
              <strong>hooker@0.2.3</strong>
              {' '}
              https://github.com/cowboy/javascript-hooker
              <br />
              License Copyright (c) 2012 'Cowboy' Ben Alman
            </li>

            <li>
              <strong>hpack.js@2.1.6</strong>
              {' '}
              https://github.com/indutny/hpack.js
              <br />
              Copyright Fedor Indutny, 2015.
            </li>

            <li>
              <strong>html-comment-regex@1.1.1</strong>
              {' '}
              https://github.com/stevemao/html-comment-regex
              <br />
              Copyright (c) Steve Mao (https://github.com/stevemao)
            </li>

            <li>
              <strong>html-entities@1.2.1</strong>
              {' '}
              https://github.com/mdevils/node-html-entities
              <br />
              Copyright (c) 2013 Dulin Marat
            </li>

            <li>
              <strong>htmlescape@1.1.1</strong>
              {' '}
              https://github.com/zertosh/htmlescape
              <br />
              Copyright (c) 2014 Andres Suarez
            </li>

            <li>
              <strong>http-deceiver@1.2.7</strong>
              {' '}
              https://github.com/indutny/http-deceiver
              <br />
              Copyright Fedor Indutny, 2015.
            </li>

            <li>
              <strong>http-errors@1.6.2</strong>
              {' '}
              https://github.com/jshttp/http-errors
              <br />
              Copyright (c) 2014 Jonathan Ong me@jongleberry.com
              <br />
              Copyright (c) 2016 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>http-parser-js@0.4.9</strong>
              {' '}
              https://github.com/creationix/http-parser-js
              <br />
              Copyright (c) 2015 Tim Caswell (https://github.com/creationix) and other contributors. All rights reserved.
            </li>

            <li>
              <strong>http-proxy-agent@1.0.0</strong>
              {' '}
              https://github.com/TooTallNate/node-http-proxy-agent
              <br />
              Copyright (c) 2013 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
            </li>

            <li>
              <strong>http-proxy-middleware@0.17.4</strong>
              {' '}
              https://github.com/chimurai/http-proxy-middleware
              <br />
              Copyright (c) 2015 Steven Chim
            </li>

            <li>
              <strong>http-proxy@1.16.2</strong>
              {' '}
              https://github.com/nodejitsu/node-http-proxy
              <br />
              Copyright (c) 2010-2016 Charlie Robbins, Jarrett Cruger & the Contributors.
            </li>

            <li>
              <strong>http-signature@1.1.1 http-signature@1.2.0</strong>
              {' '}
              https://github.com/joyent/node-http-signature
              <br />
              Copyright Joyent, Inc. All rights reserved.
            </li>

            <li>
              <strong>httpntlm@1.6.1</strong>
              {' '}
              https://github.com/SamDecrock/node-http-ntlm
              <br />
              Copyright (c) 2013 Sam Decrock &lt;sam.decrock@gmail.com&gt;
            </li>

            <li>
              <strong>httpreq@0.4.24</strong>
              {' '}
              https://github.com/SamDecrock/node-httpreq
              <br />
              Copyright (c) 2017 Sam Decrock &lt;sam.decrock@gmail.com&gt;
            </li>

            <li>
              <strong>https-browserify@1.0.0</strong>
              {' '}
              https://github.com/substack/https-browserify
              <br />
              Copyright (c) James Halliday
            </li>

            <li>
              <strong>https-proxy-agent@1.0.0</strong>
              {' '}
              https://github.com/TooTallNate/node-https-proxy-agent
              <br />
              Copyright (c) 2013 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
            </li>

            <li>
              <strong>iconv-lite@0.4.15 iconv-lite@0.4.19</strong>
              {' '}
              https://github.com/ashtuchkin/iconv-lite
              <br />
              Copyright (c) 2011 Alexander Shtuchkin
            </li>

            <li>
              <strong>iferr@0.1.5</strong>
              {' '}
              https://github.com/shesek/iferr
              <br />
              Copyright (c) 2014 Nadav Ivgi
            </li>

            <li>
              <strong>ignore@3.3.7</strong>
              {' '}
              https://github.com/kaelzhang/node-ignore
              <br />
              Copyright (c) 2013 Kael Zhang &lt;i@kael.me&gt;, contributors http://kael.me/
            </li>

            <li>
              <strong>imagesloaded@4.1.4</strong>
              {' '}
              https://github.com/desandro/imagesloaded
              <br />
              Copyright (c) 2018 David DeSandro
            </li>

            <li>
              <strong>immutable@3.8.2</strong>
              {' '}
              https://github.com/facebook/immutable-js
              <br />
              Copyright (c) 2014-present, Facebook, Inc.
            </li>

            <li>
              <strong>import-local@1.0.0</strong>
              {' '}
              https://github.com/sindresorhus/import-local
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>imurmurhash@0.1.4</strong>
              {' '}
              https://github.com/jensyt/imurmurhash-js
              <br />
              Copyright (c) 2013 Gary Court, Jens Taylor
            </li>

            <li>
              <strong>indent-string@2.1.0 indent-string@3.2.0</strong>
              {' '}
              https://github.com/sindresorhus/indent-string
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>indexes-of@1.0.1</strong>
              {' '}
              https://github.com/dominictarr/indexes-of
              <br />
              Copyright (c) 2013 Dominic Tarr
            </li>

            <li>
              <strong>indexof@0.0.1</strong>
              {' '}
              https://github.com/component/indexof
              <br />
              Copyright (c) 2012 TJ Holowaychuk
            </li>

            <li>
              <strong>inflection@1.10.0 inflection@1.3.8</strong>
              {' '}
              https://github.com/dreamerslab/node.inflection
              <br />
              Copyright (c) 2011 dreamerslab &lt;ben@dreamerslab.com&gt;
            </li>

            <li>
              <strong>inline-source-map@0.6.2</strong>
              {' '}
              https://github.com/thlorenz/inline-source-map
              <br />
              Copyright 2013 Thorsten Lorenz.  All rights reserved.
            </li>

            <li>
              <strong>inquirer@0.12.0</strong>
              {' '}
              https://github.com/sboudrias/Inquirer.js
              <br />
              Copyright (c) 2015 Simon Boudrias (twitter: @vaxilart)
            </li>

            <li>
              <strong>inquirer@3.3.0 inquirer@5.0.0</strong>
              {' '}
              https://github.com/SBoudrias/Inquirer.js
              <br />
              Copyright (c) 2016 Simon Boudrias (twitter: [@vaxilart](https://twitter.com/Vaxilart))
            </li>

            <li>
              <strong>insert-module-globals@7.0.1</strong>
              {' '}
              https://github.com/substack/insert-module-globals
            </li>

            <li>
              <strong>internal-ip@1.2.0</strong>
              {' '}
              https://github.com/sindresorhus/internal-ip
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>interpret@1.1.0</strong>
              {' '}
              https://github.com/tkellen/node-interpret
              <br />
              Copyright (c) 2014 Tyler Kellen
            </li>

            <li>
              <strong>invert-kv@1.0.0</strong>
              {' '}
              https://github.com/sindresorhus/invert-kv
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>ip@1.0.1 ip@1.1.5</strong>
              {' '}
              https://github.com/indutny/node-ip
              <br />
              Copyright Fedor Indutny, 2012.
            </li>

            <li>
              <strong>ipaddr.js@1.5.2 ipaddr.js@1.5.4</strong>
              {' '}
              https://github.com/whitequark/ipaddr.js
              <br />
              Copyright (C) 2011-2017 whitequark &lt;whitequark@whitequark.org&gt;
            </li>

            <li>
              <strong>irregular-plurals@1.4.0</strong>
              {' '}
              https://github.com/sindresorhus/irregular-plurals
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>is-absolute-url@2.1.0</strong>
              {' '}
              https://github.com/sindresorhus/is-absolute-url
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>is-absolute@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-absolute
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert.
              <br />
              Copyright (c) 2009-2014, TJ Holowaychuk
            </li>

            <li>
              <strong>is-accessor-descriptor@0.1.6</strong>
              {' '}
              https://github.com/jonschlinkert/is-accessor-descriptor
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>is-accessor-descriptor@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-accessor-descriptor
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>is-arrayish@0.2.1</strong>
              {' '}
              https://github.com/qix-/node-is-arrayish
              <br />
              Copyright (c) 2015 JD Ballard
            </li>

            <li>
              <strong>is-arrayish@0.3.1</strong>
              {' '}
              https://github.com/qix-/node-is-arrayish
              <br />
              Copyright (c) 2015 JD Ballard
            </li>

            <li>
              <strong>is-binary-path@1.0.1</strong>
              {' '}
              https://github.com/sindresorhus/is-binary-path
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>is-binary-path@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/is-binary-path
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>is-buffer@1.1.6</strong>
              {' '}
              https://github.com/feross/is-buffer
              <br />
              Copyright (c) Feross Aboukhadijeh
            </li>

            <li>
              <strong>is-builtin-module@1.0.0</strong>
              {' '}
              https://github.com/sindresorhus/is-builtin-module
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>is-callable@1.1.3</strong>
              {' '}
              https://github.com/ljharb/is-callable
              <br />
              Copyright (c) 2015 Jordan Harband
            </li>

            <li>
              <strong>is-data-descriptor@0.1.4</strong>
              {' '}
              https://github.com/jonschlinkert/is-data-descriptor
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>is-data-descriptor@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-data-descriptor
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>is-date-object@1.0.1</strong>
              {' '}
              https://github.com/ljharb/is-date-object
              <br />
              Copyright (c) 2015 Jordan Harband
            </li>

            <li>
              <strong>is-descriptor@0.1.6 is-descriptor@1.0.2</strong>
              {' '}
              https://github.com/jonschlinkert/is-descriptor
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>is-directory@0.3.1</strong>
              {' '}
              https://github.com/jonschlinkert/is-directory
              <br />
              Copyright (c) 2014-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>is-dotfile@1.0.3 is-dotfile@2.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-dotfile
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert
            </li>

            <li>
              <strong>is-equal-shallow@0.1.3</strong>
              {' '}
              https://github.com/jonschlinkert/is-equal-shallow
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>is-extendable@0.1.1</strong>
              {' '}
              https://github.com/jonschlinkert/is-extendable
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>is-extendable@1.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/is-extendable
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>is-extglob@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-extglob
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert.
            </li>

            <li>
              <strong>is-extglob@2.1.1</strong>
              {' '}
              https://github.com/jonschlinkert/is-extglob
              <br />
              Copyright (c) 2014-2016, Jon Schlinkert
            </li>

            <li>
              <strong>is-finite@1.0.2</strong>
              {' '}
              https://github.com/sindresorhus/is-finite
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>is-fullwidth-code-point@1.0.0</strong>
              {' '}
              https://github.com/sindresorhus/is-fullwidth-code-point
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>is-fullwidth-code-point@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/is-fullwidth-code-point
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>is-glob@2.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/is-glob
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert.
            </li>

            <li>
              <strong>is-glob@3.1.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-glob
              <br />
              Copyright (c) 2014-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>is-glob@4.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-glob
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>is-my-json-valid@2.17.1</strong>
              {' '}
              https://github.com/mafintosh/is-my-json-valid
              <br />
              Copyright (c) 2014 Mathias Buus
            </li>

            <li>
              <strong>is-number@0.1.1</strong>
              {' '}
              https://github.com/jonschlinkert/is-number
              <br />
              Copyright (c) 2014 Jon Schlinkert, contributors.
            </li>

            <li>
              <strong>is-number@2.1.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-number
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert.
            </li>

            <li>
              <strong>is-number@3.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-number
              <br />
              Copyright (c) 2014-2016, Jon Schlinkert
            </li>

            <li>
              <strong>is-number@4.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-number
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>is-obj@1.0.1</strong>
              {' '}
              https://github.com/sindresorhus/is-obj
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>is-odd@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-odd
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert
            </li>

            <li>
              <strong>is-path-cwd@1.0.0 is-path-in-cwd@1.0.0</strong>
              {' '}
              https://github.com/sindresorhus/is-path-in-cwd
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>is-path-inside@1.0.1</strong>
              {' '}
              https://github.com/sindresorhus/is-path-inside
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>is-plain-obj@1.1.0</strong>
              {' '}
              https://github.com/sindresorhus/is-plain-obj
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>is-plain-object@2.0.4</strong>
              {' '}
              https://github.com/jonschlinkert/is-plain-object
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>is-posix-bracket@0.1.1</strong>
              {' '}
              https://github.com/jonschlinkert/is-posix-bracket
              <br />
              Copyright (c) 2015-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>is-primitive@2.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-primitive
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert.
            </li>

            <li>
              <strong>is-primitive@3.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-primitive
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>is-promise@2.1.0</strong>
              {' '}
              https://github.com/then/is-promise
              <br />
              Copyright (c) 2014 Forbes Lindesay
            </li>

            <li>
              <strong>is-property@1.0.2</strong>
              {' '}
              https://github.com/mikolalysenko/is-property
              <br />
              Copyright (c) 2013 Mikola Lysenko
            </li>

            <li>
              <strong>is-regex@1.0.4</strong>
              {' '}
              https://github.com/ljharb/is-regex
              <br />
              Copyright (c) 2014 Jordan Harband
            </li>

            <li>
              <strong>is-relative@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-relative
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>is-resolvable@1.0.1</strong>
              {' '}
              https://github.com/shinnn/is-resolvable
              <br />
              Copyright (c) 2014 - 2016 Shinnosuke Watanabe
            </li>

            <li>
              <strong>is-stream@1.1.0</strong>
              {' '}
              https://github.com/sindresorhus/is-stream
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>is-svg@2.1.0</strong>
              {' '}
              https://github.com/sindresorhus/is-svg
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>is-symbol@1.0.1</strong>
              {' '}
              https://github.com/ljharb/is-symbol
              <br />
              Copyright (c) 2015 Jordan Harband
            </li>

            <li>
              <strong>is-typedarray@1.0.0</strong>
              {' '}
              https://github.com/hughsk/is-typedarray
            </li>

            <li>
              <strong>is-unc-path@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/is-unc-path
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>is-utf8@0.2.1</strong>
              {' '}
              https://github.com/wayfind/is-utf8
              <br />
              Copyright (C) 2014 Wei Fanzhe
            </li>

            <li>
              <strong>is-windows@1.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/is-windows
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert
            </li>

            <li>
              <strong>is-wsl@1.1.0</strong>
              {' '}
              https://github.com/sindresorhus/is-wsl
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>isarray@0.0.1 isarray@1.0.0 isarray@2.0.1 isarray@2.0.2</strong>
              {' '}
              https://github.com/juliangruber/isarray
              <br />
              Copyright (c) 2013 Julian Gruber &lt;julian@juliangruber.com&gt;
            </li>

            <li>
              <strong>isbinaryfile@3.0.2</strong>
              {' '}
              https://github.com/gjtorikian/isBinaryFile
              <br />
              Copyright (c) 2017 Garen J. Torikian
            </li>

            <li>
              <strong>isobject@2.1.0</strong>
              {' '}
              https://github.com/jonschlinkert/isobject
              <br />
              Copyright (c) 2014-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>isobject@3.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/isobject
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>isomorphic-fetch@2.2.1</strong>
              {' '}
              https://github.com/matthew-andrews/isomorphic-fetch
              <br />
              Copyright (c) 2015 Matt Andrews
            </li>

            <li>
              <strong>isstream@0.1.2</strong>
              {' '}
              https://github.com/rvagg/isstream
              <br />
              Copyright (c) 2015 Rod Vagg
            </li>

            <li>
              <strong>jasmine-core@2.8.0</strong>
              {' '}
              https://github.com/jasmine/jasmine
              <br />
              Copyright (c) 2008-2017 Pivotal Labs.
            </li>

            <li>
              <strong>jasmine@2.8.0</strong>
              {' '}
              https://github.com/jasmine/jasmine-npm
              <br />
              Copyright (c) 2008-2017 Pivotal Labs. This software is licensed under the MIT License.
            </li>

            <li>
              <strong>jodid25519@1.0.2</strong>
              {' '}
              https://github.com/meganz/jodid25519
              <br />
              Copyright (c) 2012 Ron Garret Copyright (c) 2007, 2013, 2014 Michele Bini
              <br />
              Copyright (c) 2014 Mega Limited
            </li>

            <li>
              <strong>jquery@3.2.1</strong>
              {' '}
              https://github.com/jquery/jquery
              <br />
              Copyright JS Foundation and other contributors, https://js.foundation/
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/jquery/jquery
            </li>

            <li>
              <strong>js-tokens@3.0.2</strong>
              {' '}
              https://github.com/lydell/js-tokens
              <br />
              Copyright (c) 2014, 2015, 2016, 2017 Simon Lydell
            </li>

            <li>
              <strong>js-yaml@3.10.0 js-yaml@3.7.0</strong>
              {' '}
              https://github.com/nodeca/js-yaml
              <br />
              Copyright (C) 2011-2015 by Vitaly Puzrin
            </li>

            <li>
              <strong>jsbn@0.1.1 jsbn@1.1.0</strong>
              {' '}
              https://github.com/andyperlitch/jsbn
              <br />
              Copyright (c) 2003-2005  Tom Wu. All Rights Reserved.
            </li>

            <li>
              <strong>jsesc@0.5.0 jsesc@1.3.0 jsesc@2.5.1</strong>
              {' '}
              https://github.com/mathiasbynens/jsesc
              <br />
              Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;
            </li>

            <li>
              <strong>json-loader@0.5.7</strong>
              {' '}
              https://github.com/webpack/json-loader
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>json-parse-better-errors@1.0.1</strong>
              {' '}
              https://github.com/zkat/json-parse-better-errors
              <br />
              Copyright 2017 Kat MarchÃ¡n
            </li>

            <li>
              <strong>json-schema-traverse@0.3.1</strong>
              {' '}
              https://github.com/epoberezkin/json-schema-traverse
              <br />
              Copyright (c) 2017 Evgeny Poberezkin
            </li>

            <li>
              <strong>json-stable-stringify-without-jsonify@1.0.1</strong>
              {' '}
              https://github.com/samn/json-stable-stringify
            </li>

            <li>
              <strong>json-stable-stringify@0.0.1 json-stable-stringify@1.0.1</strong>
              {' '}
              https://github.com/substack/json-stable-stringify
            </li>

            <li>
              <strong>json3@3.3.2</strong>
              {' '}
              https://github.com/bestiejs/json3
              <br />
              Copyright (c) 2012-2014 Kit Cambridge. http://kitcambridge.be/
            </li>

            <li>
              <strong>json5@0.5.1</strong>
              {' '}
              https://github.com/aseemk/json5
              <br />
              Copyright (c) 2012-2016 Aseem Kishore, and [others](https://github.com/aseemk/json5/contributors).
            </li>

            <li>
              <strong>jsonfile@2.4.0 jsonfile@3.0.1 jsonfile@4.0.0</strong>
              {' '}
              https://github.com/jprichardson/node-jsonfile
              <br />
              Copyright (c) 2012-2015, JP Richardson &lt;jprichardson@gmail.com&gt;
            </li>

            <li>
              <strong>jsonparse@1.3.1</strong>
              {' '}
              https://github.com/creationix/jsonparse
              <br />
              Copyright (c) 2012 Tim Caswell
            </li>

            <li>
              <strong>jsonpointer@4.0.1</strong>
              {' '}
              https://github.com/janl/node-jsonpointer
              <br />
              Copyright (c) 2011-2015 Jan Lehnardt &lt;jan@apache.org&gt; & Marc Bachmann &lt;https://github.com/marcbachmann&gt;
            </li>

            <li>
              <strong>jsprim@1.4.0 jsprim@1.4.1 jsprim@2.0.0</strong>
              {' '}
              https://github.com/joyent/node-jsprim
              <br />
              Copyright (c) 2012, Joyent, Inc. All rights reserved.
            </li>

            <li>
              <strong>jsx-ast-utils@2.0.1</strong>
              {' '}
              https://github.com/evcohen/jsx-ast-utils
              <br />
              Copyright (c) 2016 Ethan Cohen
            </li>

            <li>
              <strong>kind-of@1.1.0 kind-of@2.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/kind-of
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert.
            </li>

            <li>
              <strong>kind-of@3.2.2 kind-of@4.0.0 kind-of@5.1.0 kind-of@6.0.2</strong>
              {' '}
              https://github.com/jonschlinkert/kind-of
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>klaw@1.3.1 klaw@2.1.1</strong>
              {' '}
              https://github.com/jprichardson/node-klaw
              <br />
              Copyright (c) 2015-2016 JP Richardson
            </li>

            <li>
              <strong>known-css-properties@0.3.0</strong>
              {' '}
              https://github.com/betit/known-css-properties
              <br />
              Copyright (c) 2017 Mavrix Technologies
            </li>

            <li>
              <strong>labeled-stream-splicer@2.0.0</strong>
              {' '}
              https://github.com/substack/labeled-stream-splicer
            </li>

            <li>
              <strong>lazy-cache@0.2.7</strong>
              {' '}
              https://github.com/jonschlinkert/lazy-cache
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>lazy-cache@1.0.4 lazy-cache@2.0.2</strong>
              {' '}
              https://github.com/jonschlinkert/lazy-cache
              <br />
              Copyright (c) 2015-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>lcid@1.0.0</strong>
              {' '}
              https://github.com/sindresorhus/lcid
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>levn@0.3.0</strong>
              {' '}
              https://github.com/gkz/levn
              <br />
              Copyright (c) George Zahariev
            </li>

            <li>
              <strong>lexical-scope@1.2.0</strong>
              {' '}
              https://github.com/substack/lexical-scope
            </li>

            <li>
              <strong>libbase64@0.1.0</strong>
              {' '}
              https://github.com/andris9/libbase64
              <br />
              Copyright (c) 2014 Andris Reinman
            </li>

            <li>
              <strong>libmime@3.0.0</strong>
              {' '}
              https://github.com/andris9/libmime
              <br />
              Copyright (c) 2014-2016 Andris Reinman
            </li>

            <li>
              <strong>libqp@1.1.0</strong>
              {' '}
              https://github.com/andris9/libqp
              <br />
              Copyright (c) 2014 Andris Reinman
            </li>

            <li>
              <strong>liftoff@2.5.0</strong>
              {' '}
              https://github.com/js-cli/js-liftoff
              <br />
              Copyright (c) 2014 Tyler Kellen
            </li>

            <li>
              <strong>load-json-file@1.1.0 load-json-file@2.0.0 load-json-file@4.0.0</strong>
              {' '}
              https://github.com/sindresorhus/load-json-file
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>loader-runner@2.3.0</strong>
              {' '}
              https://github.com/webpack/loader-runner
            </li>

            <li>
              <strong>loader-utils@0.2.17</strong>
              {' '}
              https://github.com/webpack/loader-utils
              <br />
              Copyright (c) 2012 - 2015 Tobias Koppers
            </li>

            <li>
              <strong>loader-utils@1.1.0</strong>
              {' '}
              https://github.com/webpack/loader-utils
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>locate-path@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/locate-path
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>lodash-es@4.17.4</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright JS Foundation and other contributors &lt;https://js.foundation/&gt;
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash._basecopy@3.0.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash._baseslice@4.0.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2016 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash._basetostring@3.0.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash._basetostring@4.12.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash._basevalues@3.0.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js 1.7.0, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash._getnative@3.9.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash._isiterateecall@3.0.9</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash._reescape@3.0.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js 1.7.0, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash._reevaluate@3.0.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js 1.7.0, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash._reinterpolate@3.0.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js 1.7.0, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash._root@3.0.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2016 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash.assign@4.2.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.camelcase@4.3.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.capitalize@4.2.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.clonedeep@4.5.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.escape@3.2.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2016 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash.escape@4.0.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.isarguments@3.1.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.isarray@3.0.4</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash.isarray@4.0.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2016 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash.iserror@3.1.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2016 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash.kebabcase@4.1.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.keys@3.1.2 </strong>
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash.keys@4.2.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.memoize@3.0.4</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash.memoize@4.1.2</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.mergewith@4.6.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.reescape@3.0.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js 1.7.0, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash.reevaluate@3.0.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js 1.7.0, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash.reinterpolate@3.0.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js 1.7.0, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash.restparam@3.6.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash.tail@4.1.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.template@3.6.2</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash.template@4.4.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.templatesettings@3.1.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2016 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash.templatesettings@4.1.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.tostring@4.1.4</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.uniq@4.5.0</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash.upperfirst@4.3.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright jQuery Foundation and other contributors &lt;https://jquery.org/&gt;
              {' '}
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>lodash@1.0.2</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2013 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js 1.4.3, copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc. &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash@3.10.1</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright 2012-2015 The Dojo Foundation &lt;http://dojofoundation.org/&gt;
              <br />
              Based on Underscore.js, copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
            </li>

            <li>
              <strong>lodash@4.17.4</strong>
              {' '}
              https://github.com/lodash/lodash
              <br />
              Copyright JS Foundation and other contributors &lt;https://js.foundation/&gt;
              <br />
              Based on Underscore.js, copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors &lt;http://underscorejs.org/&gt;
              <br />
              This software consists of voluntary contributions made by many individuals.
              <br />
              For exact contribution history, see the revision history available at https://github.com/lodash/lodash
            </li>

            <li>
              <strong>log-symbols@1.0.2 log-symbols@2.1.0</strong>
              {' '}
              https://github.com/sindresorhus/log-symbols
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>loggly@1.1.1</strong>
              {' '}
              https://github.com/winstonjs/node-loggly
              <br />
              Copyright (c) 2010 Charlie Robbins
            </li>

            <li>
              <strong>loglevel@1.6.1</strong>
              {' '}
              https://github.com/pimterry/loglevel
              <br />
              Copyright (c) 2013 Tim Perry.
            </li>

            <li>
              <strong>loglevelnext@1.0.3</strong>
              {' '}
              https://github.com/shellscape/loglevelnext
              <br />
              Copyright (c) 2017 Andrew Powell Portions Copyright (c) 2013 Tim Perry
            </li>

            <li>
              <strong>longest@1.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/longest
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert.
            </li>

            <li>
              <strong>loose-envify@1.3.1</strong>
              {' '}
              https://github.com/zertosh/loose-envify
              <br />
              Copyright (c) 2015 Andres Suarez &lt;zertosh@gmail.com&gt;
            </li>

            <li>
              <strong>loud-rejection@1.6.0</strong>
              {' '}
              https://github.com/sindresorhus/loud-rejection
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>lru-cache@2.2.4</strong>
              {' '}
              https://github.com/isaacs/node-lru-cache
              <br />
              Copyright 2009, 2010, 2011 Isaac Z. Schlueter. All rights reserved.
            </li>

            <li>
              <strong>macaddress@0.2.8</strong>
              {' '}
              https://github.com/scravy/node-macaddress
            </li>

            <li>
              <strong>mailcomposer@4.0.1</strong>
              {' '}
              https://github.com/andris9/mailcomposer
              <br />
              Copyright (c) 2012-2017 Andris Reinman
            </li>

            <li>
              <strong>mailgun-js@0.7.15</strong>
              {' '}
              https://github.com/bojand/mailgun-js
              <br />
              Copyright (c) 2012 - 2014 OneLobby &lt;http://www.onelobby.com&gt;
            </li>

            <li>
              <strong>make-dir@1.1.0 </strong>
              https://github.com/sindresorhus/make-dir
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>make-iterator@1.0.</strong>
              {' '}
              https://github.com/jonschlinkert/make-iterator
              <br />
              Copyright (c) 2014, 2016-2017, Jon Schlinkert
            </li>

            <li>
              <strong>map-cache@0.2.2</strong>
              {' '}
              https://github.com/jonschlinkert/map-cache
              <br />
              Copyright (c) 2015-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>map-obj@1.0.1 map-obj@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/map-obj
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>map-visit@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/map-visit
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert
            </li>

            <li>
              <strong>masonry-layout@4.2.1</strong>
              {' '}
              https://github.com/desandro/masonry
              <br />
              Copyright (c) 2018 David DeSandro
            </li>

            <li>
              <strong>matchmedia@0.1.2</strong>
              {' '}
              https://github.com/iceddev/matchmedia
              <br />
              Copyright (c) 2015 Iced Development
            </li>

            <li>
              <strong>matchmediaquery@0.2.1</strong>
              {' '}
              https://github.com/ncochard/matchmediaquery
              <br />
              Copyright (c) 2017 ncochard
            </li>

            <li>
              <strong>math-expression-evaluator@1.2.17</strong>
              {' '}
              https://github.com/redhivesoftware/math-expression-evaluator.git#readme
              <br />
              Copyright (c) 2015 Ankit G.
            </li>

            <li>
              <strong>math-random@1.0.1</strong>
              {' '}
              https://github.com/michaelrhodes/math-random
            </li>

            <li>
              <strong>md5.js@1.3.4</strong>
              {' '}
              https://github.com/crypto-browserify/md5.js
              <br />
              Copyright (c) 2016 Kirill Fomichev
            </li>

            <li>
              <strong>media-typer@0.3.0</strong>
              {' '}
              https://github.com/jshttp/media-typer
              <br />
              Copyright (c) 2014 Douglas Christopher Wilson
            </li>

            <li>
              <strong>mem@1.1.0</strong>
              {' '}
              https://github.com/sindresorhus/mem
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>memory-fs@0.4.1</strong>
              {' '}
              https://github.com/webpack/memory-fs
              <br />
              Copyright (c) 2012-2014 Tobias Koppers
            </li>

            <li>
              <strong>meow@3.7.0 meow@4.0.0</strong>
              {' '}
              https://github.com/sindresorhus/meow
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>merge-descriptors@1.0.1</strong>
              {' '}
              https://github.com/component/merge-descriptors
              <br />
              Copyright (c) 2013 Jonathan Ong &lt;me@jongleberry.com&gt;
              <br />
              Copyright (c) 2015 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>merge@1.2.0</strong>
              {' '}
              https://github.com/yeikos/js.merge
              <br />
              Copyright (c) 2014 yeikos - http://www.yeikos.com
            </li>

            <li>
              <strong>methods@1.1.2</strong>
              {' '}
              https://github.com/jshttp/methods
              <br />
              Copyright (c) 2013-2014 TJ Holowaychuk &lt;tj@vision-media.ca&gt;
              <br />
              Copyright (c) 2015-2016 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>micromatch@2.3.11 micromatch@3.1.5</strong>
              {' '}
              https://github.com/jonschlinkert/micromatch
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert.
            </li>

            <li>
              <strong>miller-rabin@4.0.1</strong>
              {' '}
              https://github.com/indutny/miller-rabin
              <br />
              Copyright Fedor Indutny, 2014.
            </li>

            <li>
              <strong>mime-db@1.27.0 mime-db@1.30.0 mime-db@1.32.0</strong>
              {' '}
              https://github.com/jshttp/mime-db
              <br />
              Copyright (c) 2014 Jonathan Ong me@jongleberry.com
            </li>

            <li>
              <strong>mime-types@2.1.15 mime-types@2.1.17</strong>
              {' '}
              https://github.com/jshttp/mime-types
              <br />
              Copyright (c) 2014 Jonathan Ong &lt;me@jongleberry.com&gt;
              <br />
              Copyright (c) 2015 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>mime@1.4.1 mime@1.6.0 mime@2.2.0</strong>
              {' '}
              https://github.com/broofa/node-mime
              <br />
              Copyright (c) 2010 Benjamin Thomas, Robert Kieffer
            </li>

            <li>
              <strong>mimic-fn@1.1.0</strong>
              {' '}
              https://github.com/sindresorhus/mimic-fn
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>minimalistic-crypto-utils@1.0.1</strong>
              {' '}
              https://github.com/indutny/minimalistic-crypto-utils
              <br />
              Copyright Fedor Indutny, 2017.
            </li>

            <li>
              <strong>minimatch@0.2.14</strong>
              {' '}
              https://github.com/isaacs/minimatch
              <br />
              Copyright 2009, 2010, 2011 Isaac Z. Schlueter. All rights reserved.
            </li>

            <li>
              <strong>minimist-options@3.0.2</strong>
              {' '}
              https://github.com/vadimdemedes/minimist-options
              <br />
              Copyright (c) Vadim Demedes &lt;vdemedes@gmail.com&gt; (vadimdemedes.com)
            </li>

            <li>
              <strong>minimist@0.0.10 minimist@0.0.8 minimist@1.1.3 minimist@1.2.0</strong>
              {' '}
              https://github.com/substack/minimist
            </li>

            <li>
              <strong>minizlib@1.1.0</strong>
              {' '}
              https://github.com/isaacs/minizlib
              <br />
              Minizlib was created by Isaac Z. Schlueter.
              <br />
              It is a derivative work of the Node.js project.
              <br />
              Copyright Isaac Z. Schlueter and Contributors Copyright Node.js contributors. All rights reserved.
              <br />
              Copyright Joyent, Inc. and other Node contributors. All rights reserved.
            </li>

            <li>
              <strong>mixin-deep@1.3.0</strong>
              {' '}
              https://github.com/jonschlinkert/mixin-deep
              <br />
              Copyright (c) 2014-2015, 2017, Jon Schlinkert.
            </li>

            <li>
              <strong>mixin-object@2.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/mixin-object
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert.
            </li>

            <li>
              <strong>mixin-object@3.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/mixin-object
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>mkdirp@0.5.0 mkdirp@0.5.1</strong>
              {' '}
              https://github.com/substack/node-mkdirp
              <br />
              Copyright 2010 James Halliday (mail@substack.net)
            </li>

            <li>
              <strong>module-deps@4.1.1</strong>
              {' '}
              https://github.com/substack/module-deps
            </li>

            <li>
              <strong>moment@2.20.1</strong>
              {' '}
              https://github.com/moment/moment
              <br />
              Copyright (c) JS Foundation and other contributors
            </li>

            <li>
              <strong>ms@0.7.1</strong>
              {' '}
              https://github.com/guille/ms.js
              <br />
              Copyright (c) 2014 Guillermo Rauch &lt;rauchg@gmail.com&gt;
            </li>

            <li>
              <strong>ms@2.0.0 ms@2.1.1</strong>
              {' '}
              https://github.com/zeit/ms
              <br />
              Copyright (c) 2016 Zeit, Inc.
            </li>

            <li>
              <strong>multicast-dns-service-types@1.1.0</strong>
              {' '}
              https://github.com/mafintosh/multicast-dns-service-types
              <br />
              Copyright (c) 2015 Mathias Buus
            </li>

            <li>
              <strong>multicast-dns@6.2.1</strong>
              {' '}
              https://github.com/mafintosh/multicast-dns
              <br />
              Copyright (c) 2015 Mathias Buus
            </li>

            <li>
              <strong>multipipe@0.1.2 multipipe@2.0.1</strong>
              {' '}
              https://github.com/juliangruber/multipipe
              <br />
              Copyright (c) 2014 Segment.io Inc. &lt;friends@segment.io&gt;
              <br />
              Copyright (c) 2014 Julian Gruber &lt;julian@juliangruber.com&gt;
            </li>

            <li>
              <strong>nan@2.8.0</strong>
              {' '}
              https://github.com/nodejs/nan
              <br />
              Copyright (c) 2017 NAN contributors
              <br />
              NAN contributors listed at &lt;https://github.com/nodejs/nan#contributors&gt;
            </li>

            <li>
              <strong>nanomatch@1.2.7</strong>
              {' '}
              https://github.com/micromatch/nanomatch
              <br />
              Copyright (c) 2016-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>natural-compare@1.4.0</strong>
              {' '}
              https://github.com/litejs/natural-compare-lite
              <br />
              Copyright (c) 2012-2015 Lauri Rooden &lt;lauri@rooden.ee&gt;
            </li>

            <li>
              <strong>negotiator@0.6.1</strong>
              {' '}
              https://github.com/jshttp/negotiator
              <br />
              Copyright (c) 2012-2014 Federico Romero
              <br />
              Copyright (c) 2012-2014 Isaac Z. Schlueter
              <br />
              Copyright (c) 2014-2015 Douglas Christopher Wilson
            </li>

            <li>
              <strong>netmask@1.0.6</strong>
              {' '}
              https://github.com/rs/node-netmask
              <br />
              Copyright (c) 2011 Olivier Poitrey &lt;rs@dailymotion.com&gt;
            </li>

            <li>
              <strong>node-fetch@1.7.3</strong>
              {' '}
              https://github.com/bitinn/node-fetch
              <br />
              Copyright (c) 2016 David Frank
            </li>

            <li>
              <strong>node-gyp@3.6.2</strong>
              {' '}
              https://github.com/nodejs/node-gyp
              <br />
              Copyright (c) 2012 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
            </li>

            <li>
              <strong>node-libs-browser@2.1.0</strong>
              {' '}
              https://github.com/webpack/node-libs-browser
              <br />
              Copyright (c) 2012 Tobias Koppers
            </li>

            <li>
              <strong>node-sass@4.7.2</strong>
              {' '}
              https://github.com/sass/node-sass
              <br />
              Copyright (c) 2013-2016 Andrew Nesbitt
            </li>

            <li>
              <strong>node-uuid@1.4.8</strong>
              {' '}
              https://github.com/broofa/node-uuid
              <br />
              Copyright (c)  2010-2012 Robert Kieffer
            </li>

            <li>
              <strong>nodemailer-direct-transport@3.3.2</strong>
              {' '}
              https://github.com/andris9/nodemailer-direct-transport
              <br />
              Copyright (c) 2014-2016 Andris Reinman
            </li>

            <li>
              <strong>nodemailer-fetch@1.6.0</strong>
              {' '}
              https://github.com/nodemailer/nodemailer-fetch
              <br />
              Copyright (c) 2015-2016 Andris Reinman
            </li>

            <li>
              <strong>nodemailer-shared@1.1.0</strong>
              {' '}
              https://github.com/nodemailer/nodemailer-shared
              <br />
              Copyright (c) 2016 Andris Reinman
            </li>

            <li>
              <strong>nodemailer-smtp-pool@2.8.2</strong>
              {' '}
              https://github.com/andris9/nodemailer-smtp-pool
              <br />
              Copyright (c) 2014-2016 Andris Reinman
            </li>

            <li>
              <strong>nodemailer-smtp-transport@2.7.2</strong>
              {' '}
              https://github.com/andris9/nodemailer-smtp-transport
              <br />
              Copyright (c) 2014-2016 Andris Reinman
            </li>

            <li>
              <strong>nodemailer-wellknown@0.1.10</strong>
              {' '}
              https://github.com/andris9/nodemailer-wellknown
              <br />
              Copyright (c) 2014-2016 Andris Reinman
            </li>

            <li>
              <strong>nodemailer@2.7.2</strong>
              {' '}
              https://nodemailer.com/
              <br />
              Copyright (c) 2011-2016 Andris Reinman
            </li>

            <li>
              <strong>normalize-path@2.1.1</strong>
              {' '}
              https://github.com/jonschlinkert/normalize-path
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert
            </li>

            <li>
              <strong>normalize-range@0.1.2</strong>
              {' '}
              https://github.com/jamestalmage/normalize-range
              <br />
              Copyright (c) James Talmage &lt;james@talmage.io&gt; (github.com/jamestalmage)
            </li>

            <li>
              <strong>normalize-url@1.9.1 normalize-url@2.0.1</strong>
              {' '}
              https://github.com/sindresorhus/normalize-url
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>npm-run-path@2.0.2</strong>
              {' '}
              https://github.com/sindresorhus/npm-run-path
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>null-check@1.0.0 null-check@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/null-check
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>null-loader@0.1.1</strong>
              {' '}
              https://github.com/webpack/null-loader
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>num2fraction@1.2.2</strong>
              {' '}
              https://github.com/yisibl/num2fraction
              <br />
              Copyright (c) 2014 PostCSS
            </li>

            <li>
              <strong>number-is-nan@1.0.1</strong>
              {' '}
              https://github.com/sindresorhus/number-is-nan
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>object-assign@3.0.0 object-assign@4.1.1</strong>
              {' '}
              https://github.com/sindresorhus/object-assign
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>object-component@0.0.3</strong>
              {' '}
              https://www.npmjs.com/package/object-component
            </li>

            <li>
              <strong>object-copy@0.1.0</strong>
              {' '}
              https://github.com/jonschlinkert/object-copy
              <br />
              Copyright (c) 2016, Jon Schlinkert.
            </li>

            <li>
              <strong>object-keys@1.0.11</strong>
              {' '}
              https://github.com/ljharb/object-keys
              <br />
              Copyright (C) 2013 Jordan Harband
            </li>

            <li>
              <strong>object-visit@1.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/object-visit
              <br />
              Copyright (c) 2015, 2017, Jon Schlinkert
            </li>

            <li>
              <strong>object.defaults@1.1.0</strong>
              {' '}
              https://github.com/jonschlinkert/object.defaults
              <br />
              Copyright (c) 2014-2015, 2017, Jon Schlinkert
            </li>

            <li>
              <strong>object.getownpropertydescriptors@2.0.3</strong>
              {' '}
              https://github.com/ljharb/object.getownpropertydescriptors
              <br />
              Copyright (c) 2015 Jordan Harband
            </li>

            <li>
              <strong>object.map@1.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/object.map
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert, contributors.
            </li>

            <li>
              <strong>object.omit@2.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/
              <br />
              Copyright (c) 2014-2016, Jon Schlinkert
            </li>

            <li>
              <strong>object.omit@3.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>object.pick@1.3.0</strong>
              {' '}
              https://github.com/jonschlinkert/object.pick
              <br />
              Copyright (c) 2014-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>object.values@1.0.4</strong>
              {' '}
              https://github.com/es-shims/Object.values
              <br />
              Copyright (c) 2015 Jordan Harband
            </li>

            <li>
              <strong>obuf@1.1.1</strong>
              {' '}
              https://github.com/indutny/offset-buffer
              <br />
              Copyright Fedor Indutny, 2015.
            </li>

            <li>
              <strong>on-finished@2.3.0</strong>
              {' '}
              https://github.com/jshttp/on-finished
              <br />
              Copyright (c) 2013 Jonathan Ong &lt;me@jongleberry.com&gt;
              <br />
              Copyright (c) 2014 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>on-headers@1.0.1</strong>
              {' '}
              https://github.com/jshttp/on-headers
              <br />
              Copyright (c) 2014 Douglas Christopher Wilson
            </li>

            <li>
              <strong>onetime@1.1.0 onetime@2.0.1</strong>
              {' '}
              https://github.com/sindresorhus/onetime
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>opener@1.4.3</strong>
              {' '}
              https://github.com/domenic/opener
              <br />
              Copyright (c) 2012–2016 Domenic Denicola &lt;d@domenic.me&gt;
            </li>

            <li>
              <strong>opn@5.1.0</strong>
              {' '}
              https://github.com/sindresorhus/opn
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt;
            </li>

            <li>
              <strong>optimist@0.6.1</strong>
              {' '}
              https://github.com/substack/node-optimist
              <br />
              Copyright 2010 James Halliday (mail@substack.net)
            </li>

            <li>
              <strong>optionator@0.8.2</strong>
              {' '}
              https://github.com/gkz/optionator
              <br />
              Copyright (c) George Zahariev
            </li>

            <li>
              <strong>options@0.0.6</strong>
              {' '}
              https://github.com/einaros/options.js
              <br />
              Copyright (c) 2012 Einar Otto Stangvik &lt;einaros@gmail.com&gt;
            </li>

            <li>
              <strong>orchestrator@0.3.8</strong>
              {' '}
              https://github.com/robrich/orchestrator
              <br />
              Copyright (c) 2013 Richardson & Sons, LLC (http://richardsonandsons.com/)
            </li>

            <li>
              <strong>ordered-read-streams@0.1.0</strong>
              {' '}
              https://github.com/armed/ordered-read-streams
              <br />
              Copyright (c) 2014 Artem Medeusheyev
            </li>

            <li>
              <strong>original@1.0.0</strong>
              {' '}
              https://github.com/unshiftio/original
              <br />
              Copyright (c) 2015 Unshift.io, Arnout Kazemier, the Contributors.
            </li>

            <li>
              <strong>os-browserify@0.3.0</strong>
              {' '}
              https://github.com/CoderPuppy/os-browserify
              <br />
              Copyright (c) 2017 CoderPuppy
            </li>

            <li>
              <strong>os-homedir@1.0.2</strong>
              {' '}
              https://github.com/sindresorhus/os-homedir
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>os-locale@1.4.0 os-locale@2.1.0</strong>
              {' '}
              https://github.com/sindresorhus/os-locale
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>os-tmpdir@1.0.2</strong>
              {' '}
              https://github.com/sindresorhus/os-tmpdir
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>outlayer@2.1.1</strong>
              {' '}
              https://github.com/metafizzy/outlayer
              <br />
              Copyright (c) 2018 David DeSandro
            </li>

            <li>
              <strong>output-file-sync@2.0.0</strong>
              {' '}
              https://github.com/shinnn/output-file-sync
              <br />
              Copyright (c) 2014 - 2016 Shinnosuke Watanabe
            </li>

            <li>
              <strong>p-finally@1.0.0</strong>
              {' '}
              https://github.com/sindresorhus/p-finally
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>p-limit@1.2.0</strong>
              {' '}
              https://github.com/sindresorhus/p-limit
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>p-locate@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/p-locate
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>p-map@1.2.0</strong>
              {' '}
              https://github.com/sindresorhus/p-map
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>p-try@1.0.0</strong>
              {' '}
              https://github.com/sindresorhus/p-try
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>pac-proxy-agent@1.1.0</strong>
              {' '}
              https://github.com/TooTallNate/node-pac-proxy-agent
              <br />
              Copyright (c) 2014 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
            </li>

            <li>
              <strong>pac-resolver@2.0.0</strong>
              {' '}
              https://github.com/TooTallNate/node-pac-resolver
              <br />
              Copyright (c) 2013 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
            </li>

            <li>
              <strong>parallel-transform@1.1.0</strong>
              {' '}
              https://github.com/mafintosh/parallel-transform
              <br />
              Copyright 2013 Mathias Buus
            </li>

            <li>
              <strong>parents@1.0.1</strong>
              {' '}
              https://github.com/substack/node-parents
            </li>

            <li>
              <strong>parse-filepath@1.0.2</strong>
              {' '}
              https://github.com/jonschlinkert/parse-filepath
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert.
            </li>

            <li>
              <strong>parse-glob@3.0.4</strong>
              {' '}
              https://github.com/jonschlinkert/parse-glob
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>parse-json@2.2.0 parse-json@3.0.0 parse-json@4.0.0</strong>
              {' '}
              https://github.com/sindresorhus/parse-json
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>parse-passwd@1.0.0</strong>
              {' '}
              https://github.com/doowb/parse-passwd
              <br />
              Copyright (c) 2016 Brian Woodward
            </li>

            <li>
              <strong>parsejson@0.0.3</strong>
              {' '}
              https://github.com/get/parsejson
              <br />
              Copyright (c) 2015 Gal Koren
            </li>

            <li>
              <strong>parseqs@0.0.5</strong>
              {' '}
              https://github.com/get/querystring
              <br />
              Copyright (c) 2015 Gal Koren
            </li>

            <li>
              <strong>parseuri@0.0.5</strong>
              {' '}
              https://github.com/get/parseuri
              <br />
              Copyright (c) 2014 Gal Koren
            </li>

            <li>
              <strong>parseurl@1.3.2</strong>
              {' '}
              https://github.com/pillarjs/parseurl
              <br />
              Copyright (c) 2014 Jonathan Ong &lt;me@jongleberry.com&gt;
              <br />
              Copyright (c) 2014-2017 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>pascalcase@0.1.1</strong>
              {' '}
              https://github.com/jonschlinkert/pascalcase
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>path-array@1.0.1</strong>
              {' '}
              https://github.com/TooTallNate/node-path-array
              <br />
              Copyright (c) 2013 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
            </li>

            <li>
              <strong>path-browserify@0.0.0</strong>
              {' '}
              https://github.com/substack/path-browserify
            </li>

            <li>
              <strong>path-dirname@1.0.2</strong>
              {' '}
              https://github.com/es128/path-dirname
              <br />
              Copyright (c) Elan Shanker and Node.js contributors. All rights reserved.
            </li>

            <li>
              <strong>path-exists@2.1.0 path-exists@3.0.0</strong>
              {' '}
              https://github.com/sindresorhus/path-exists
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>path-is-absolute@1.0.1</strong>
              {' '}
              https://github.com/sindresorhus/path-is-absolute
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>path-is-inside@1.0.2</strong>
              {' '}
              https://github.com/domenic/path-is-inside
              <br />
              Copyright © 2013–2016 Domenic Denicola &lt;d@domenic.me&gt;
            </li>

            <li>
              <strong>path-key@2.0.1</strong>
              {' '}
              https://github.com/sindresorhus/path-key
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>path-parse@1.0.5</strong>
              {' '}
              https://github.com/jbgutierrez/path-parse
              <br />
              Copyright (c) Javier Blanco (http://jbgutierrez.info)
            </li>

            <li>
              <strong>path-platform@0.11.15</strong>
              {' '}
              https://github.com/tjfontaine/node-path-platform
              <br />
              Copyright Node.js contributors. All rights reserved.
              <br />
              This license applies to parts of Node.js originating from the
              <br />
              https://github.com/joyent/node repository: Copyright Joyent, Inc. and other Node contributors.
            </li>

            <li>
              <strong>path-proxy@1.0.0</strong>
              {' '}
              https://github.com/jclem/path-proxy
            </li>

            <li>
              <strong>path-root-regex@0.1.2</strong>
              {' '}
              https://github.com/regexhq/path-root-regex
              <br />
              Copyright (c) 2016, Jon Schlinkert.
            </li>

            <li>
              <strong>path-root@0.1.1</strong>
              {' '}
              https://github.com/jonschlinkert/path-root
              <br />
              Copyright (c) 2016, Jon Schlinkert.
            </li>

            <li>
              <strong>path-to-regexp@0.1.7 path-to-regexp@1.7.0 path-to-regexp@2.1.0</strong>
              {' '}
              https://github.com/component/path-to-regexp
              <br />
              Copyright (c) 2014 Blake Embrey (hello@blakeembrey.com)
            </li>

            <li>
              <strong>path-type@1.1.0 path-type@2.0.0 path-type@3.0.0</strong>
              {' '}
              https://github.com/sindresorhus/path-type
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>pbkdf2@3.0.14</strong>
              {' '}
              https://github.com/crypto-browserify/pbkdf2
              <br />
              Copyright (c) 2014 Daniel Cousens
            </li>

            <li>
              <strong>pend@1.2.0</strong>
              {' '}
              https://github.com/andrewrk/node-pend
              <br />
              Copyright (c) 2014 Andrew Kelley
            </li>

            <li>
              <strong>performance-now@0.2.0</strong>
              {' '}
              https://github.com/meryn/performance-now
              <br />
              Copyright (c) 2013 Meryn Stol
            </li>

            <li>
              <strong>performance-now@2.1.0</strong>
              {' '}
              https://github.com/braveg1rl/performance-now
              <br />
              Copyright (c) 2013 Braveg1rl
            </li>

            <li>
              <strong>pify@2.3.0 pify@3.0.0</strong>
              {' '}
              https://github.com/sindresorhus/pify
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>pinkie-promise@2.0.1</strong>
              {' '}
              https://github.com/floatdrop/pinkie-promise
              <br />
              Copyright (c) Vsevolod Strukchinsky &lt;floatdrop@gmail.com&gt; (github.com/floatdrop)
            </li>

            <li>
              <strong>pinkie@2.0.4</strong>
              {' '}
              https://github.com/floatdrop/pinkie
              <br />
              Copyright (c) Vsevolod Strukchinsky &lt;floatdrop@gmail.com&gt; (github.com/floatdrop)
            </li>

            <li>
              <strong>pkg-dir@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/pkg-dir
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>plugin-error@0.1.2</strong>
              {' '}
              https://github.com/jonschlinkert/plugin-error
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>plur@2.1.2</strong>
              {' '}
              https://github.com/sindresorhus/plur
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>pluralize@1.2.1 pluralize@7.0.0</strong>
              {' '}
              https://github.com/blakeembrey/pluralize
              <br />
              Copyright (c) 2013 Blake Embrey (hello@blakeembrey.com)
            </li>

            <li>
              <strong>popper.js@1.12.9</strong>
              {' '}
              https://github.com/FezVrasta/popper.js
              <br />
              Copyright 2016 Federico Zivolo
            </li>

            <li>
              <strong>portfinder@1.0.13</strong>
              {' '}
              https://github.com/indexzero/node-portfinder
              <br />
              Copyright (c) 2012 Charlie Robbins
            </li>

            <li>
              <strong>posix-character-classes@0.1.1</strong>
              {' '}
              https://github.com/jonschlinkert/posix-character-classes
              <br />
              Copyright (c) 2016-2017, Jon Schlinkert
            </li>

            <li>
              <strong>postcss-calc@5.3.1 postcss-calc@6.0.1</strong>
              {' '}
              https://github.com/postcss/postcss-calc
              <br />
              Copyright (c) 2014 Maxime Thirouin
            </li>

            <li>
              <strong>postcss-colormin@2.2.2</strong>
              {' '}
              https://github.com/ben-eb/postcss-colormin
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-convert-values@2.6.1</strong>
              {' '}
              https://github.com/ben-eb/postcss-convert-values
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-discard-comments@2.0.4</strong>
              {' '}
              https://github.com/ben-eb/postcss-discard-comments
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-discard-duplicates@2.1.0</strong>
              {' '}
              https://github.com/ben-eb/postcss-discard-duplicates
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-discard-empty@2.1.0</strong>
              {' '}
              https://github.com/ben-eb/postcss-discard-empty
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-discard-overridden@0.1.1</strong>
              {' '}
              https://github.com/justineo/postcss-discard-overridden
              <br />
              Copyright 2016 Justineo &lt;justice360@gmail.com&gt;
            </li>

            <li>
              <strong>postcss-discard-unused@2.2.3</strong>
              {' '}
              https://github.com/ben-eb/postcss-discard-unused
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-filter-plugins@2.0.2 postcss-filter-plugins@3.0.0</strong>
              {' '}
              https://github.com/postcss/postcss-filter-plugins
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-load-config@1.2.0</strong>
              {' '}
              https://github.com/michael-ciniawsky/postcss-load-config
              <br />
              Copyright (c) Michael Ciniawsky &lt;michael.ciniawsky@gmail.com&gt;
            </li>

            <li>
              <strong>postcss-load-options@1.2.0</strong>
              {' '}
              https://github.com/michael-ciniawsky/postcss-load-options
              <br />
              Copyright (c) 2016 Michael Ciniawsky &lt;michael.ciniawsky@gmail.com&gt;
            </li>

            <li>
              <strong>postcss-load-plugins@2.3.0</strong>
              {' '}
              https://github.com/michael-ciniawsky/postcss-load-plugins
              <br />
              Copyright (c) Michael Ciniawsky &lt;michael.ciniawsky@gmail.com&gt;
            </li>

            <li>
              <strong>postcss-loader@2.0.10</strong>
              {' '}
              https://github.com/postcss/postcss-loader
              <br />
              Copyright 2017 Andrey Sitnik &lt;andrey@sitnik.ru&lt;
            </li>

            <li>
              <strong>postcss-merge-idents@2.1.7</strong>
              {' '}
              https://github.com/ben-eb/postcss-merge-idents
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-merge-longhand@2.0.2 postcss-merge-longhand@3.0.0</strong>
              {' '}
              https://github.com/ben-eb/postcss-merge-longhand
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-merge-rules@2.1.2</strong>
              {' '}
              https://github.com/ben-eb/postcss-merge-rules
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-message-helpers@2.0.0</strong>
              {' '}
              https://github.com/MoOx/postcss-message-helpers
              <br />
              Copyright (c) 2014 Maxime Thirouin
            </li>

            <li>
              <strong>postcss-minify-font-values@1.0.5</strong>
              {' '}
              https://github.com/TrySound/postcss-minify-font-values
              <br />
              Copyright (c) Bogdan Chadkin &lt;trysound@yandex.ru&gt;
            </li>

            <li>
              <strong>postcss-minify-gradients@1.0.5</strong>
              {' '}
              https://github.com/ben-eb/postcss-minify-gradients
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-minify-params@1.2.2</strong>
              {' '}
              https://github.com/ben-eb/postcss-minify-params
              <br />
              Copyright 2015 Bogdan Chadkin &lt;trysound@yandex.ru&gt;
            </li>

            <li>
              <strong>postcss-minify-selectors@2.1.1</strong>
              {' '}
              https://github.com/ben-eb/postcss-minify-selectors
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-modules-local-by-default@1.2.0</strong>
              {' '}
              https://github.com/css-modules/postcss-modules-local-by-default
              <br />
              Copyright 2015 Mark Dalgleish &lt;mark.john.dalgleish@gmail.com&gt;
            </li>

            <li>
              <strong>postcss-normalize-charset@1.1.1</strong>
              {' '}
              https://github.com/ben-eb/postcss-charset
              <br />
              Copyright 2015 Bogdan Chadkin &lt;trysound@yandex.ru&gt;
            </li>

            <li>
              <strong>postcss-normalize-url@3.0.8</strong>
              {' '}
              https://github.com/ben-eb/postcss-normalize-url
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-ordered-values@2.2.3</strong>
              {' '}
              https://github.com/ben-eb/postcss-ordered-values
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-reduce-idents@2.4.0</strong>
              {' '}
              https://github.com/ben-eb/postcss-reduce-idents
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-reduce-initial@1.0.1</strong>
              {' '}
              https://github.com/ben-eb/postcss-reduce-initial
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-reduce-transforms@1.0.4</strong>
              {' '}
              https://github.com/ben-eb/postcss-reduce-transforms
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-reporter@1.4.1</strong>
              {' '}
              https://github.com/postcss/postcss-reporter
              <br />
              Copyright (c) 2015 David Clark
            </li>

            <li>
              <strong>postcss-selector-parser@2.2.3 postcss-selector-parser@3.1.1</strong>
              {' '}
              https://github.com/postcss/postcss-selector-parser
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-svgo@2.1.6</strong>
              {' '}
              https://github.com/ben-eb/postcss-svgo
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-unique-selectors@2.0.2</strong>
              {' '}
              https://github.com/ben-eb/postcss-unique-selectors
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss-value-parser@3.3.0</strong>
              {' '}
              https://github.com/TrySound/postcss-value-parser
              <br />
              Copyright (c) Bogdan Chadkin &lt;trysound@yandex.ru&gt;
            </li>

            <li>
              <strong>postcss-zindex@2.2.0</strong>
              {' '}
              https://github.com/ben-eb/postcss-zindex
              <br />
              Copyright (c) Ben Briggs &lt;beneb.info@gmail.com&gt; (http://beneb.info)
            </li>

            <li>
              <strong>postcss@5.2.18 postcss@6.0.16</strong>
              {' '}
              https://github.com/postcss/postcss
              <br />
              Copyright 2013 Andrey Sitnik &lt;andrey@sitnik.ru&gt;>
            </li>

            <li>
              <strong>prelude-ls@1.1.2</strong>
              {' '}
              https://github.com/gkz/prelude-ls
              <br />
              Copyright (c) George Zahariev
            </li>

            <li>
              <strong>prepend-http@1.0.4 prepend-http@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/prepend-http
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>preserve@0.2.0</strong>
              {' '}
              https://github.com/jonschlinkert/preserve
              <br />
              Copyright (c) 2014-2015, Jon Schlinkert.
            </li>

            <li>
              <strong>pretty-hrtime@1.0.3</strong>
              {' '}
              https://github.com/robrich/pretty-hrtime
              <br />
              Copyright (c) 2013 Richardson & Sons, LLC (http://richardsonandsons.com/)
            </li>

            <li>
              <strong>private@0.1.8</strong>
              {' '}
              https://github.com/benjamn/private
              <br />
              Copyright (c) 2014 Ben Newman &lt;bn@cs.stanford.edu&gt;
            </li>

            <li>
              <strong>process-nextick-args@1.0.7</strong>
              {' '}
              https://github.com/calvinmetcalf/process-nextick-args
              <br />
              Copyright (c) 2015 Calvin Metcalf
            </li>

            <li>
              <strong>process@0.11.10</strong>
              {' '}
              https://github.com/shtylman/node-process
              <br />
              Copyright (c) 2013 Roman Shtylman &lt;shtylman@gmail.com&gt;
            </li>

            <li>
              <strong>progress@1.1.8</strong>
              {' '}
              https://github.com/visionmedia/node-progress
              <br />
              Copyright (c) 2014 TJ Holowaychuk &lt;tj@vision-media.ca&gt;
            </li>

            <li>
              <strong>progress@2.0.0</strong>
              {' '}
              https://github.com/visionmedia/node-progress
              <br />
              Copyright (c) 2017 TJ Holowaychuk &lt;tj@vision-media.ca&gt;
            </li>

            <li>
              <strong>promise@7.3.1 promise@8.0.1</strong>
              {' '}
              https://github.com/then/promise
              <br />
              Copyright (c) 2014 Forbes Lindesay
            </li>

            <li>
              <strong>prop-types@15.6.0</strong>
              {' '}
              https://github.com/reactjs/prop-types
              <br />
              Copyright (c) 2013-present, Facebook, Inc.
            </li>

            <li>
              <strong>proxy-addr@2.0.2</strong>
              {' '}
              https://github.com/jshttp/proxy-addr
              <br />
              Copyright (c) 2014-2016 Douglas Christopher Wilson
            </li>

            <li>
              <strong>proxy-agent@2.0.0</strong>
              {' '}
              https://github.com/TooTallNate/node-proxy-agent
              <br />
              Copyright (c) 2013 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
            </li>

            <li>
              <strong>prr@1.0.1</strong>
              {' '}
              https://github.com/rvagg/prr
              <br />
              Copyright (c) 2014 Rod Vagg
            </li>

            <li>
              <strong>public-encrypt@4.0.0</strong>
              {' '}
              https://github.com/crypto-browserify/publicEncrypt
            </li>

            <li>
              <strong>pump@1.0.3 pump@2.0.0</strong>
              {' '}
              https://github.com/mafintosh/pump
              <br />
              Copyright (c) 2014 Mathias Buus
            </li>

            <li>
              <strong>pumpify@1.3.6</strong>
              {' '}
              https://github.com/mafintosh/pumpify
              <br />
              Copyright (c) 2014 Mathias Buus
            </li>

            <li>
              <strong>punycode@1.3.2 punycode@1.4.1 punycode@2.1.0</strong>
              {' '}
              https://github.com/bestiejs/punycode.js
              <br />
              Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;
            </li>

            <li>
              <strong>q@1.4.1</strong>
              {' '}
              https://github.com/kriskowal/q
              <br />
              Copyright 2009-2014 Kristopher Michael Kowal. All rights reserved.
            </li>

            <li>
              <strong>q@1.5.1</strong>
              {' '}
              https://github.com/kriskowal/q
              <br />
              Copyright 2009-2017 Kristopher Michael Kowal. All rights reserved.
            </li>

            <li>
              <strong>qjobs@1.1.5</strong>
              {' '}
              https://github.com/franck34/qjobs
              <br />
              Copyright (c) 2013-2016 Franck TABARY
            </li>

            <li>
              <strong>query-string@4.3.4 query-string@5.0.1</strong>
              {' '}
              https://github.com/sindresorhus/query-string
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>querystring-es3@0.2.1</strong>
              {' '}
              https://github.com/mike-spainhower/querystring
              <br />
              Copyright 2012 Irakli Gozalishvili. All rights reserved.
            </li>

            <li>
              <strong>querystring@0.2.0</strong>
              {' '}
              https://github.com/Gozala/querystring
              <br />
              Copyright 2012 Irakli Gozalishvili. All rights reserved.
            </li>

            <li>
              <strong>querystringify@0.0.4 querystringify@1.0.0</strong>
              {' '}
              https://github.com/unshiftio/querystringify
              <br />
              Copyright (c) 2015 Unshift.io, Arnout Kazemier,  the Contributors.
            </li>

            <li>
              <strong>quick-lru@1.1.0</strong>
              {' '}
              https://github.com/sindresorhus/quick-lru
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>raf@3.4.0</strong>
              {' '}
              https://github.com/chrisdickinson/raf
            </li>

            <li>
              <strong>randomatic@1.1.7 randomatic@3.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/randomatic
              <br />
              Copyright (c) 2013-2017, Jon Schlinkert
            </li>

            <li>
              <strong>randombytes@2.0.6</strong>
              {' '}
              https://github.com/crypto-browserify/randombytes
              <br />
              Copyright (c) 2017 crypto-browserify
            </li>

            <li>
              <strong>randomfill@1.0.3</strong>
              {' '}
              https://github.com/crypto-browserify/randombytes
              <br />
              Copyright (c) 2017 crypto-browserify
            </li>

            <li>
              <strong>range-parser@1.2.0</strong>
              {' '}
              https://github.com/jshttp/range-parser
              <br />
              Copyright (c) 2012-2014 TJ Holowaychuk &lt;tj@vision-media.ca&gt;
              <br />
              Copyright (c) 2015-2016 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>raw-body@2.3.2</strong>
              {' '}
              https://github.com/stream-utils/raw-body
              <br />
              Copyright (c) 2013-2014 Jonathan Ong &lt;me@jongleberry.com&gt;
              <br />
              Copyright (c) 2014-2015 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>rc@1.2.1 rc@1.2.3</strong>
              {' '}
              https://github.com/dominictarr/rc
              <br />
              Copyright (c) 2011 Dominic Tarr
            </li>

            <li>
              <strong>re-reselect@1.0.1</strong>
              {' '}
              https://github.com/toomuchdesign/re-reselect
              <br />
              Copyright (c) Andrea Carraro
            </li>

            <li>
              <strong>react-animate-height@0.10.9</strong>
              {' '}
              https://github.com/Stanko/react-animate-height
              <br />
              Copyright (c) 2017 - today Stanko TadiÄ‡
            </li>

            <li>
              <strong>react-datepicker@1.0.4</strong>
              {' '}
              https://github.com/Hacker0x01/react-datepicker
              <br />
              Copyright (c) 2017 HackerOne Inc and individual contributors
            </li>

            <li>
              <strong>react-dimensions@1.3.1</strong>
              {' '}
              https://github.com/digidem/react-dimensions
            </li>

            <li>
              <strong>react-dom@16.2.0</strong>
              {' '}
              https://github.com/facebook/react
              <br />
              Copyright (c) 2013-present, Facebook, Inc.
            </li>

            <li>
              <strong>react-metrics@2.4.0</strong>
              {' '}
              https://github.com/nfl/react-metrics
              <br />
              Copyright (c) 2015 NFL
            </li>

            <li>
              <strong>react-month-picker@1.3.5</strong>
              {' '}
              https://github.com/nickeljew/react-month-picker
              <br />
              Copyright (c) 2015 nickeljew
            </li>

            <li>
              <strong>react-onclickoutside@6.7.0</strong>
              {' '}
              https://github.com/Pomax/react-onclickoutside
            </li>

            <li>
              <strong>react-popper@0.7.5</strong>
              {' '}
              https://github.com/souporserious/react-popper
              <br />
              Copyright (c) 2015 React Popper authors
            </li>

            <li>
              <strong>react-redux@5.0.6</strong>
              {' '}
              https://github.com/reactjs/react-redux
              <br />
              Copyright (c) 2015-present Dan Abramov
            </li>

            <li>
              <strong>react-resize-detector@1.1.0</strong>
              {' '}
              https://github.com/maslianok/react-resize-detector
            </li>

            <li>
              <strong>react-responsive@4.0.3</strong>
              {' '}
              https://github.com/contra/react-responsive
              <br />
              Copyright (c) 2014 Fractal &lt;contact@wearefractal.com&gt;
            </li>

            <li>
              <strong>react-router@4.2.0</strong>
              {' '}
              https://github.com/ReactTraining/react-router
              <br />
              Copyright (c) React Training 2016-2018
            </li>

            <li>
              <strong>react-smooth@1.0.0</strong>
              {' '}
              https://github.com/recharts/react-smooth
              <br />
              Copyright (c) 2016 recharts
            </li>

            <li>
              <strong>react-tapper@0.1.16</strong>
              {' '}
              https://github.com/nickeljew/react-tapper
              <br />
              Copyright (c) 2015 nickeljew
            </li>

            <li>
              <strong>react@16.2.0</strong>
              {' '}
              https://github.com/facebook/react
              <br />
              Copyright (c) 2013-present, Facebook, Inc.
            </li>

            <li>
              <strong>read-file-stdin@0.2.1</strong>
              {' '}
              https://github.com/ianstormtaylor/read-file-stdin
            </li>

            <li>
              <strong>read-only-stream@2.0.0</strong>
              {' '}
              https://github.com/substack/read-only-stream
            </li>

            <li>
              <strong>read-pkg-up@1.0.1</strong>
              {' '}
              https://github.com/sindresorhus/read-pkg-up
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>read-pkg-up@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/read-pkg-up
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>read-pkg-up@3.0.0</strong>
              {' '}
              https://github.com/sindresorhus/read-pkg-up
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>read-pkg@1.1.0 read-pkg@2.0.0 read-pkg@3.0.0</strong>
              {' '}
              https://github.com/sindresorhus/read-pkg
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>readable-stream@1.0.34 readable-stream@1.1.14 readable-stream@2.0.6</strong>
              {' '}
              https://github.com/isaacs/readable-stream
              <br />
              Copyright Joyent, Inc. and other Node contributors. All rights reserved.
            </li>

            <li>
              <strong>readable-stream@2.2.9</strong>
              {' '}
              https://github.com/nodejs/readable-stream
              <br />
              Copyright Node.js contributors. All rights reserved.
              <br />
              This license applies to parts of Node.js originating from the https://github.com/joyent/node repository:
              <br />
              Copyright Joyent, Inc. and other Node contributors. All rights reserved.
            </li>

            <li>
              <strong>readable-stream@2.3.3</strong>
              {' '}
              https://github.com/nodejs/readable-stream
              <br />
              Copyright Node.js contributors. All rights reserved.
              <br />
              This license applies to parts of Node.js originating from the https://github.com/joyent/node repository:
              <br />
              Copyright Joyent, Inc. and other Node contributors. All rights reserved.
            </li>

            <li>
              <strong>readdirp@2.1.0</strong>
              {' '}
              https://github.com/thlorenz/readdirp
              <br />
              Copyright (c) 2012-2015 Thorsten Lorenz
            </li>

            <li>
              <strong>readline2@1.0.1</strong>
              {' '}
              https://github.com/sboudrias/readline2
              <br />
              Copyright (c) 2012 Simon Boudrias (twitter: [@vaxilart](https://twitter.com/Vaxilart))
            </li>

            <li>
              <strong>recharts-scale@0.3.2</strong>
              {' '}
              https://github.com/recharts/recharts-scale
              <br />
              Copyright (c) 2015 Sen Yang
            </li>

            <li>
              <strong>recharts@1.0.0-beta.9</strong>
              {' '}
              https://github.com/recharts/recharts
              <br />
              Copyright (c) 2015 recharts
            </li>

            <li>
              <strong>rechoir@0.6.2</strong>
              {' '}
              https://github.com/tkellen/node-rechoir
              <br />
              Copyright (c) 2015 Tyler Kellen
            </li>

            <li>
              <strong>redent@1.0.0 redent@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/redent
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>redis-commands@1.3.1</strong>
              {' '}
              https://github.com/NodeRedis/redis-commands
              <br />
              Copyright (c) 2015 NodeRedis
            </li>

            <li>
              <strong>redis-parser@2.6.0</strong>
              {' '}
              https://github.com/NodeRedis/node-redis-parser
              <br />
              Copyright (c) 2015 NodeRedis
            </li>

            <li>
              <strong>redis@2.8.0</strong>
              {' '}
              https://github.com/NodeRedis/node_redis
              <br />
              Copyright (c) 2016 by NodeRedis
            </li>

            <li>
              <strong>reduce-css-calc@1.3.0 reduce-css-calc@2.1.3</strong>
              {' '}
              https://github.com/MoOx/reduce-css-calc
              <br />
              Copyright (c) 2014 Maxime Thirouin & Joakim Bengtson
            </li>

            <li>
              <strong>reduce-function-call@1.0.2</strong>
              {' '}
              https://github.com/MoOx/reduce-function-call
              <br />
              Copyright (c) 2014 'MoOx' Maxime Thirouin
            </li>

            <li>
              <strong>redux-batched-actions@0.2.1</strong>
              {' '}
              https://github.com/tshelburne/redux-batched-actions
              <br />
              Copyright (c) 2016 Tim Shelburne
            </li>

            <li>
              <strong>redux-devtools-extension@2.13.2</strong>
              {' '}
              https://github.com/zalmoxisus/redux-devtools-extension
              <br />
              Copyright (c) 2015-present Mihail Diordiev
            </li>

            <li>
              <strong>redux-thunk@2.2.0</strong>
              {' '}
              https://github.com/gaearon/redux-thunk
              <br />
              Copyright (c) 2015 Dan Abramov
            </li>

            <li>
              <strong>redux@3.7.2</strong>
              {' '}
              https://github.com/reactjs/redux
              <br />
              Copyright (c) 2015-present Dan Abramov
            </li>

            <li>
              <strong>regenerate-unicode-properties@5.1.3</strong>
              {' '}
              https://github.com/mathiasbynens/regenerate-unicode-properties
              <br />
              Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;
            </li>

            <li>
              <strong>regenerate@1.3.3</strong>
              {' '}
              https://github.com/mathiasbynens/regenerate
              <br />
              Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;
            </li>

            <li>
              <strong>regenerator-runtime@0.10.5 regenerator-runtime@0.11.1</strong>
              {' '}
              https://github.com/facebook/regenerator/tree/master/packages/regenerator-runtime
              <br />
              Copyright (c) 2014-present, Facebook, Inc.
            </li>

            <li>
              <strong>regenerator-transform@0.10.1</strong>
              {' '}
              https://github.com/facebook/regenerator/tree/master/packages/regenerator-transform
            </li>

            <li>
              <strong>regex-cache@0.4.4</strong>
              {' '}
              https://github.com/jonschlinkert/regex-cache
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>regex-not@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/regex-not
              <br />
              Copyright (c) 2016 Jon Schlinkert
            </li>

            <li>
              <strong>regexpu-core@1.0.0 regexpu-core@2.0.0 regexpu-core@4.1.3</strong>
              {' '}
              https://github.com/mathiasbynens/regexpu-core
              <br />
              Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;
            </li>

            <li>
              <strong>regjsgen@0.2.0</strong>
              {' '}
              https://github.com/d10/regjsgen
              <br />
              Copyright 2014 Benjamin Tan &lt;demoneaux@gmail.com&gt; (https://d10.github.io/)
            </li>

            <li>
              <strong>regjsgen@0.3.0</strong>
              {' '}
              https://github.com/demoneaux/regjsgen
              <br />
              Copyright 2014-2016 Benjamin Tan &lt;https://demoneaux.github.io/&gt;
            </li>

            <li>
              <strong>repeat-element@1.1.2</strong>
              {' '}
              https://github.com/jonschlinkert/repeat-element
              <br />
              Copyright (c) 2015 Jon Schlinkert
            </li>

            <li>
              <strong>repeat-string@0.2.2</strong>
              {' '}
              https://github.com/jonschlinkert/repeat-string
              <br />
              Copyright (c) 2014 Jon Schlinkert, contributors.
            </li>

            <li>
              <strong>repeat-string@1.6.1</strong>
              {' '}
              https://github.com/jonschlinkert/repeat-string
              <br />
              Copyright (c) 2014-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>repeating@2.0.1 repeating@3.0.0</strong>
              {' '}
              https://github.com/sindresorhus/repeating
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>replace-ext@0.0.1</strong>
              {' '}
              https://github.com/wearefractal/replace-ext
              <br />
              Copyright (c) 2014 Fractal &lt;contact@wearefractal.com&gt;
            </li>

            <li>
              <strong>replace-ext@1.0.0</strong>
              {' '}
              https://github.com/gulpjs/replace-ext
              <br />
              Copyright (c) 2014 Blaine Bublitz &lt;laine.bublitz@gmail.com&gt;,
              Eric Schoffstall &lt;yo@contra.io&gt; and other contributors
            </li>

            <li>
              <strong>request-progress@2.0.1</strong>
              {' '}
              https://github.com/IndigoUnited/node-request-progress
              <br />
              Copyright (c) 2012 IndigoUnited
            </li>

            <li>
              <strong>requestretry@1.12.2</strong>
              {' '}
              https://github.com/FGRibreau/node-request-retry
              <br />
              Copyright (c) 2014 Francois-Guillaume Ribreau
            </li>

            <li>
              <strong>require-directory@2.1.1</strong>
              {' '}
              https://github.com/troygoode/node-require-directory
              <br />
              Copyright (c) 2011 Troy Goode &lt;troygoode@gmail.com&gt;
            </li>

            <li>
              <strong>require-from-string@1.2.1 require-from-string@2.0.1</strong>
              {' '}
              https://github.com/floatdrop/require-from-string
              <br />
              Copyright (c) Vsevolod Strukchinsky &lt;floatdrop@gmail.com&gt; (github.com/floatdrop)
            </li>

            <li>
              <strong>require-uncached@1.0.3</strong>
              {' '}
              https://github.com/sindresorhus/require-uncached
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>requires-port@1.0.0</strong>
              {' '}
              https://github.com/unshiftio/requires-port
              <br />
              Copyright (c) 2015 Unshift.io, Arnout Kazemier, the Contributors.
            </li>

            <li>
              <strong>reselect@3.0.1</strong>
              {' '}
              https://github.com/reactjs/reselect
              <br />
              Copyright (c) 2015-2016 Reselect Contributors
            </li>

            <li>
              <strong>resolve-cwd@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/resolve-cwd
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>resolve-dir@1.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/resolve-dir
              <br />
              Copyright (c) 2015-2016, Jon Schlinkert
            </li>

            <li>
              <strong>resolve-from@1.0.1 resolve-from@3.0.0 resolve-from@4.0.0</strong>
              {' '}
              https://github.com/sindresorhus/resolve-from
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>resolve-pathname@2.2.0</strong>
              {' '}
              https://github.com/mjackson/resolve-pathname
            </li>

            <li>
              <strong>resolve-url@0.2.1</strong>
              {' '}
              https://github.com/lydell/resolve-url
              <br />
              Copyright (c) 2013 Simon Lydell
            </li>

            <li>
              <strong>resolve@1.1.7 resolve@1.5.0</strong>
              {' '}
              https://github.com/substack/node-resolve
            </li>

            <li>
              <strong>restore-cursor@1.0.1 restore-cursor@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/restore-cursor
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>right-align@0.1.3</strong>
              {' '}
              https://github.com/jonschlinkert/right-align
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>ripemd160@2.0.1</strong>
              {' '}
              https://github.com/crypto-browserify/ripemd160
              <br />
              Copyright (c) 2016 crypto-browserify
            </li>

            <li>
              <strong>run-async@0.1.0 run-async@2.3.0</strong>
              {' '}
              https://github.com/SBoudrias/run-async
              <br />
              Copyright (c) 2014 Simon Boudrias
            </li>

            <li>
              <strong>safe-buffer@5.0.1 safe-buffer@5.1.1</strong>
              {' '}
              https://github.com/feross/safe-buffer
              <br />
              Copyright (c) Feross Aboukhadijeh
            </li>

            <li>
              <strong>sass-graph@2.2.4</strong>
              {' '}
              https://github.com/xzyfer/sass-graph
            </li>

            <li>
              <strong>sass-lint@1.12.1</strong>
              {' '}
              https://github.com/sasstools/sass-lint
              <br />
              Copyright (c) 2015 Sam Richard
            </li>

            <li>
              <strong>sass-loader@6.0.6</strong>
              {' '}
              https://github.com/webpack-contrib/sass-loader
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>schema-utils@0.3.0 schema-utils@0.4.3</strong>
              {' '}
              https://github.com/webpack-contrib/schema-utils
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>scss-tokenizer@0.2.3</strong>
              {' '}
              https://github.com/sasstools/scss-tokenizer
              <br />
              Copyright (c) 2015 sasstools
            </li>

            <li>
              <strong>select-hose@2.0.0</strong>
              {' '}
              https://github.com/indutny/select-hose
              <br />
              Copyright Fedor Indutny, 2015.
            </li>

            <li>
              <strong>selfsigned@1.10.1</strong>
              {' '}
              https://github.com/jfromaniello/selfsigned
            </li>

            <li>
              <strong>semantic-ui-react@0.77.2</strong>
              {' '}
              https://github.com/Semantic-Org/Semantic-UI-React
              <br />
              Copyright (c) 2016 TechnologyAdvice
            </li>

            <li>
              <strong>send@0.16.1</strong>
              {' '}
              https://github.com/pillarjs/send
              <br />
              Copyright (c) 2012 TJ Holowaychuk Copyright (c) 2014-2016 Douglas Christopher Wilson
            </li>

            <li>
              <strong>sequencify@0.0.7</strong>
              {' '}
              https://github.com/robrich/sequencify
              <br />
              Copyright (c) 2013 Richardson & Sons, LLC (http://richardsonandsons.com/)
            </li>

            <li>
              <strong>serve-index@1.9.1</strong>
              {' '}
              https://github.com/expressjs/serve-index
              <br />
              Copyright (c) 2010 Sencha Inc.
              <br />
              Copyright (c) 2011 LearnBoost
              <br />
              Copyright (c) 2011 TJ Holowaychuk
              <br />
              Copyright (c) 2014-2015 Douglas Christopher Wilson
            </li>

            <li>
              <strong>serve-static@1.13.1</strong>
              {' '}
              https://github.com/expressjs/serve-static
              <br />
              Copyright (c) 2010 Sencha Inc.
              <br />
              Copyright (c) 2011 LearnBoost
              <br />
              Copyright (c) 2011 TJ Holowaychuk
              <br />
              Copyright (c) 2014-2016 Douglas Christopher Wilson
            </li>

            <li>
              <strong>set-getter@0.1.0</strong>
              {' '}
              https://github.com/doowb/set-getter
              <br />
              Copyright (c) 2016, Brian Woodward.
            </li>

            <li>
              <strong>set-immediate-shim@1.0.1</strong>
              {' '}
              https://github.com/sindresorhus/set-immediate-shim
              <br />
              Copyright (c) Sindre Sorhus (http://sindresorhus.com)
            </li>

            <li>
              <strong>set-value@0.4.3 set-value@2.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/set-value
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert
            </li>

            <li>
              <strong>setimmediate@1.0.5</strong>
              {' '}
              https://github.com/yuzujs/setImmediate
              <br />
              Copyright (c) 2012 Barnesandnoble.com, llc, Donavon West, and Domenic Denicola
            </li>

            <li>
              <strong>sha.js@2.4.9</strong>
              {' '}
              https://github.com/crypto-browserify/sha.js
              <br />
              Copyright (c) 2013-2014 sha.js contributors
            </li>

            <li>
              <strong>shallow-clone@0.1.2</strong>
              {' '}
              https://github.com/jonschlinkert/shallow-clone
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>shallow-clone@2.0.2</strong>
              {' '}
              https://github.com/jonschlinkert/shallow-clone
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>shasum@1.0.2</strong>
              {' '}
              https://github.com/dominictarr/shasum
              <br />
              Copyright (c) 2012 Dominic Tarr
            </li>

            <li>
              <strong>shebang-command@1.2.0</strong>
              {' '}
              https://github.com/kevva/shebang-command
              <br />
              Copyright (c) Kevin Martensson &lt;kevinmartensson@gmail.com&lt; (github.com/kevva)
            </li>

            <li>
              <strong>shebang-regex@1.0.0</strong>
              {' '}
              https://github.com/sindresorhus/shebang-regex
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>shell-quote@1.6.1</strong>
              {' '}
              https://github.com/substack/node-shell-quote
              <br />
              Copyright (c) 2013 James Halliday (mail@substack.net)
            </li>

            <li>
              <strong>simple-swizzle@0.2.2</strong>
              {' '}
              https://github.com/qix-/node-simple-swizzle
              <br />
              Copyright (c) 2015 Josh Junon
            </li>

            <li>
              <strong>slack-node@0.2.0</strong>
              {' '}
              https://github.com/clonn/slack-node-sdk
              <br />
              Copyright (c) 2015 Caesar Chi
            </li>

            <li>
              <strong>slash@1.0.0</strong>
              {' '}
              https://github.com/sindresorhus/slash
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>slice-ansi@0.0.4</strong>
              {' '}
              https://github.com/chalk/slice-ansi
              <br />
              Copyright (c) 2015 DC &lt;threedeecee@gmail.com&gt;
            </li>

            <li>
              <strong>slice-ansi@1.0.0</strong>
              {' '}
              https://github.com/chalk/slice-ansi
              <br />
              Copyright (c) DC &lt;threedeecee@gmail.com&gt;
            </li>

            <li>
              <strong>smart-buffer@1.1.15</strong>
              {' '}
              https://github.com/JoshGlazebrook/smart-buffer
              <br />
              Copyright (c) 2013 Josh Glazebrook
            </li>

            <li>
              <strong>smtp-connection@2.12.0</strong>
              {' '}
              https://github.com/andris9/smtp-connection
              <br />
              Copyright (c) 2014-2016 Andris Reinman
            </li>

            <li>
              <strong>snapdragon-node@2.1.1</strong>
              {' '}
              https://github.com/jonschlinkert/snapdragon-node
              <br />
              Copyright (c) 2017, Jon Schlinkert
            </li>

            <li>
              <strong>snapdragon-util@3.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/snapdragon-util
              <br />
              Copyright (c) 2017, Jon Schlinkert
            </li>

            <li>
              <strong>snapdragon@0.8.1</strong>
              {' '}
              https://github.com/jonschlinkert/snapdragon
              <br />
              Copyright (c) 2015-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>socket.io-adapter@1.1.1</strong>
              {' '}
              https://github.com/socketio/socket.io-adapter
              <br />
              Copyright (c) 2014 Guillermo Rauch &lt;guillermo@learnboost.com&gt;
            </li>

            <li>
              <strong>socket.io-client@2.0.4</strong>
              {' '}
              https://github.com/Automattic/socket.io-client
              <br />
              Copyright (c) 2014 Guillermo Rauch
            </li>

            <li>
              <strong>socket.io-parser@3.1.2</strong>
              {' '}
              https://github.com/Automattic/socket.io-parser
              <br />
              Copyright (c) 2014 Guillermo Rauch &lt;guillermo@learnboost.com&gt;
            </li>

            <li>
              <strong>socket.io@2.0.4</strong>
              {' '}
              https://github.com/socketio/socket.io
              <br />
              Copyright (c) 2014-2017 Automattic &lt;dev@cloudup.com&gt;
            </li>

            <li>
              <strong>sockjs-client@1.1.4</strong>
              {' '}
              https://github.com/sockjs/sockjs-client
              <br />
              Copyright (c) 2011-2012 VMware, Inc.
            </li>

            <li>
              <strong>sockjs@0.3.19</strong>
              {' '}
              https://github.com/sockjs/sockjs-node
              <br />
              Copyright (C) 2011 VMware, Inc.
            </li>

            <li>
              <strong>socks-proxy-agent@2.1.1</strong>
              {' '}
              https://github.com/TooTallNate/node-socks-proxy-agent
              <br />
              Copyright (c) 2013 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
            </li>

            <li>
              <strong>socks@1.1.10 socks@1.1.9</strong>
              {' '}
              https://github.com/JoshGlazebrook/socks
              <br />
              Copyright (c) 2013 Josh Glazebrook
            </li>

            <li>
              <strong>sort-keys@1.1.2 sort-keys@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/sort-keys
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>source-list-map@2.0.0</strong>
              {' '}
              https://github.com/webpack/source-list-map
              <br />
              Copyright (c) 2017 JS Foundation
            </li>

            <li>
              <strong>source-map-resolve@0.5.1</strong>
              {' '}
              https://github.com/lydell/source-map-resolve
              <br />
              Copyright (c) 2014, 2015, 2016, 2017 Simon Lydell
            </li>

            <li>
              <strong>source-map-support@0.4.18 source-map-support@0.5.0</strong>
              {' '}
              https://github.com/evanw/node-source-map-support
              <br />
              Copyright (c) 2014 Evan Wallace
            </li>

            <li>
              <strong>source-map-url@0.4.0</strong>
              {' '}
              https://github.com/lydell/source-map-url
              <br />
              Copyright (c) 2014 Simon Lydell
            </li>

            <li>
              <strong>sparkles@1.0.0</strong>
              {' '}
              https://github.com/phated/sparkles
              <br />
              Copyright (c) 2014 Blaine Bublitz
            </li>

            <li>
              <strong>spdx-expression-parse@1.0.4</strong>
              {' '}
              https://github.com/kemitchell/spdx-expression-parse.js
              <br />
              Copyright (c) 2015 Kyle E. Mitchell & other authors listed in AUTHORS
              <br />
              at https://github.com/kemitchell/spdx-expression-parse.js/blob/master/AUTHORS
            </li>

            <li>
              <strong>spdy-transport@2.0.20</strong>
              {' '}
              https://github.com/spdy-http2/spdy-transport
              <br />
              Copyright Fedor Indutny, 2015.
            </li>

            <li>
              <strong>spdy@3.4.7</strong>
              {' '}
              https://github.com/indutny/node-spdy
              <br />
              Copyright Fedor Indutny, 2015.
            </li>

            <li>
              <strong>split-string@3.1.0</strong>
              {' '}
              https://github.com/jonschlinkert/split-string
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>sshpk@1.13.0 sshpk@1.13.1</strong>
              {' '}
              https://github.com/arekinath/node-sshpk
              <br />
              Copyright Joyent, Inc. All rights reserved.
            </li>

            <li>
              <strong>stable@0.1.6</strong>
              {' '}
              https://github.com/Two-Screen/stable
              <br />
              Copyright (C) 2017 Angry Bytes and contributors.
            </li>

            <li>
              <strong>static-extend@0.1.2</strong>
              {' '}
              https://github.com/jonschlinkert/static-extend
              <br />
              Copyright (c) 2016, Jon Schlinkert.
            </li>

            <li>
              <strong>statuses@1.3.1 statuses@1.4.0</strong>
              {' '}
              https://github.com/jshttp/statuses
              <br />
              Copyright (c) 2014 Jonathan Ong &lt;me@jongleberry.com&gt;
              <br />
              Copyright (c) 2016 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>stdout-stream@1.4.0</strong>
              {' '}
              https://github.com/mafintosh/stdout-stream
              <br />
              Copyright 2013 Mathias Buus
            </li>

            <li>
              <strong>stream-browserify@2.0.1</strong>
              {' '}
              https://github.com/substack/stream-browserify
              <br />
              Copyright (c) James Halliday
            </li>

            <li>
              <strong>stream-combiner2@1.1.1</strong>
              {' '}
              https://github.com/substack/stream-combiner2
              <br />
              Copyright (c) 2012 Dominic Tarr
            </li>

            <li>
              <strong>stream-consume@0.1.0</strong>
              {' '}
              https://github.com/aroneous/stream-consume
              <br />
              Copyright (c) 2014 Aron Nopanen
            </li>

            <li>
              <strong>stream-each@1.2.2</strong>
              {' '}
              https://github.com/mafintosh/stream-each
              <br />
              Copyright (c) 2015 Mathias Buus
            </li>

            <li>
              <strong>stream-http@2.7.2</strong>
              {' '}
              https://github.com/jhiesey/stream-http
              <br />
              Copyright (c) 2015 John Hiesey
            </li>

            <li>
              <strong>stream-shift@1.0.0</strong>
              {' '}
              https://github.com/mafintosh/stream-shift
              <br />
              Copyright (c) 2016 Mathias Buus
            </li>

            <li>
              <strong>stream-splicer@2.0.0</strong>
              {' '}
              https://github.com/substack/stream-splicer
            </li>

            <li>
              <strong>streamroller@0.7.0</strong>
              {' '}
              https://github.com/nomiddlename/streamroller
              <br />
              Copyright (c) 2013 Gareth Jones
            </li>

            <li>
              <strong>strict-uri-encode@1.1.0 strict-uri-encode@2.0.0</strong>
              {' '}
              https://github.com/kevva/strict-uri-encode
              <br />
              Copyright (c) Kevin Mårtensson &lt;kevinmartensson@gmail.com&gt; (github.com/kevva)
            </li>

            <li>
              <strong>string-width@1.0.2 string-width@2.1.1</strong>
              {' '}
              https://github.com/sindresorhus/string-width
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>string_decoder@0.10.31</strong>
              {' '}
              https://github.com/rvagg/string_decoder
              <br />
              Copyright Joyent, Inc. and other Node contributors.
            </li>

            <li>
              <strong>string_decoder@1.0.1 string_decoder@1.0.3</strong>
              {' '}
              https://github.com/rvagg/string_decoder
              <br />
              Copyright Node.js contributors. All rights reserved.
              <br />
              This license applies to parts of Node.js originating from the https://github.com/joyent/node repository:
              <br />
              Copyright Joyent, Inc. and other Node contributors. All rights reserved.
            </li>

            <li>
              <strong>stringstream@0.0.5</strong>
              {' '}
              https://github.com/mhart/StringStream
              <br />
              Copyright (c) 2012 Michael Hart (michael.hart.au@gmail.com)
            </li>

            <li>
              <strong>strip-ansi@3.0.1 strip-ansi@4.0.0</strong>
              {' '}
              https://github.com/chalk/strip-ansi
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>strip-bom@1.0.0 strip-bom@2.0.0 strip-bom@3.0.0</strong>
              {' '}
              https://github.com/sindresorhus/strip-bom
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>strip-eof@1.0.0</strong>
              {' '}
              https://github.com/sindresorhus/strip-eof
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>strip-indent@1.0.1 strip-indent@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/strip-indent
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>strip-json-comments@1.0.4 strip-json-comments@2.0.1</strong>
              {' '}
              https://github.com/sindresorhus/strip-json-comments
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>style-loader@0.19.1</strong>
              {' '}
              https://github.com/webpack/style-loader
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>stylehacks@2.3.2</strong>
              {' '}
              https://github.com/ben-eb/stylehacks
              <br />
              Copyright (c) Ben Briggs (http://beneb.info)
            </li>

            <li>
              <strong>subarg@1.0.0</strong>
              {' '}
              https://github.com/substack/subarg
            </li>

            <li>
              <strong>supports-color@2.0.0 supports-color@3.2.3 supports-color@4.5.0 supports-color@5.1.0</strong>
              {' '}
              https://github.com/chalk/supports-color
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>svgo@0.7.2 svgo@1.0.3</strong>
              {' '}
              https://github.com/svg/svgo
              <br />
              Copyright (c) 2012–2016 Kir Belevich
            </li>

            <li>
              <strong>symbol-observable@1.0.1 symbol-observable@1.1.0</strong>
              {' '}
              https://github.com/blesh/symbol-observable
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
              <br />
              Copyright (c) Ben Lesh &lt;ben@benlesh.com&gt;
            </li>

            <li>
              <strong>syntax-error@1.3.0</strong>
              {' '}
              https://github.com/substack/node-syntax-error
            </li>

            <li>
              <strong>tapable@0.2.8 tapable@1.0.0-beta.5</strong>
              {' '}
              https://github.com/webpack/tapable
            </li>

            <li>
              <strong>text-table@0.2.0</strong>
              {' '}
              https://github.com/substack/text-table
            </li>

            <li>
              <strong>throttleit@1.0.0</strong>
              {' '}
              https://github.com/component/throttle
            </li>

            <li>
              <strong>through2@0.6.5</strong>
              {' '}
              https://github.com/rvagg/through2
              <br />
              Copyright 2013, Rod Vagg (the 'Original Author') All rights reserved.
            </li>

            <li>
              <strong>through2@2.0.3</strong>
              {' '}
              https://github.com/rvagg/through2
              <br />
              Copyright (c) 2016 Rod Vagg (the 'Original Author') and additional contributors
            </li>

            <li>
              <strong>through@2.3.8</strong>
              {' '}
              https://github.com/dominictarr/through
              <br />
              Copyright (c) 2011 Dominic Tarr
            </li>

            <li>
              <strong>thunky@0.1.0</strong>
              {' '}
              https://github.com/mafintosh/thunky
            </li>

            <li>
              <strong>thunkify@2.1.2</strong>
              {' '}
              https://github.com/visionmedia/node-thunkify
            </li>

            <li>
              <strong>tildify@1.2.0</strong>
              {' '}
              https://github.com/sindresorhus/tildify
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>time-stamp@1.1.0 time-stamp@2.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/time-stamp
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert
            </li>

            <li>
              <strong>timers-browserify@1.4.2 timers-browserify@2.0.4</strong>
              {' '}
              https://github.com/jryans/timers-browserify
              <br />
              Copyright (c) 2012 J. Ryan Stinnett &lt;jryans@gmail.com&gt;
              <br />
              The `lib/node` directory borrows files from joyent/node which uses the following license:
              <br />
              Copyright Joyent, Inc. and other Node contributors. All rights reserved.
            </li>

            <li>
              <strong>timespan@2.3.0</strong>
              {' '}
              https://github.com/indexzero/TimeSpan.js
              <br />
              Copyright (c) 2010 Michael Stum, Charlie Robbins
            </li>

            <li>
              <strong>tmp@0.0.33</strong>
              {' '}
              https://github.com/raszi/node-tmp
              <br />
              Copyright (c) 2014 KARASZI IstvÃ¡n
            </li>

            <li>
              <strong>to-array@0.1.4</strong>
              {' '}
              https://github.com/Raynos/to-array
              <br />
              Copyright (c) 2012 Raynos.
            </li>

            <li>
              <strong>to-arraybuffer@1.0.1</strong>
              {' '}
              https://github.com/jhiesey/to-arraybuffer
              <br />
              Copyright (c) 2016 John Hiesey
            </li>

            <li>
              <strong>to-fast-properties@1.0.3 to-fast-properties@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/to-fast-properties
              <br />
              Copyright (c) 2014 Petka Antonov
              <br />
              Copyright (c) 2015 Sindre Sorhus
            </li>

            <li>
              <strong>to-object-path@0.3.0</strong>
              {' '}
              https://github.com/jonschlinkert/to-object-path
              <br />
              Copyright (c) 2015-2016, Jon Schlinkert.
            </li>

            <li>
              <strong>to-regex-range@2.1.1</strong>
              {' '}
              https://github.com/micromatch/to-regex-range
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert
            </li>

            <li>
              <strong>to-regex@3.0.1</strong>
              {' '}
              https://github.com/jonschlinkert/to-regex
              <br />
              Copyright (c) 2016 Jon Schlinkert
            </li>

            <li>
              <strong>transmitter@3.0.1</strong>
              {' '}
              https://github.com/goatslacker/transmitter
              <br />
              Copyright (c) 2018 Josh Perez, http://www.goatslacker.com
            </li>

            <li>
              <strong>trim-newlines@1.0.0 trim-newlines@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/trim-newlines
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>trim-right@1.0.1</strong>
              {' '}
              https://github.com/sindresorhus/trim-right
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>tryit@1.0.3</strong>
              {' '}
              https://github.com/HenrikJoreteg/tryit
              <br />
              Copyright (c) 2018 Henrik Joreteg, https://joreteg.com
            </li>

            <li>
              <strong>tsscmp@1.0.5</strong>
              {' '}
              https://github.com/suryagh/tsscmp
              <br />
              Copyright (c) 2016
            </li>

            <li>
              <strong>tty-browserify@0.0.0</strong>
              {' '}
              https://github.com/substack/tty-browserify
            </li>

            <li>
              <strong>twix@1.2.1</strong>
              {' '}
              https://github.com/icambron/twix.js
              <br />
              Copyright (c) 2012-2015 Isaac Cambron and contributors
            </li>

            <li>
              <strong>type-check@0.3.2</strong>
              {' '}
              https://github.com/gkz/type-check
              <br />
              Copyright (c) George Zahariev
            </li>

            <li>
              <strong>type-is@1.6.15</strong>
              {' '}
              https://github.com/jshttp/type-is
              <br />
              Copyright (c) 2014 Jonathan Ong &lt;me@jongleberry.com&gt;
              <br />
              Copyright (c) 2014-2015 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>typedarray@0.0.6</strong>
              {' '}
              https://github.com/substack/typedarray
              <br />
              Copyright (c) 2010, Linden Research, Inc.
              <br />
              Copyright (c) 2012, Joshua Bell
            </li>

            <li>
              <strong>ua-parser-js@0.7.17</strong>
              {' '}
              https://github.com/faisalman/ua-parser-js
              <br />
              Copyright (c) 2012-2016 Faisal Salman &lt;fyzlman@gmail.com&gt;
            </li>

            <li>
              <strong>uglify-to-browserify@1.0.2 uglify-to-browserify@2.0.0</strong>
              {' '}
              https://github.com/ForbesLindesay/uglify-to-browserify
              <br />
              Copyright (c) 2013 Forbes Lindesay
            </li>

            <li>
              <strong>uglifyjs-webpack-plugin@0.4.6 uglifyjs-webpack-plugin@1.1.6</strong>
              {' '}
              https://github.com/webpack-contrib/uglifyjs-webpack-plugin
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>ultron@1.1.1</strong>
              {' '}
              https://github.com/unshiftio/ultron
              <br />
              Copyright (c) 2015 Unshift.io, Arnout Kazemier,  the Contributors.
            </li>

            <li>
              <strong>umd@3.0.1</strong>
              {' '}
              https://github.com/ForbesLindesay/umd
              <br />
              Copyright (c) 2013 Forbes Lindesay
            </li>

            <li>
              <strong>unc-path-regex@0.1.2</strong>
              {' '}
              https://github.com/regexhq/unc-path-regex
              <br />
              Copyright (c) 2015, Jon Schlinkert.
            </li>

            <li>
              <strong>underscore@1.7.0</strong>
              {' '}
              https://github.com/jashkenas/underscore
              <br />
              Copyright (c) 2009-2014 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
            </li>

            <li>
              <strong>unicode-canonical-property-names-ecmascript@1.0.3</strong>
              {' '}
              https://github.com/mathiasbynens/unicode-canonical-property-names-ecmascript
              <br />
              Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;
            </li>

            <li>
              <strong>unicode-match-property-ecmascript@1.0.3</strong>
              {' '}
              https://github.com/mathiasbynens/unicode-match-property-ecmascript
              <br />
              Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;
            </li>

            <li>
              <strong>unicode-match-property-value-ecmascript@1.0.1</strong>
              {' '}
              https://github.com/mathiasbynens/unicode-match-property-value-ecmascript
              <br />
              Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;
            </li>

            <li>
              <strong>unicode-property-aliases-ecmascript@1.0.3</strong>
              {' '}
              https://github.com/mathiasbynens/unicode-property-aliases-ecmascript
              <br />
              Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;
            </li>

            <li>
              <strong>union-value@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/union-value
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert
            </li>

            <li>
              <strong>uniq@1.0.1</strong>
              {' '}
              https://github.com/mikolalysenko/uniq
              <br />
              Copyright (c) 2013 Mikola Lysenko
            </li>

            <li>
              <strong>uniqid@4.1.1</strong>
              {' '}
              https://github.com/adamhalasz/uniqid
              <br />
              Copyright (c) 2014 Halász Ádám mail@adamhalasz.com
            </li>

            <li>
              <strong>uniqs@2.0.0</strong>
              {' '}
              https://github.com/fgnass/uniqs
            </li>

            <li>
              <strong>unique-stream@1.0.0</strong>
              {' '}
              https://github.com/eugeneware/unique-stream
              <br />
              Copyright 2014 Eugene Ware
            </li>

            <li>
              <strong>universalify@0.1.1</strong>
              {' '}
              https://github.com/RyanZim/universalify
              <br />
              Copyright (c) 2017, Ryan Zimmerman &lt;opensrc@ryanzim.com&gt;
            </li>

            <li>
              <strong>unpipe@1.0.0</strong>
              {' '}
              https://github.com/stream-utils/unpipe
              <br />
              Copyright (c) 2015 Douglas Christopher Wilson &lt;doug@somethingdoug.com&gt;
            </li>

            <li>
              <strong>unquote@1.1.1</strong>
              {' '}
              https://github.com/lakenen/node-unquote
              <br />
              Copyright (c) 2017 Cameron Lakenen
            </li>

            <li>
              <strong>unset-value@1.0.0</strong>
              {' '}
              https://github.com/jonschlinkert/unset-value
              <br />
              Copyright (c) 2015, 2017, Jon Schlinkert
            </li>

            <li>
              <strong>urix@0.1.0</strong>
              {' '}
              https://github.com/lydell/urix
              <br />
              Copyright (c) 2013 Simon Lydell
            </li>

            <li>
              <strong>url-join@2.0.5</strong>
              {' '}
              https://github.com/jfromaniello/url-join
              <br />
              Copyright (c) 2015 José F. Romaniello
            </li>

            <li>
              <strong>url-loader@0.6.2</strong>
              {' '}
              https://github.com/webpack-contrib/url-loader
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>url-parse@1.0.5 url-parse@1.2.0</strong>
              {' '}
              https://github.com/unshiftio/url-parse
              <br />
              Copyright (c) 2015 Unshift.io, Arnout Kazemier,  the Contributors.
            </li>

            <li>
              <strong>url@0.11.0</strong>
              {' '}
              https://github.com/defunctzombie/node-url
              <br />
              Copyright Joyent, Inc. and other Node contributors.
            </li>

            <li>
              <strong>use@2.0.2</strong>
              {' '}
              https://github.com/jonschlinkert/use
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert
            </li>

            <li>
              <strong>user-home@1.1.1 user-home@2.0.0</strong>
              {' '}
              https://github.com/sindresorhus/user-home
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>useragent@2.2.1</strong>
              {' '}
              https://github.com/3rd-Eden/useragent
              <br />
              Copyright (c) 2013 Arnout Kazemier (http://3rd-Eden.com)
            </li>

            <li>
              <strong>util-deprecate@1.0.2</strong>
              {' '}
              https://github.com/TooTallNate/util-deprecate
              <br />
              Copyright (c) 2014 Nathan Rajlich &lt;nathan@tootallnate.net&gt;
            </li>

            <li>
              <strong>util.promisify@1.0.0</strong>
              {' '}
              https://github.com/ljharb/util.promisify
              <br />
              Copyright (c) 2017 Jordan Harband
            </li>

            <li>
              <strong>util@0.10.3</strong>
              {' '}
              https://github.com/defunctzombie/node-util
              <br />
              Copyright Joyent, Inc. and other Node contributors. All rights reserved.
            </li>

            <li>
              <strong>utils-merge@1.0.1</strong>
              {' '}
              https://github.com/jaredhanson/utils-merge
              <br />
              Copyright (c) 2013-2017 Jared Hanson
            </li>

            <li>
              <strong>uuid@3.0.1 uuid@3.1.0</strong>
              {' '}
              https://github.com/kelektiv/node-uuid
              <br />
              Copyright (c) 2010-2016 Robert Kieffer and other contributors
            </li>

            <li>
              <strong>v8flags@2.1.1 v8flags@3.0.1</strong>
              {' '}
              https://github.com/tkellen/node-v8flags
              <br />
              Copyright (c) 2014 Tyler Kellen
            </li>

            <li>
              <strong>value-equal@0.4.0</strong>
              {' '}
              https://github.com/mjackson/value-equal
            </li>

            <li>
              <strong>vary@1.1.2</strong>
              {' '}
              https://github.com/jshttp/vary
              <br />
              Copyright (c) 2014-2017 Douglas Christopher Wilson
            </li>

            <li>
              <strong>vendors@1.0.1</strong>
              {' '}
              https://github.com/wooorm/vendors
              <br />
              Copyright (c) 2016 Titus Wormer &lt;tituswormer@gmail.com&gt;
            </li>

            <li>
              <strong>verror@1.3.6</strong>
              {' '}
              https://github.com/davepacheco/node-verror
              <br />
              Copyright (c) 2012, Joyent, Inc. All rights reserved.
            </li>

            <li>
              <strong>verror@1.10.0</strong>
              {' '}
              https://github.com/davepacheco/node-verror
              <br />
              Copyright (c) 2016, Joyent, Inc. All rights reserved.
            </li>

            <li>
              <strong>vinyl-fs@0.3.14</strong>
              {' '}
              https://github.com/wearefractal/vinyl-fs
              <br />
              Copyright (c) 2014 Fractal &lt;contact@wearefractal.com&gt;
            </li>

            <li>
              <strong>vinyl@0.4.6 vinyl@0.5.3</strong>
              {' '}
              https://github.com/wearefractal/vinyl
              <br />
              Copyright (c) 2013 Fractal &lt;contact@wearefractal.com&gt;
            </li>

            <li>
              <strong>vinyl@2.1.0</strong>
              {' '}
              https://github.com/gulpjs/vinyl
              <br />
              Copyright (c) 2013 Blaine Bublitz &lt;blaine.bublitz@gmail.com&gt;,
              Eric Schoffstall &lt;yo@contra.io&gt; and other contributors
            </li>

            <li>
              <strong>vm-browserify@0.0.4</strong>
              {' '}
              https://github.com/substack/vm-browserify
            </li>

            <li>
              <strong>void-elements@2.0.1 void-elements@3.1.0</strong>
              {' '}
              https://github.com/hemanth/void-elements
              <br />
              Copyright (c) 2014 hemanth
            </li>

            <li>
              <strong>watchpack@1.4.0</strong>
              {' '}
              https://github.com/webpack/watchpack
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>wbuf@1.7.2</strong>
              {' '}
              https://github.com/indutny/wbuf
              <br />
              Copyright Fedor Indutny, 2014.
            </li>

            <li>
              <strong>webpack-bundle-analyzer@2.9.2</strong>
              {' '}
              https://github.com/webpack-contrib/webpack-bundle-analyzer
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>webpack-dev-middleware@1.12.2 webpack-dev-middleware@2.0.4</strong>
              {' '}
              https://github.com/webpack/webpack-dev-middleware
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>webpack-dev-server@2.10.1</strong>
              {' '}
              https://github.com/webpack/webpack-dev-server
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>webpack-log@1.1.1</strong>
              {' '}
              https://github.com/webpack-contrib/webpack-log
              <br />
              Copyright (c) 2017 webpack-contrib
            </li>

            <li>
              <strong>webpack-merge@4.1.1</strong>
              {' '}
              https://github.com/survivejs/webpack-merge
              <br />
              Copyright (c) 2015 Juho Vepsalainen
            </li>

            <li>
              <strong>webpack-sources@1.1.0</strong>
              {' '}
              https://github.com/webpack/webpack-sources
              <br />
              Copyright (c) 2017 JS Foundation and other contributors
            </li>

            <li>
              <strong>webpack@3.10.0</strong>
              {' '}
              https://github.com/webpack/webpack
              <br />
              Copyright JS Foundation and other contributors
            </li>

            <li>
              <strong>websocket-driver@0.7.0 websocket-extensions@0.1.3</strong>
              {' '}
              https://github.com/faye/websocket-driver-node
              <br />
              Copyright (c) 2010-2017 James Coglan
            </li>

            <li>
              <strong>whatwg-fetch@0.9.0 whatwg-fetch@2.0.3</strong>
              {' '}
              https://github.com/github/fetch
              <br />
              Copyright (c) 2014-2015 GitHub, Inc.
            </li>

            <li>
              <strong>when@3.7.8</strong>
              {' '}
              https://github.com/cujojs/when
              <br />
              Copyright (c) 2011 Brian Cavalier
            </li>

            <li>
              <strong>whet.extend@0.9.9</strong>
              {' '}
              https://github.com/Meettya/whet.extend
              <br />
              Copyright (c) 2012 Dmitrii Karpich
            </li>

            <li>
              <strong>window-size@0.1.0</strong>
              {' '}
              https://github.com/jonschlinkert/window-size
              <br />
              Copyright (c) 2014 Jon Schlinkert
            </li>

            <li>
              <strong>window-size@1.1.0</strong>
              {' '}
              https://github.com/jonschlinkert/window-size
              <br />
              Copyright (c) 2015-2017, Jon Schlinkert
            </li>

            <li>
              <strong>wordwrap@0.0.2 wordwrap@0.0.3 wordwrap@1.0.0</strong>
              {' '}
              https://github.com/substack/node-wordwrap
            </li>

            <li>
              <strong>worker-farm@1.5.2</strong>
              {' '}
              https://github.com/rvagg/node-worker-farm
              <br />
              Copyright (c) 2014 LevelUP contributors
              <br />
              LevelUP contributors listed at &lt;https://github.com/rvagg/node-levelup#contributors&gt;
            </li>

            <li>
              <strong>wrap-ansi@2.1.0 wrap-ansi@3.0.1</strong>
              {' '}
              https://github.com/chalk/wrap-ansi
              <br />
              Copyright (c) Sindre Sorhus &lt;sindresorhus@gmail.com&gt; (sindresorhus.com)
            </li>

            <li>
              <strong>wrench@1.5.9</strong>
              {' '}
              https://ryanmcgrath@github.com/ryanmcgrath/wrench-js
              <br />
              Copyright (c) 2010 Ryan McGrath
            </li>

            <li>
              <strong>write-file-stdout@0.0.2</strong>
              {' '}
              https://github.com/ianstormtaylor/write-file-stdout
            </li>

            <li>
              <strong>write@0.2.1 write@1.0.3</strong>
              {' '}
              https://github.com/jonschlinkert/write
              <br />
              Copyright (c) 2014-2017, Jon Schlinkert.
            </li>

            <li>
              <strong>ws@3.3.3 ws@4.0.0</strong>
              {' '}
              https://github.com/websockets/ws
              <br />
              Copyright (c) 2011 Einar Otto Stangvik &lt;einaros@gmail.com&gt;
            </li>

            <li>
              <strong>wtf-8@1.0.1</strong>
              {' '}
              https://github.com/mathiasbynens/wtf-8
              <br />
              Copyright Mathias Bynens &lt;https://mathiasbynens.be/&gt;
            </li>

            <li>
              <strong>xmlhttprequest-ssl@1.5.5</strong>
              {' '}
              https://github.com/mjwwit/node-XMLHttpRequest
              <br />
              Copyright (c) 2010 passive.ly LLC
            </li>

            <li>
              <strong>xregexp@2.0.0 xregexp@4.0.0</strong>
              {' '}
              https://github.com/slevithan/xregexp
              <br />
              Copyright (c) 2007-2017 Steven Levithan &lt;http://xregexp.com/&gt;
            </li>

            <li>
              <strong>xtend@4.0.1</strong>
              {' '}
              https://github.com/Raynos/xtend
              <br />
              Copyright (c) 2012-2014 Raynos.
            </li>

            <li>
              <strong>yargs@10.1.1 yargs@3.10.0 yargs@6.6.0 yargs@7.1.0 yargs@8.0.2</strong>
              {' '}
              https://github.com/yargs/yargs
              <br />
              Copyright 2010 James Halliday &lt;mail@substack.net&gt;
              <br />
              Modified work Copyright 2014 Contributors &lt;ben@npmjs.com&gt;
            </li>

            <li>
              <strong>yauzl@2.4.1</strong>
              {' '}
              https://github.com/thejoshwolfe/yauzl
              <br />
              Copyright (c) 2014 Josh Wolfe
            </li>

            <li>
              <strong>yeast@0.1.2</strong>
              {' '}
              https://github.com/unshiftio/yeast
              <br />
              Copyright (c) 2015 Unshift.io, Arnout Kazemier, the Contributors.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p><strong>MIT License full text:</strong></p>
            <p>
              Permission is hereby granted, free of charge, to any person obtaining a copy
              of this software and associated documentation files (the "Software"), to deal
              in the Software without restriction, including without limitation the rights
              to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
              copies of the Software, and to permit persons to whom the Software is
              furnished to do so, subject to the following conditions:
            </p>
            <p>
              The above copyright notice and this permission notice shall be included in all
              copies or substantial portions of the Software.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
              SOFTWARE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <p><strong>ISC License</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>abbrev@1.1.0 abbrev@1.1.1</strong>
              {' '}
              https://github.com/isaacs/abbrev-js
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>anymatch@1.3.2 anymatch@2.0.0</strong>
              {' '}
              https://github.com/micromatch/anymatch
              <br />
              Copyright (c) 2014 Elan Shanker
            </li>

            <li>
              <strong>aproba@1.1.1 aproba@1.2.0</strong>
              {' '}
              https://github.com/iarna/aproba
              <br />
              Copyright (c) 2015, Rebecca Turner &lt;me@re-becca.org&gt;
            </li>

            <li>
              <strong>are-we-there-yet@1.1.4</strong>
              {' '}
              https://github.com/iarna/are-we-there-yet
              <br />
              Copyright (c) 2015, Rebecca Turner
            </li>

            <li>
              <strong>block-stream@0.0.9</strong>
              {' '}
              https://github.com/isaacs/block-stream
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>boolbase@1.0.0</strong>
              {' '}
              https://github.com/fb55/boolbase
              <br />
              Copyright (c) 2014-2015, Felix Boehm &lt;me@feedic.com&gt;
            </li>

            <li>
              <strong>browserify-sign@4.0.4</strong>
              {' '}
              https://github.com/crypto-browserify/browserify-sign
              <br />
              Copyright (c) 2014-2015 Calvin Metcalf and browserify-sign contributors
            </li>

            <li>
              <strong>cacache@10.0.2</strong>
              {' '}
              https://github.com/zkat/cacache
              <br />
              Copyright (c) npm, Inc.
            </li>

            <li>
              <strong>chownr@1.0.1</strong>
              {' '}
              https://github.com/isaacs/chownr
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>cli-width@2.2.0</strong>
              {' '}
              https://github.com/knownasilya/cli-width
              <br />
              Copyright (c) 2015, Ilya Radchenko &lt;ilya@burstcreations.com&gt;
            </li>

            <li>
              <strong>cliui@2.1.0</strong>
              {' '}
              https://github.com/bcoe/cliui
              <br />
              Copyright (c) 2015, Contributors
            </li>

            <li>
              <strong>cliui@3.2.0</strong>
              {' '}
              https://github.com/bcoe/cliui
              <br />
              Copyright (c) 2015, Contributors
            </li>

            <li>
              <strong>cliui@4.0.0</strong>
              {' '}
              https://github.com/bcoe/cliui
              <br />
              Copyright (c) 2015, Contributors
            </li>

            <li>
              <strong>color-support@1.1.3</strong>
              {' '}
              https://github.com/isaacs/color-support
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>console-control-strings@1.1.0</strong>
              {' '}
              https://github.com/iarna/console-control-strings
              <br />
              Copyright (c) 2014, Rebecca Turner &lt;me@re-becca.org&gt;
            </li>

            <li>
              <strong>copy-concurrently@1.0.5</strong>
              {' '}
              https://github.com/npm/copy-concurrently
              <br />
              Copyright (c) 2017, Rebecca Turner &lt;me@re-becca.org&gt;
            </li>

            <li>
              <strong>detect-node@2.0.3</strong>
              {' '}
              https://github.com/iliakan/detect-node
              <br />
              Copyright (c) 2017 Ilya Kantor
            </li>

            <li>
              <strong>electron-to-chromium@1.3.30</strong>
              {' '}
              https://github.com/kilian/electron-to-chromium
            </li>

            <li>
              <strong>fs-minipass@1.2.5</strong>
              {' '}
              https://github.com/npm/fs-minipass
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>fs-write-stream-atomic@1.0.10</strong>
              {' '}
              https://github.com/npm/fs-write-stream-atomic
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>fs.realpath@1.0.0</strong>
              {' '}
              https://github.com/isaacs/fs.realpath
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>fstream-ignore@1.0.5</strong>
              {' '}
              https://github.com/isaacs/fstream-ignore
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>fstream@1.0.11</strong>
              {' '}
              https://github.com/npm/fstream
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>gather-stream@1.0.0</strong>
              {' '}
              https://github.com/natevw/gather-stream
              <br />
              Copyright (c) 2014, Nathan Vander Wilt
            </li>

            <li>
              <strong>gauge@2.7.4</strong>
              {' '}
              https://github.com/iarna/gauge
              <br />
              Copyright (c) 2014, Rebecca Turner &lt;me@re-becca.org&gt;
            </li>

            <li>
              <strong>get-caller-file@1.0.2</strong>
              {' '}
              https://github.com/stefanpenner/get-caller-file
            </li>

            <li>
              <strong>glob-parent@2.0.0 glob-parent@3.1.0</strong>
              {' '}
              https://github.com/es128/glob-parent
              <br />
              Copyright (c) 2015 Elan Shanker
            </li>

            <li>
              <strong>glob@4.5.3 glob@6.0.4 glob@7.1.2</strong>
              {' '}
              https://github.com/isaacs/node-glob
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>graceful-fs@3.0.11 graceful-fs@4.1.11</strong>
              {' '}
              https://github.com/isaacs/node-graceful-fs
              <br />
              Copyright (c) Isaac Z. Schlueter, Ben Noordhuis, and Contributors
            </li>

            <li>
              <strong>har-schema@1.0.5 har-schema@2.0.0</strong>
              {' '}
              https://github.com/ahmadnassri/har-schema
              <br />
              Copyright (c) 2015, Ahmad Nassri &lt;ahmad@ahmadnassri.com&gt;
            </li>

            <li>
              <strong>har-validator@2.0.6 har-validator@4.2.1 har-validator@5.0.3 har-validator@5.1.0</strong>
              {' '}
              https://github.com/ahmadnassri/har-validator
              <br />
              Copyright (c) 2015, Ahmad Nassri &lt;ahmad@ahmadnassri.com&gt;
            </li>

            <li>
              <strong>has-unicode@2.0.1</strong>
              {' '}
              https://github.com/iarna/has-unicode
              <br />
              Copyright (c) 2014, Rebecca Turner &lt;me@re-becca.org&gt;
            </li>

            <li>
              <strong>hosted-git-info@2.5.0</strong>
              {' '}
              https://github.com/npm/hosted-git-info
              <br />
              Copyright (c) 2015, Rebecca Turner
            </li>

            <li>
              <strong>icss-replace-symbols@1.1.0</strong>
              {' '}
              https://github.com/css-modules/icss-replace-symbols
              <br />
              Copyright (c) Glen Maddern, 2015.
            </li>

            <li>
              <strong>icss-utils@2.1.0</strong>
              {' '}
              https://github.com/css-modules/icss-utils
              <br />
              Glen Maddern and Bogdan Chadkin, 2015.
            </li>

            <li>
              <strong>in-publish@2.0.0</strong>
              {' '}
              https://github.com/iarna/in-publish
              <br />
              Copyright (c) 2015, Rebecca Turner &lt;me@re-becca.org&gt;
            </li>

            <li>
              <strong>inflight@1.0.6</strong>
              {' '}
              https://github.com/npm/inflight
              <br />
              Copyright (c) Isaac Z. Schlueter
            </li>

            <li>
              <strong>inherits@1.0.2 inherits@2.0.1 inherits@2.0.3</strong>
              {' '}
              https://github.com/isaacs/inherits
              <br />
              Copyright (c) Isaac Z. Schlueter
            </li>

            <li>
              <strong>ini@1.3.4</strong>
              {' '}
              https://github.com/isaacs/ini
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>ini@1.3.5</strong>
              {' '}
              https://github.com/isaacs/ini
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>isexe@2.0.0</strong>
              {' '}
              https://github.com/isaacs/isexe
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>json-stringify-safe@5.0.1</strong>
              {' '}
              https://github.com/isaacs/json-stringify-safe
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>killable@1.0.0</strong>
              {' '}
              https://github.com/marten-de-vries/killable
            </li>

            <li>
              <strong>lru-cache@2.6.5 lru-cache@2.7.3 lru-cache@4.1.1</strong>
              {' '}
              https://github.com/isaacs/node-lru-cache
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>minimalistic-assert@1.0.0</strong>
              {' '}
              https://github.com/calvinmetcalf/minimalistic-assert
              <br />
              Copyright 2015 Calvin Metcalf
            </li>

            <li>
              <strong>minimatch@2.0.10 minimatch@3.0.4</strong>
              {' '}
              https://github.com/isaacs/minimatch
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>minipass@2.2.1</strong>
              {' '}
              https://github.com/isaacs/minipass
            </li>

            <li>
              <strong>move-concurrently@1.0.1</strong>
              {' '}
              https://github.com/npm/move-concurrently
              <br />
              Copyright (c) 2017, Rebecca Turner &lt;me@re-becca.org&gt;
            </li>

            <li>
              <strong>mute-stream@0.0.5 mute-stream@0.0.7</strong>
              {' '}
              https://github.com/isaacs/mute-stream
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>natives@1.1.1</strong>
              {' '}
              https://github.com/isaacs/natives
            </li>

            <li>
              <strong>nopt@3.0.6 nopt@4.0.1</strong>
              {' '}
              https://github.com/npm/nopt
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>npmlog@4.1.0 npmlog@4.1.2</strong>
              {' '}
              https://github.com/npm/npmlog
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>once@1.3.3 once@1.4.0</strong>
              {' '}
              https://github.com/isaacs/once
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>osenv@0.1.4</strong>
              {' '}
              https://github.com/npm/osenv
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>parse-asn1@5.1.0</strong>
              {' '}
              https://github.com/crypto-browserify/parse-asn1
              <br />
              Copyright (c) 2017, crypto-browserify contributors
            </li>

            <li>
              <strong>postcss-modules-extract-imports@1.1.0 postcss-modules-scope@1.1.0</strong>
              {' '}
              https://github.com/css-modules/postcss-modules-extract-imports
              <br />
              Glen Maddern, 2015.
            </li>

            <li>
              <strong>postcss-modules-values@1.3.0</strong>
              {' '}
              https://github.com/css-modules/postcss-modules-values
              <br />
              Glen Maddern, 2015.
            </li>

            <li>
              <strong>promise-inflight@1.0.1</strong>
              {' '}
              https://github.com/iarna/promise-inflight
              <br />
              Copyright (c) 2017, Rebecca Turner &lt;me@re-becca.org&gt;
            </li>

            <li>
              <strong>pseudomap@1.0.2</strong>
              {' '}
              https://github.com/isaacs/pseudomap
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>remove-trailing-separator@1.1.0</strong>
              {' '}
              https://github.com/darsain/remove-trailing-separator
              <br />
              Copyright (c) 2017 Tomas Sardyha &lt;darsain@gmail.com&gt;
            </li>

            <li>
              <strong>require-main-filename@1.0.1</strong>
              {' '}
              https://github.com/yargs/require-main-filename
              <br />
              Copyright (c) 2016, Contributors
            </li>

            <li>
              <strong>rimraf@2.6.1 rimraf@2.6.2</strong>
              {' '}
              https://github.com/isaacs/rimraf
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>run-queue@1.0.3</strong>
              {' '}
              https://github.com/iarna/run-queue
            </li>

            <li>
              <strong>sax@1.2.4</strong>
              {' '}
              https://github.com/isaacs/sax-js
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>semver@4.3.6 semver@5.0.3 semver@5.3.0 semver@5.4.1</strong>
              {' '}
              https://github.com/npm/node-semver
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>set-blocking@2.0.0</strong>
              {' '}
              https://github.com/yargs/set-blocking
              <br />
              Copyright (c) 2016, Contributors
            </li>

            <li>
              <strong>setprototypeof@1.0.3 setprototypeof@1.1.0</strong>
              {' '}
              https://github.com/wesleytodd/setprototypeof
              <br />
              Copyright (c) 2015, Wes Todd
            </li>

            <li>
              <strong>sigmund@1.0.1</strong>
              {' '}
              https://github.com/isaacs/sigmund
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>signal-exit@3.0.2</strong>
              {' '}
              https://github.com/tapjs/signal-exit
              <br />
              Copyright (c) 2015, Contributors
            </li>

            <li>
              <strong>ssri@5.0.0</strong>
              {' '}
              https://github.com/zkat/ssri
              <br />
              Copyright (c) npm, Inc.
            </li>

            <li>
              <strong>tar@2.2.1 tar@4.2.0</strong>
              {' '}
              https://github.com/isaacs/node-tar
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>uid-number@0.0.6</strong>
              {' '}
              https://github.com/isaacs/uid-number
              <br />
              Copyright (c) Isaac Z. Schlueter
            </li>

            <li>
              <strong>unique-filename@1.1.0</strong>
              {' '}
              https://github.com/iarna/unique-filename
            </li>

            <li>
              <strong>unique-slug@2.0.0</strong>
              {' '}
              https://github.com/iarna/unique-slug
            </li>

            <li>
              <strong>which-module@1.0.0 which-module@2.0.0</strong>
              {' '}
              https://github.com/nexdrew/which-module
              <br />
              Copyright (c) 2016, Contributors
            </li>

            <li>
              <strong>which@1.3.0</strong>
              {' '}
              https://github.com/isaacs/node-which
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>wide-align@1.1.2</strong>
              {' '}
              https://github.com/iarna/wide-align
              <br />
              Copyright (c) 2015, Rebecca Turner &lt;me@re-becca.org&gt;
            </li>

            <li>
              <strong>wrappy@1.0.2</strong>
              {' '}
              https://github.com/npm/wrappy
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>y18n@3.2.1 y18n@4.0.0</strong>
              {' '}
              https://github.com/yargs/y18n
              <br />
              Copyright (c) 2015, Contributors
            </li>

            <li>
              <strong>yallist@2.1.2 yallist@3.0.2</strong>
              {' '}
              https://github.com/isaacs/yallist
              <br />
              Copyright (c) Isaac Z. Schlueter and Contributors
            </li>

            <li>
              <strong>yargs-parser@4.2.1 yargs-parser@5.0.0 yargs-parser@7.0.0 yargs-parser@8.1.0</strong>
              {' '}
              https://github.com/yargs/yargs-parser
              <br />
              Copyright (c) 2016, Contributors
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <strong>ISC license full text:</strong>
            <p>
              Permission to use, copy, modify, and/or distribute this software for any
              purpose with or without fee is hereby granted, provided that the above
              copyright notice and this permission notice appear in all copies.
            </p>
            <p>
              THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
              WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
              MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
              ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
              WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
              ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
              IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <p><strong>Apache 2.0 License</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>ansi-html@0.0.7</strong>
              {' '}
              https://github.com/Tjatse/ansi-html
            </li>

            <li>
              <strong>aws-sign2@0.6.0</strong>
              {' '}
              https://github.com/mikeal/aws-sign
            </li>

            <li>
              <strong>aws-sign2@0.7.0</strong>
              {' '}
              https://github.com/mikeal/aws-sign
            </li>

            <li>
              <strong>caseless@0.11.0</strong>
              {' '}
              https://github.com/mikeal/caseless
            </li>

            <li>
              <strong>caseless@0.12.0</strong>
              {' '}
              https://github.com/mikeal/caseless
            </li>

            <li>
              <strong>detect-libc@1.0.2</strong>
              {' '}
              https://github.com/lovell/detect-libc
            </li>

            <li>
              <strong>detect-libc@1.0.3</strong>
              {' '}
              https://github.com/lovell/detect-libc
            </li>

            <li>
              <strong>doctrine@2.1.0</strong>
              {' '}
              https://github.com/eslint/doctrine
            </li>

            <li>
              <strong>ejs@2.5.7</strong>
              {' '}
              https://github.com/mde/ejs
            </li>

            <li>
              <strong>eslint-visitor-keys@1.0.0</strong>
              {' '}
              https://github.com/eslint/eslint-visitor-keys
              <br />
              Copyright contributors
            </li>

            <li>
              <strong>forever-agent@0.6.1</strong>
              {' '}
              https://github.com/mikeal/forever-agent
            </li>

            <li>
              <strong>kew@0.7.0</strong>
              {' '}
              https://github.com/Medium/kew
              <br />
              Copyright 2012 The Obvious Corporation. http://obvious.com/
            </li>

            <li>
              <strong>log4js@2.4.1</strong>
              {' '}
              https://github.com/log4js-node/log4js-node
              <br />
              Copyright 2015 Gareth Jones (with contributions from many other people)
            </li>

            <li>
              <strong>oauth-sign@0.8.2</strong>
              {' '}
              https://github.com/mikeal/oauth-sign
            </li>

            <li>
              <strong>phantomjs-prebuilt@2.1.16</strong>
              {' '}
              https://github.com/Medium/phantomjs
              <br />
              Copyright 2012 The Obvious Corporation. http://obvious.com/
            </li>

            <li>
              <strong>request@2.75.0 request@2.79.0 request@2.81.0 request@2.83.0</strong>
              {' '}
              https://github.com/request/request
            </li>

            <li>
              <strong>rxjs@5.5.6</strong>
              {' '}
              https://github.com/ReactiveX/RxJS
              <br />
              Copyright (c) 2015-2017 Google, Inc., Netflix, Inc., Microsoft Corp. and contributors
            </li>

            <li>
              <strong>spdx-correct@1.0.2</strong>
              {' '}
              https://github.com/kemitchell/spdx-correct.js
            </li>

            <li>
              <strong>true-case-path@1.0.2</strong>
              {' '}
              https://github.com/barsh/true-case-path
            </li>

            <li>
              <strong>tunnel-agent@0.4.3 tunnel-agent@0.6.0</strong>
              {' '}
              https://github.com/mikeal/tunnel-agent
            </li>

            <li>
              <strong>validate-npm-package-license@3.0.1</strong>
              {' '}
              https://github.com/kemitchell/validate-npm-package-license.js
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <strong>Apache License full text:</strong>

            <p>
              Apache License
              <br />
              Version 2.0, January 2004
              <br />
              <a href="http://www.apache.org/licenses/">http://www.apache.org/licenses/</a>
            </p>
            <p>TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION</p>
            <p>
              <strong>1. Definitions</strong>
              .
            </p>
            <p>
              "License" shall mean the terms and conditions for use, reproduction, and
              distribution as defined by Sections 1 through 9 of this document.
            </p>
            <p>
              "Licensor" shall mean the copyright owner or entity authorized by the
              copyright owner that is granting the License.
            </p>
            <p>
              "Legal Entity" shall mean the union of the acting entity and all other
              entities that control, are controlled by, or are under common control with
              that entity. For the purposes of this definition, "control" means (i) the
              power, direct or indirect, to cause the direction or management of such
              entity, whether by contract or otherwise, or (ii) ownership of fifty
              percent (50%) or more of the outstanding shares, or (iii) beneficial
              ownership of such entity.
            </p>
            <p>
              "You" (or "Your") shall mean an individual or Legal Entity exercising
              permissions granted by this License.
            </p>
            <p>
              "Source" form shall mean the preferred form for making modifications,
              including but not limited to software source code, documentation source,
              and configuration files.
            </p>
            <p>
              "Object" form shall mean any form resulting from mechanical transformation
              or translation of a Source form, including but not limited to compiled
              object code, generated documentation, and conversions to other media types.
            </p>
            <p>
              "Work" shall mean the work of authorship, whether in Source or Object form,
              made available under the License, as indicated by a copyright notice that
              is included in or attached to the work (an example is provided in the
              Appendix below).
            </p>
            <p>
              "Derivative Works" shall mean any work, whether in Source or Object form,
              that is based on (or derived from) the Work and for which the editorial
              revisions, annotations, elaborations, or other modifications represent, as
              a whole, an original work of authorship. For the purposes of this License,
              Derivative Works shall not include works that remain separable from, or
              merely link (or bind by name) to the interfaces of, the Work and Derivative
              Works thereof.
            </p>
            <p>
              "Contribution" shall mean any work of authorship, including the original
              version of the Work and any modifications or additions to that Work or
              Derivative Works thereof, that is intentionally submitted to Licensor for
              inclusion in the Work by the copyright owner or by an individual or Legal
              Entity authorized to submit on behalf of the copyright owner. For the
              purposes of this definition, "submitted" means any form of electronic,
              verbal, or written communication sent to the Licensor or its
              representatives, including but not limited to communication on electronic
              mailing lists, source code control systems, and issue tracking systems that
              are managed by, or on behalf of, the Licensor for the purpose of discussing
              and improving the Work, but excluding communication that is conspicuously
              marked or otherwise designated in writing by the copyright owner as "Not a
              Contribution."
            </p>
            <p>
              "Contributor" shall mean Licensor and any individual or Legal Entity on
              behalf of whom a Contribution has been received by Licensor and
              subsequently incorporated within the Work.
            </p>
            <p>
              <strong>2. Grant of Copyright License</strong>
              . Subject to the
              terms and conditions of this License, each Contributor hereby grants to You
              a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable
              copyright license to reproduce, prepare Derivative Works of, publicly
              display, publicly perform, sublicense, and distribute the Work and such
              Derivative Works in Source or Object form.
            </p>
            <p>
              <strong>3. Grant of Patent License</strong>
              . Subject to the terms
              and conditions of this License, each Contributor hereby grants to You a
              perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable
              (except as stated in this section) patent license to make, have made, use,
              offer to sell, sell, import, and otherwise transfer the Work, where such
              license applies only to those patent claims licensable by such Contributor
              that are necessarily infringed by their Contribution(s) alone or by
              combination of their Contribution(s) with the Work to which such
              Contribution(s) was submitted. If You institute patent litigation against
              any entity (including a cross-claim or counterclaim in a lawsuit) alleging
              that the Work or a Contribution incorporated within the Work constitutes
              direct or contributory patent infringement, then any patent licenses
              granted to You under this License for that Work shall terminate as of the
              date such litigation is filed.
            </p>
            <p>
              <strong>4. Redistribution</strong>
              . You may reproduce and
              distribute copies of the Work or Derivative Works thereof in any medium,
              with or without modifications, and in Source or Object form, provided that
              You meet the following conditions:
            </p>
            <ol style={{ listStyleType: 'lower-latin' }}>
              <li>
                You must give any other recipients of the Work or Derivative Works a
                copy of this License; and
              </li>

              <li>
                You must cause any modified files to carry prominent notices stating
                that You changed the files; and
              </li>

              <li>
                You must retain, in the Source form of any Derivative Works that You
                distribute, all copyright, patent, trademark, and attribution notices from
                the Source form of the Work, excluding those notices that do not pertain to
                any part of the Derivative Works; and
              </li>

              <li>
                If the Work includes a "NOTICE" text file as part of its distribution,
                then any Derivative Works that You distribute must include a readable copy
                of the attribution notices contained within such NOTICE file, excluding
                those notices that do not pertain to any part of the Derivative Works, in
                at least one of the following places: within a NOTICE text file distributed
                as part of the Derivative Works; within the Source form or documentation,
                if provided along with the Derivative Works; or, within a display generated
                by the Derivative Works, if and wherever such third-party notices normally
                appear. The contents of the NOTICE file are for informational purposes only
                and do not modify the License. You may add Your own attribution notices
                within Derivative Works that You distribute, alongside or as an addendum to
                the NOTICE text from the Work, provided that such additional attribution
                notices cannot be construed as modifying the License.
                <br />
                <br />
                You may add Your own copyright statement to Your modifications and may
                provide additional or different license terms and conditions for use,
                reproduction, or distribution of Your modifications, or for any such
                Derivative Works as a whole, provided Your use, reproduction, and
                distribution of the Work otherwise complies with the conditions stated in
                this License.
              </li>
            </ol>
            <p>
              <strong>5. Submission of Contributions</strong>
              . Unless You
              explicitly state otherwise, any Contribution intentionally submitted for
              inclusion in the Work by You to the Licensor shall be under the terms and
              conditions of this License, without any additional terms or conditions.
              Notwithstanding the above, nothing herein shall supersede or modify the
              terms of any separate license agreement you may have executed with Licensor
              regarding such Contributions.
            </p>
            <p>
              <strong>6. Trademarks</strong>
              . This License does not grant
              permission to use the trade names, trademarks, service marks, or product
              names of the Licensor, except as required for reasonable and customary use
              in describing the origin of the Work and reproducing the content of the
              NOTICE file.
            </p>
            <p>
              <strong>7. Disclaimer of Warranty</strong>
              . Unless required by
              applicable law or agreed to in writing, Licensor provides the Work (and
              each Contributor provides its Contributions) on an "AS IS" BASIS, WITHOUT
              WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied, including,
              without limitation, any warranties or conditions of TITLE,
              NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A PARTICULAR PURPOSE. You
              are solely responsible for determining the appropriateness of using or
              redistributing the Work and assume any risks associated with Your exercise
              of permissions under this License.
            </p>
            <p>
              <strong>8. Limitation of Liability</strong>
              . In no event and
              under no legal theory, whether in tort (including negligence), contract, or
              otherwise, unless required by applicable law (such as deliberate and
              grossly negligent acts) or agreed to in writing, shall any Contributor be
              liable to You for damages, including any direct, indirect, special,
              incidental, or consequential damages of any character arising as a result
              of this License or out of the use or inability to use the Work (including
              but not limited to damages for loss of goodwill, work stoppage, computer
              failure or malfunction, or any and all other commercial damages or losses),
              even if such Contributor has been advised of the possibility of such
              damages.
            </p>
            <p>
              <strong>9. Accepting Warranty or Additional Liability</strong>
              .
              While redistributing the Work or Derivative Works thereof, You may choose
              to offer, and charge a fee for, acceptance of support, warranty, indemnity,
              or other liability obligations and/or rights consistent with this License.
              However, in accepting such obligations, You may act only on Your own behalf
              and on Your sole responsibility, not on behalf of any other Contributor,
              and only if You agree to indemnify, defend, and hold each Contributor
              harmless for any liability incurred by, or claims asserted against, such
              Contributor by reason of your accepting any such warranty or additional
              liability.
            </p>
            <p>END OF TERMS AND CONDITIONS</p>

            <ul>
              <li>
                For eslint-visitor-keys@1.0.0 see also this required NOTICE:
                <br />
                Copyright contributors
              </li>
            </ul>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>rx-lite-aggregates@4.0.8</strong>
              {' '}
              https://github.com/Reactive-Extensions/RxJS
              <br />
              Copyright (c) Microsoft Open Technologies, Inc.  All rights reserved.
              <br />
              Microsoft Open Technologies would like to thank its contributors, a list
              of whom are at http://rx.codeplex.com/wikipage?title=Contributors.
            </li>

            <li>
              <strong>rx-lite@3.1.2 rx-lite@4.0.8 rx@4.1.0</strong>
              {' '}
              https://github.com/Reactive-Extensions/RxJS
              <br />
              Copyright (c) Microsoft.  All rights reserved.
              <br />
              Microsoft Open Technologies would like to thank its contributors, a list
              of whom are at http://rx.codeplex.com/wikipage?title=Contributors
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Licensed under the Apache License, Version 2.0 (the "License"); you
              may not use this file except in compliance with the License. You may
              obtain a copy of the License at
            </p>

            <p>http://www.apache.org/licenses/LICENSE-2.0</p>

            <p>
              Unless required by applicable law or agreed to in writing, software
              distributed under the License is distributed on an "AS IS" BASIS,
              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or
              implied. See the License for the specific language governing permissions
              and limitations under the License.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>bcrypt-pbkdf@1.0.1</strong>
              {' '}
              https://www.npmjs.com/package/bcrypt-pbkdf
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ol>
              <li>
                Redistributions of source code must retain the above copyright notice,
                this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright notice,
                this list of conditions and the following disclaimer in the documentation
                and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of the copyright holder nor the names of its
                contributors may be used to endorse or promote products derived
                from this software without specific prior written permission.
              </li>
            </ol>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS AND CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>boom@2.10.1</strong>
              {' '}
              https://github.com/hapijs/boom
              Copyright (c) 2012-2014, Walmart and other contributors.
              <br />
              All rights reserved.
            </li>

            <li>
              <strong>boom@4.3.1 boom@5.2.0 boom@7.1.1</strong>
              {' '}
              https://github.com/hapijs/boom
              Copyright (c) 2012-2017, Project contributors.
              <br />
              Copyright (c) 2012-2014, Walmart.
              <br />
              All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                The names of any contributors may not be used to endorse or promote
                products derived from this software without specific prior written
                permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS AND CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>

            <p className="center">*   *   *</p>

            <p>
              The complete list of contributors can be found at:
              https://github.com/hapijs/boom/graphs/contributors
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <strong>The Amazon Author product also includes the following third-party software/licensing:</strong>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>bounce@1.2.0</strong>
              {' '}
              https://github.com/hapijs/bounce
              <br />
              Copyright (c) 2017, Project contributors.
              <br />
              All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                The names of any contributors may not be used to endorse or promote
                products derived from this software without specific prior written
                permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS AND CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>

            <p className="center">*   *   *</p>

            <p>
              The complete list of contributors can be found at:
              https://github.com/hapijs/bounce/graphs/contributors
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>cryptiles@2.0.5</strong>
              {' '}
              https://github.com/hapijs/cryptiles
              <br />
              Copyright (c) 2014, Eran Hammer and other contributors.
              <br />
              All rights reserved.
            </li>

            <li>
              <strong>cryptiles@3.1.2 cryptiles@4.1.1</strong>
              {' '}
              https://github.com/hapijs/cryptiles
              <br />
              Copyright (c) 2014-2017, Eran Hammer and Project contributors
              <br />
              All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                The names of any contributors may not be used to endorse or promote
                products derived from this software without specific prior written
                permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS AND CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>

            <p className="center">*   *   *</p>

            <p>
              The complete list of contributors can be found at:
              https://github.com/hueniverse/cryptiles/graphs/contributors
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>css-mediaquery@0.1.2</strong>
              {' '}
              https://github.com/ericf/css-mediaquery
              <br />
              Copyright 2014 Yahoo! Inc.
              <br />
              All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of the Yahoo! Inc. nor the
                names of its contributors may be used to endorse or promote products
                derived from this software without specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL YAHOO! INC. BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <p><strong>BSD 2-Clause</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>css-select@1.3.0-rc0</strong>
              {' '}
              https://github.com/fb55/css-select
              <br />
              Copyright (c) Felix Böhm
              <br />
              All rights reserved.
            </li>

            <li>
              <strong>css-what@2.1.0</strong>
              {' '}
              https://github.com/fb55/css-what
              <br />
              Copyright (c) Felix Böhm
              <br />
              All rights reserved.
            </li>

            <li>
              <strong>doctrine@1.5.0</strong>
              {' '}
              https://github.com/eslint/doctrine
              <br />
              Copyright jQuery Foundation and other contributors, https://jquery.org/
            </li>

            <li>
              <strong>domelementtype@1.1.3 domelementtype@1.3.0</strong>
              {' '}
              https://github.com/FB55/domelementtype
              <br />
              Copyright (c) Felix Böhm
              <br />
              All rights reserved.
            </li>

            <li>
              <strong>domutils@1.5.1 domutils@1.5.1</strong>
              {' '}
              https://github.com/FB55/domutils
              <br />
              Copyright (c) Felix Böhm
              <br />
              All rights reserved.
            </li>

            <li>
              <strong>entities@1.1.1</strong>
              {' '}
              https://github.com/fb55/node-entities
              <br />
              Copyright (c) Felix Böhm
              <br />
              All rights reserved.
            </li>

            <li>
              <strong>escodegen@1.9.0</strong>
              {' '}
              https://github.com/estools/escodegen
              <br />
              Copyright (C) 2012 Yusuke Suzuki (twitter: @Constellation) and other contributors.
            </li>

            <li>
              <strong>escope@3.6.0</strong>
              {' '}
              https://github.com/estools/escope
              <br />
              Copyright (C) 2012-2013 Yusuke Suzuki (twitter: @Constellation) and other contributors.
            </li>

            <li>
              <strong>eslint-scope@3.7.1</strong>
              {' '}
              https://github.com/eslint/eslint-scope
              <br />
              Copyright JS Foundation and other contributors, https://js.foundation
              <br />
              Copyright (C) 2012-2013 Yusuke Suzuki (twitter: @Constellation) and other contributors.
            </li>

            <li>
              <strong>espree@3.5.2</strong>
              {' '}
              https://github.com/eslint/espree
              <br />
              Copyright JS Foundation and other contributors, https://js.foundation
            </li>

            <li>
              <strong>esprima@2.7.3 esprima@3.1.3 esprima@3.1.3 esprima@4.0.0</strong>
              {' '}
              https://github.com/jquery/esprima
              <br />
              Copyright (c) jQuery Foundation, Inc. and Contributors, All Rights Reserved.
            </li>

            <li>
              <strong>esrecurse@4.2.0</strong>
              {' '}
              https://github.com/estools/esrecurse
              <br />
              Copyright (C) 2014 Yusuke Suzuki (https://github.com/Constellation)
              (twitter: @Constellation (https://twitter.com/Constellation)) and other contributors.
            </li>

            <li>
              <strong>estraverse@4.2.0</strong>
              {' '}
              https://github.com/estools/estraverse
              <br />
              Copyright (C) 2012-2016 Yusuke Suzuki (twitter: @Constellation) and other contributors.
            </li>

            <li>
              <strong>esutils@2.0.2</strong>
              {' '}
              https://github.com/estools/esutils
              <br />
              Copyright (C) 2013 Yusuke Suzuki (twitter: @Constellation) and other contributors.
            </li>

            <li>
              <strong>extract-zip@1.6.6</strong>
              {' '}
              https://github.com/maxogden/extract-zip
              <br />
              Copyright (c) 2014 Max Ogden and other contributors All rights reserved.
            </li>

            <li>
              <strong>glob@3.1.21</strong>
              {' '}
              https://github.com/isaacs/node-glob
              <br />
              Copyright (c) Isaac Z. Schlueter ('Author') All rights reserved.
            </li>

            <li>
              <strong>graceful-fs@1.2.3</strong>
              {' '}
              https://github.com/isaacs/node-graceful-fs
              <br />
              Copyright (c) Isaac Z. Schlueter ('Author') All rights reserved.
            </li>

            <li>
              <strong>mississippi@1.3.0</strong>
              {' '}
              https://github.com/maxogden/mississippi
            </li>

            <li>
              <strong>normalize-package-data@2.4.0</strong>
              {' '}
              https://github.com/npm/normalize-package-data
              This package contains code originally written by Isaac Z. Schlueter. Used with permission.
              <br />
              Copyright (c) Meryn Stol ('Author') All rights reserved.
            </li>

            <li>
              <strong>nth-check@1.0.1</strong>
              {' '}
              https://github.com/fb55/nth-check
              <br />
              Copyright (c) Felix Böhm
              <br />
              All rights reserved.
            </li>

            <li>
              <strong>regjsparser@0.1.5 regjsparser@0.2.1</strong>
              {' '}
              https://github.com/jviereck/regjsparser
              <br />
              Copyright (c) Julian Viereck and Contributors, All Rights Reserved.
            </li>

            <li>
              <strong>tar-pack@3.4.0 tar-pack@3.4.1</strong>
              {' '}
              https://github.com/ForbesLindesay/tar-pack
              <br />
              Copyright (c) 2014, Forbes Lindesay All rights reserved.
            </li>

            <li>
              <strong>uglify-es@3.3.5 uglify-js@2.8.29 uglify-js@3.3.5</strong>
              {' '}
              https://github.com/mishoo/UglifyJS2
              <br />
              Copyright 2012-2013 (c) Mihai Bazon &lt;mihai.bazon@gmail.com&gt;
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p><strong>BSD 2-Clause Full Text</strong></p>

            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL &lt;COPYRIGHT HOLDER&gt; BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
              THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>


        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <p><strong>BSD 3-Clause</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>d3-array@1.2.1</strong>
              {' '}
              https://github.com/d3/d3-array
              <br />
              Copyright 2010-2016 Mike Bostock All rights reserved.
            </li>

            <li>
              <strong>d3-collection@1.0.4</strong>
              {' '}
              https://github.com/d3/d3-collection
              <br />
              Copyright 2010-2016, Mike Bostock All rights reserved.
            </li>

            <li>
              <strong>d3-color@1.0.3</strong>
              {' '}
              https://github.com/d3/d3-color
              <br />
              Copyright 2010-2016 Mike Bostock All rights reserved.
            </li>

            <li>
              <strong>d3-format@1.2.2</strong>
              {' '}
              https://github.com/d3/d3-format
              <br />
              Copyright 2010-2015 Mike Bostock All rights reserved.
            </li>

            <li>
              <strong>d3-interpolate@1.1.6</strong>
              {' '}
              https://github.com/d3/d3-interpolate
              <br />
              Copyright 2010-2016 Mike Bostock All rights reserved.
            </li>

            <li>
              <strong>d3-path@1.0.5</strong>
              {' '}
              https://github.com/d3/d3-path
              <br />
              Copyright 2015-2016 Mike Bostock All rights reserved.
            </li>

            <li>
              <strong>d3-scale@1.0.6</strong>
              {' '}
              https://github.com/d3/d3-scale
              <br />
              Copyright 2010-2015 Mike Bostock All rights reserved.
            </li>

            <li>
              <strong>d3-scale@1.0.7</strong>
              {' '}
              https://github.com/d3/d3-scale
              <br />
              Copyright 2010-2015 Mike Bostock All rights reserved.
            </li>

            <li>
              <strong>d3-shape@1.2.0</strong>
              {' '}
              https://github.com/d3/d3-shape
              <br />
              Copyright 2010-2015 Mike Bostock All rights reserved.
            </li>

            <li>
              <strong>d3-time-format@2.1.1</strong>
              {' '}
              https://github.com/d3/d3-time-format
              <br />
              Copyright 2010-2017 Mike Bostock All rights reserved.
            </li>

            <li>
              <strong>d3-time@1.0.8</strong>
              {' '}
              https://github.com/d3/d3-time
              <br />
              Copyright 2010-2016 Mike Bostock All rights reserved.
            </li>

            <li>
              <strong>json-schema@0.2.3</strong>
              {' '}
              https://github.com/kriszyp/json-schema
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p><strong>BSD 2-Clause Full Text</strong></p>

            <p>
              Redistribution and use in source and binary forms, with or without modification,
              are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright notice, this
                list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright notice,
                this list of conditions and the following disclaimer in the documentation
                and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of the author nor the names of contributors may be used to
                endorse or promote products derived from this software without specific prior
                written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
              ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
              ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>duplexer2@0.0.2</strong>
              {' '}
              https://github.com/deoxxa/duplexer2
              <br />
              Copyright (c) 2013, Deoxxa Development
              <br />
              All rights reserved.
            </li>

            <li>
              <strong>duplexer2@0.1.4</strong>
              {' '}
              https://github.com/deoxxa/duplexer2
              <br />
              Copyright (c) 2013, Deoxxa Development
              <br />
              All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ol>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of Deoxxa Development nor the names of its contributors
                may be used to endorse or promote products derived from this software
                without specific prior written permission.
              </li>
            </ol>
            <p>
              THIS SOFTWARE IS PROVIDED BY DEOXXA DEVELOPMENT ''AS IS'' AND ANY
              EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL DEOXXA DEVELOPMENT BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>esquery@1.0.0</strong>
              {' '}
              https://github.com/jrfeenst/esquery
              <br />
              Copyright (c) 2013, Joel Feenstra
              All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of the ESQuery nor the names of its contributors may
                be used to endorse or promote products derived from this software without
                specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL JOEL FEENSTRA BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>fbemitter@2.1.1</strong>
              {' '}
              https://github.com/facebook/emitter
              <br />
              BSD License  For emitter software
              <br />
              Copyright (c) 2013-present, Facebook, Inc. All rights reserved.
            </li>

            <li>
              <strong>fbjs@0.1.0-alpha.7</strong>
              {' '}
              https://github.com/facebook/fbjs
              <br />
              BSD License  For fbjs software  Copyright (c) 2013-2015, Facebook, Inc.
              <br />
              All rights reserved.
            </li>

            <li>
              <strong>flux@2.1.1</strong>
              {' '}
              https://github.com/facebook/flux
              <br />
              BSD License  For Flux software  Copyright (c) 2014-2015, Facebook, Inc.
              <br />
              All rights reserved.
            </li>

            <li>
              <strong>flux@3.1.3</strong>
              {' '}
              https://github.com/facebook/flux
              <br />
              BSD License  For Flux software  Copyright (c) 2014-present, Facebook, Inc.
              <br />
              All rights reserved.
            </li>

            <li>
              <strong>warning@3.0.0</strong>
              {' '}
              https://github.com/BerkeleyTrue/warning
              BSD License  For React software  Copyright (c) 2013-2015, Facebook, Inc.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name Facebook nor the names of its contributors may
                be used to endorse or promote products derived from this software without
                specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS AND CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>filesize@3.5.11</strong>
              {' '}
              https://github.com/avoidwork/filesize.js
              <br />
              Copyright (c) 2017, Jason Mulligan All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name filesize nor the names of its contributors may
                be used to endorse or promote products derived from this software without
                specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS AND CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>hawk@3.1.3</strong>
              {' '}
              https://github.com/hueniverse/hawk
              <br />
              Copyright (c) 2012-2014, Eran Hammer and other contributors. All rights reserved.
            </li>

            <li>
              <strong>hawk@6.0.2</strong>
              {' '}
              https://github.com/hueniverse/hawk
              <br />
              Copyright (c) 2012-2017, Eran Hammer and Project contributors
            </li>

            <li>
              <strong>hawk@7.0.6</strong>
              {' '}
              https://github.com/hueniverse/hawk
              <br />
              Copyright (c) 2012-2017, Eran Hammer and Project contributors
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                The names of any contributors may not be used to endorse or promote
                products derived from this software without specific prior written
                permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS AND CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
            <p className="center">*   *   *</p>

            <p>
              The complete list of contributors can be found at:
              https://github.com/hueniverse/hawk/graphs/contributors
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>hoek@2.16.3</strong>
              {' '}
              https://github.com/hapijs/hoek
              <br />
              Copyright (c) 2011-2014, Walmart and other contributors.
              <br />
              Copyright (c) 2011, Yahoo Inc.
              <br />
              All rights reserved.
            </li>

            <li>
              <strong>hoek@4.2.0</strong>
              {' '}
              https://github.com/hapijs/hoek
              <br />
              Copyright (c) 2011-2016, Project contributors
              <br />
              Copyright (c) 2011-2014, Walmart
              <br />
              Copyright (c) 2011, Yahoo Inc.
              <br />
              All rights reserved.
            </li>

            <li>
              <strong>hoek@5.0.2</strong>
              {' '}
              https://github.com/hapijs/hoek
              <br />
              Copyright (c) 2011-2017, Project contributors
              <br />
              Copyright (c) 2011-2014, Walmart
              <br />
              Copyright (c) 2011, Yahoo Inc.
              <br />
              All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                The names of any contributors may not be used to endorse or promote
                products derived from this software without specific prior written
                permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS AND CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>

            <p className="center">*   *   *</p>
            <p>
              The complete list of contributors can be found at:
              https://github.com/hapijs/hapi/graphs/contributors
              Portions of this project were initially based on the Yahoo! Inc.
              Postmile project, published at https://github.com/yahoo/postmile.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>hoist-non-react-statics@1.2.0</strong>
              {' '}
              https://github.com/mridgway/hoist-non-react-statics
              <br />
              Copyright (c) 2015, Yahoo! Inc. All rights reserved.
            </li>

            <li>
              <strong>hoist-non-react-statics@2.3.1</strong>
              {' '}
              https://github.com/mridgway/hoist-non-react-statics
              <br />
              Copyright (c) 2015, Yahoo! Inc. All rights reserved.
            </li>

            <li>
              <strong>serialize-javascript@1.4.0</strong>
              {' '}
              https://github.com/yahoo/serialize-javascript
              <br />
              Copyright 2014 Yahoo! Inc. All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use of this software in source and binary forms,
              with or without modification, are permitted provided that the following
              conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of Yahoo! Inc. nor the names of YUI's contributors may be
                used to endorse or promote products derived from this software without
                specific prior written permission of Yahoo! Inc.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>hyphenate-style-name@1.0.2</strong>
              {' '}
              https://github.com/rexxars/hyphenate-style-name
              <br />
              Copyright (c) 2015, Espen Hovlandsdal All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use of this software in source and binary forms,
              with or without modification, are permitted provided that the following
              conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of hyphenate-style-name nor the names of its
                contributors may be used to endorse or promote products derived from
                this software without specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>ieee754@1.1.8</strong>
              {' '}
              https://github.com/feross/ieee754
              <br />
              Copyright (c) 2008, Fair Oaks Labs, Inc. All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use of this software in source and binary forms,
              with or without modification, are permitted provided that the following
              conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of Fair Oaks Labs, nor the names of its
                contributors may be used to endorse or promote products derived from
                this software without specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>invariant@2.2.2</strong>
              {' '}
              https://github.com/zertosh/invariant
              <br />
              Copyright (c) 2016, Andres Suarez All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use of this software in source and binary forms,
              with or without modification, are permitted provided that the following
              conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of invariant, nor the names of its
                contributors may be used to endorse or promote products derived from
                this software without specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>js-base64@2.4.0</strong>
              {' '}
              https://github.com/dankogai/js-base64
              <br />
              Copyright (c) 2014, Dan Kogai All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use of this software in source and binary forms,
              with or without modification, are permitted provided that the following
              conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of &lt;project&gt;, nor the names of its
                contributors may be used to endorse or promote products derived from
                this software without specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>


        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>node-forge@0.6.33</strong>
              {' '}
              https://github.com/digitalbazaar/forge
              <br />
              Copyright (c) 2010, Digital Bazaar, Inc.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use of this software in source and binary forms,
              with or without modification, are permitted provided that the following
              conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of Digital Bazaar, Inc., nor the names of its
                contributors may be used to endorse or promote products derived from
                this software without specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>node-pre-gyp@0.6.39</strong>
              {' '}
              https://github.com/mapbox/node-pre-gyp
              <br />
              Copyright (c), Mapbox  All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use of this software in source and binary forms,
              with or without modification, are permitted provided that the following
              conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of node-pre-gyp, nor the names of its
                contributors may be used to endorse or promote products derived from
                this software without specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>qs@6.2.3 qs@6.3.2 qs@6.4.0 qs@6.5.1</strong>
              {' '}
              https://github.com/ljharb/qs
              <br />
              Copyright (c) 2014 Nathan LaFreniere and other contributors. All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                The names of any contributors may not be used to endorse or promote
                products derived from this software without specific prior written
                permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS AND CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>

            <p className="center">*   *   *</p>
            <p>
              The complete list of contributors can be found at:
              https://github.com/hapijs/qs/graphs/contributors
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>react-transition-group@2.2.1</strong>
              {' '}
              https://github.com/reactjs/react-transition-group
              <br />
              Copyright (c) 2016, React Community Forked from
              <br />
              React (https://github.com/facebook/react)
              <br />
              Copyright 2013-present, Facebook, Inc. All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright notice, this
                list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright notice,
                this list of conditions and the following disclaimer in the documentation
                and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of the copyright holder nor the names of its
                contributors may be used to endorse or promote products derived from
                this software without specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
              FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
              DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
              SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
              CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
              OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
              OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>shelljs@0.6.1</strong>
              {' '}
              https://github.com/shelljs/shelljs
              <br />
              Copyright (c) 2012, Artur Adib &lt;arturadib@gmail.com&gt;
              <br />
              All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>You may use this project under the terms of the New BSD license as follows:</p>

            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of Artur Adib nor the
                names of the contributors may be used to endorse or promote products
                derived from this software without specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
              AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
              IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
              ARE DISCLAIMED. IN NO EVENT SHALL ARTUR ADIB BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF
              THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>sntp@1.0.9</strong>
              {' '}
              https://github.com/hueniverse/sntp
              <br />
              Copyright (c) 2012-2014, Eran Hammer and other contributors. All rights reserved.
            </li>

            <li>
              <strong>sntp@2.1.0 sntp@3.0.1</strong>
              {' '}
              https://github.com/hueniverse/sntp
              <br />
              Copyright (c) 2012-2016, Eran Hammer and Project contributors All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                The names of any contributors may not be used to endorse or promote
                products derived from this software without specific prior written
                permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS AND CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>

            <p className="center">*   *   *</p>

            <p>
              The complete list of contributors can be found at:
              https://github.com/hueniverse/sntp/graphs/contributors
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>source-map@0.4.4 source-map@0.5.7 source-map@0.6.1</strong>
              {' '}
              https://github.com/mozilla/source-map
              <br />
              Copyright (c) 2009-2011, Mozilla Foundation and contributors
              <br />
              All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright notice, this
                list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright notice,
                this list of conditions and the following disclaimer in the documentation
                and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the names of the Mozilla Foundation nor the names of project
                contributors may be used to endorse or promote products derived from this
                software without specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
              FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
              DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
              SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
              CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
              OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
              OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>sprintf-js@1.0.3 sprintf-js@1.1.1</strong>
              {' '}
              https://github.com/alexei/sprintf.js
              <br />
              Copyright (c) 2007-present, Alexandru Mărășteanu &lt;hello@alexei.ro&gt;
              <br />
              All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of this software nor the names of its contributors may be
                used to endorse or promote products derived from this software without
                specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR
              ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>table@3.8.3 table@4.0.2</strong>
              {' '}
              https://github.com/gajus/table
              <br />
              Copyright (c) 2016, Gajus Kuizinas (http://gajus.com/)
              <br />
              All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                Neither the name of the Gajus Kuizinas (http://gajus.com/) nor the
                names of its contributors may be used to endorse or promote products
                derived from this software without specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL ANUARY BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>teamwork@3.0.1</strong>
              {' '}
              https://github.com/hueniverse/teamwork
              <br />
              Copyright (c) 2015-2017, Eran Hammer and Project contributors
              <br />
              All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                The names of any contributors may not be used to endorse or promote
                products derived from this software without specific prior written
                permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS AND CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>

            <p className="center">*   *   *</p>

            <p>
              The complete list of contributors can be found at:
              https://github.com/hueniverse/teamwork/graphs/contributors
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>tough-cookie@2.3.2 tough-cookie@2.3.3</strong>
              {' '}
              https://github.com/salesforce/tough-cookie
              <br />
              Copyright (c) 2015, Salesforce.com, Inc.
              <br />
              All rights reserved.
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              Redistribution and use in source and binary forms, with or without
              modification, are permitted provided that the following conditions are met:
            </p>
            <ul>
              <li>
                Redistributions of source code must retain the above copyright
                notice, this list of conditions and the following disclaimer.
              </li>
              <li>
                Redistributions in binary form must reproduce the above copyright
                notice, this list of conditions and the following disclaimer in the
                documentation and/or other materials provided with the distribution.
              </li>
              <li>
                The names Salesforce.com nor the names of its contributors
                may not be used to endorse or promote products derived from this
                software without specific prior written permission.
              </li>
            </ul>
            <p>
              THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
              ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
              WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
              DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDERS AND CONTRIBUTORS BE LIABLE FOR ANY
              DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
              (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
              LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
              ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
              (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
              SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
            </p>
          </div>
        </div>

        <div className="aa-attribution-license-container">
          <p><strong>The Amazon Author product also includes the following third-party software/licensing:</strong></p>
          <ul className="aa-attribution-license-packages">
            <li>
              <strong>uws@0.14.5</strong>
              {' '}
              https://github.com/uWebSockets/uWebSockets
              <br />
              Copyright (c) 2016 Alex Hultman and contributors
            </li>
          </ul>
          <div className="aa-attribution-license-text">
            <p>
              This software is provided 'as-is', without any express or implied
              warranty. In no event will the authors be held liable for any damages
              arising from the use of this software.
            </p>

            <p>
              Permission is granted to anyone to use this software for any purpose,
              including commercial applications, and to alter it and redistribute it
              freely, subject to the following restrictions:
            </p>
            <ol>
              <li>
                The origin of this software must not be misrepresented; you must not
                claim that you wrote the original software. If you use this software
                in a product, an acknowledgement in the product documentation would be
                appreciated but is not required.
              </li>
              <li>
                Altered source versions must be plainly marked as such, and must not be
                misrepresented as being the original software.
              </li>
              <li>This notice may not be removed or altered from any source distribution.</li>
            </ol>
          </div>
        </div>
      </div>
    );
  }
}

export default Attribution;
